var map = {
	"./ABCIcon": 579499,
	"./AboutCircleIcon": 35701,
	"./AboutCircleOutlineIcon": 865379,
	"./AboutIcon": 620903,
	"./AboutOutlineIcon": 186470,
	"./AboutVariantIcon": 95383,
	"./AcUnitIcon": 68972,
	"./AcademicCapIcon": 117711,
	"./AccelerometerIcon": 843785,
	"./AccessAlarmsIcon": 41461,
	"./AccessPointIcon": 842566,
	"./AccessPointNetworkIcon": 742373,
	"./AccessPointNetworkOffIcon": 509049,
	"./AccessTimeIcon": 78428,
	"./AccessibilityIcon": 187019,
	"./AccessibleIcon": 903201,
	"./AccountAddIcon": 974827,
	"./AccountAddOutlineIcon": 813936,
	"./AccountAlertIcon": 243999,
	"./AccountAlertOutlineIcon": 425845,
	"./AccountArrowLeftIcon": 209138,
	"./AccountArrowLeftOutlineIcon": 598097,
	"./AccountArrowRightIcon": 138886,
	"./AccountArrowRightOutlineIcon": 897911,
	"./AccountBadgeAlertIcon": 763386,
	"./AccountBadgeAlertOutlineIcon": 389126,
	"./AccountBadgeHorizontalIcon": 867808,
	"./AccountBadgeHorizontalOutlineIcon": 269842,
	"./AccountBadgeIcon": 681376,
	"./AccountBadgeOutlineIcon": 637781,
	"./AccountBalanceIcon": 236514,
	"./AccountBalanceWalletIcon": 855908,
	"./AccountBalanceWalletOutlineIcon": 570794,
	"./AccountBoxIcon": 439911,
	"./AccountBoxMultipleIcon": 567261,
	"./AccountBoxOutlineIcon": 230807,
	"./AccountCardDetailsIcon": 690683,
	"./AccountCardDetailsOutlineIcon": 550150,
	"./AccountCheckIcon": 742929,
	"./AccountCheckOutlineIcon": 250063,
	"./AccountChildCircleIcon": 816308,
	"./AccountChildIcon": 122125,
	"./AccountCircleIcon": 22156,
	"./AccountCircleOutlineIcon": 684601,
	"./AccountClockIcon": 322834,
	"./AccountClockOutlineIcon": 806266,
	"./AccountConvertIcon": 171051,
	"./AccountDetailsIcon": 486238,
	"./AccountEditIcon": 409321,
	"./AccountGroupIcon": 263417,
	"./AccountGroupOutlineIcon": 23697,
	"./AccountHeartIcon": 420172,
	"./AccountHeartOutlineIcon": 111551,
	"./AccountHelpIcon": 340783,
	"./AccountHelpOutlineIcon": 563817,
	"./AccountIcon": 30354,
	"./AccountKeyIcon": 957671,
	"./AccountKeyOutlineIcon": 738632,
	"./AccountLocationIcon": 782494,
	"./AccountMinusIcon": 222387,
	"./AccountMinusOutlineIcon": 741599,
	"./AccountMultipleAddIcon": 443403,
	"./AccountMultipleAddOutlineIcon": 300225,
	"./AccountMultipleCheckIcon": 918159,
	"./AccountMultipleIcon": 716450,
	"./AccountMultipleMinusIcon": 166130,
	"./AccountMultipleMinusOutlineIcon": 290379,
	"./AccountMultipleOutlineIcon": 607771,
	"./AccountMultiplePlusIcon": 671977,
	"./AccountMultiplePlusOutlineIcon": 398101,
	"./AccountMultipleTickIcon": 471564,
	"./AccountNetworkIcon": 816068,
	"./AccountNetworkOutlineIcon": 658970,
	"./AccountOffIcon": 801375,
	"./AccountOffOutlineIcon": 349570,
	"./AccountOutlineIcon": 693348,
	"./AccountPendingIcon": 76239,
	"./AccountPendingOutlineIcon": 728174,
	"./AccountPlusIcon": 701022,
	"./AccountPlusOutlineIcon": 878827,
	"./AccountQuestionIcon": 591174,
	"./AccountQuestionMarkIcon": 118959,
	"./AccountQuestionMarkOutlineIcon": 414323,
	"./AccountQuestionOutlineIcon": 646940,
	"./AccountRemoveIcon": 798172,
	"./AccountRemoveOutlineIcon": 766204,
	"./AccountSearchIcon": 672838,
	"./AccountSearchOutlineIcon": 864792,
	"./AccountSettingsIcon": 702255,
	"./AccountStarIcon": 974414,
	"./AccountStarOutlineIcon": 563353,
	"./AccountSupervisorCircleIcon": 422724,
	"./AccountSupervisorIcon": 610342,
	"./AccountSwitchIcon": 974610,
	"./AccountTieIcon": 840953,
	"./AccountsAddIcon": 555991,
	"./AccountsAddOutlineIcon": 90487,
	"./AccountsCheckIcon": 257746,
	"./AccountsGroupIcon": 580589,
	"./AccountsGroupOutlineIcon": 615284,
	"./AccountsIcon": 794133,
	"./AccountsMinusIcon": 344076,
	"./AccountsMinusOutlineIcon": 149024,
	"./AccountsOutlineIcon": 627721,
	"./AccountsPlusIcon": 134740,
	"./AccountsPlusOutlineIcon": 510044,
	"./AccountsSwitchIcon": 897947,
	"./AccountsTickIcon": 800701,
	"./AccusoftIcon": 455208,
	"./AchievementAwardIcon": 120224,
	"./AchievementIcon": 715783,
	"./AchievementOutlineIcon": 523054,
	"./AchievementVariantIcon": 225369,
	"./AchievementVariantOutlineIcon": 469476,
	"./AdbIcon": 629120,
	"./AdchoicesIcon": 581441,
	"./AddAlarmIcon": 923653,
	"./AddAlertIcon": 946884,
	"./AddAlertOutlineIcon": 600363,
	"./AddBoxIcon": 473701,
	"./AddCallIcon": 161354,
	"./AddCircleIcon": 867510,
	"./AddCircleOutlineIcon": 729144,
	"./AddIcon": 801013,
	"./AddLocationIcon": 669940,
	"./AddNetworkIcon": 942705,
	"./AddNetworkOutlineIcon": 421772,
	"./AddShoppingCartIcon": 333476,
	"./AddToPhotosIcon": 894943,
	"./AddressMarkerIcon": 806285,
	"./AdjustIcon": 692775,
	"./AdobeIcon": 682456,
	"./AedIcon": 995505,
	"./AeroplaneIcon": 583355,
	"./AeroplaneLandingIcon": 767450,
	"./AeroplaneOffIcon": 843912,
	"./AeroplaneTakeoffIcon": 36192,
	"./AerosolIcon": 652128,
	"./AirConditionerIcon": 241450,
	"./AirFilterIcon": 830191,
	"./AirHornIcon": 768721,
	"./AirPurifierIcon": 475917,
	"./AirbagIcon": 719139,
	"./AirballoonIcon": 513706,
	"./AirlineSeatFlatAngledIcon": 709437,
	"./AirlineSeatFlatIcon": 341301,
	"./AirlineSeatIndividualSuiteIcon": 225607,
	"./AirlineSeatLegroomExtraIcon": 102503,
	"./AirlineSeatLegroomNormalIcon": 409761,
	"./AirlineSeatLegroomReducedIcon": 987193,
	"./AirlineSeatReclineExtraIcon": 644846,
	"./AirlineSeatReclineNormalIcon": 734661,
	"./AirplaneIcon": 415804,
	"./AirplaneLandingIcon": 115270,
	"./AirplaneOffIcon": 617698,
	"./AirplaneTakeoffIcon": 787963,
	"./AirplanemodeActiveIcon": 870287,
	"./AirplanemodeInactiveIcon": 689716,
	"./AirplayIcon": 408313,
	"./AirportIcon": 593491,
	"./AlarmAddIcon": 334247,
	"./AlarmBellIcon": 805478,
	"./AlarmCheckIcon": 35194,
	"./AlarmClockAddIcon": 666384,
	"./AlarmClockCheckIcon": 647376,
	"./AlarmClockIcon": 234593,
	"./AlarmClockMultipleIcon": 30968,
	"./AlarmClockOffIcon": 974970,
	"./AlarmClockPlusIcon": 740991,
	"./AlarmClockSnoozeIcon": 325043,
	"./AlarmClockTickIcon": 928081,
	"./AlarmClocksIcon": 981980,
	"./AlarmIcon": 473682,
	"./AlarmLightIcon": 298752,
	"./AlarmLightOutlineIcon": 206089,
	"./AlarmMultipleIcon": 945000,
	"./AlarmNoteIcon": 968762,
	"./AlarmNoteOffIcon": 921188,
	"./AlarmOffIcon": 986953,
	"./AlarmOnIcon": 264954,
	"./AlarmPlusIcon": 989491,
	"./AlarmSnoozeIcon": 502248,
	"./AlarmTickIcon": 587499,
	"./AlarmsIcon": 176300,
	"./AlbumIcon": 278914,
	"./AlertBoxIcon": 882225,
	"./AlertBoxOutlineIcon": 938713,
	"./AlertCircleIcon": 585316,
	"./AlertCircleOutlineIcon": 497857,
	"./AlertDecagramIcon": 550450,
	"./AlertDecagramOutlineIcon": 582446,
	"./AlertIcon": 81565,
	"./AlertOctagonIcon": 511931,
	"./AlertOctagonOutlineIcon": 902326,
	"./AlertOctagramIcon": 98957,
	"./AlertOctagramOutlineIcon": 283561,
	"./AlertOutlineIcon": 826891,
	"./AlienIcon": 731823,
	"./AllInclusiveIcon": 336262,
	"./AlphaABoxIcon": 633603,
	"./AlphaABoxOutlineIcon": 392887,
	"./AlphaACircleIcon": 684154,
	"./AlphaACircleOutlineIcon": 27986,
	"./AlphaAIcon": 447233,
	"./AlphaBBoxIcon": 101565,
	"./AlphaBBoxOutlineIcon": 214584,
	"./AlphaBCircleIcon": 270369,
	"./AlphaBCircleOutlineIcon": 586427,
	"./AlphaBIcon": 581031,
	"./AlphaCBoxIcon": 64623,
	"./AlphaCBoxOutlineIcon": 295282,
	"./AlphaCCircleIcon": 509423,
	"./AlphaCCircleOutlineIcon": 47444,
	"./AlphaCIcon": 639898,
	"./AlphaDBoxIcon": 450042,
	"./AlphaDBoxOutlineIcon": 668395,
	"./AlphaDCircleIcon": 190349,
	"./AlphaDCircleOutlineIcon": 129351,
	"./AlphaDIcon": 731356,
	"./AlphaEBoxIcon": 440574,
	"./AlphaEBoxOutlineIcon": 763137,
	"./AlphaECircleIcon": 920541,
	"./AlphaECircleOutlineIcon": 193358,
	"./AlphaEIcon": 71869,
	"./AlphaFBoxIcon": 739013,
	"./AlphaFBoxOutlineIcon": 714450,
	"./AlphaFCircleIcon": 169966,
	"./AlphaFCircleOutlineIcon": 990031,
	"./AlphaFIcon": 671465,
	"./AlphaGBoxIcon": 382922,
	"./AlphaGBoxOutlineIcon": 740674,
	"./AlphaGCircleIcon": 491133,
	"./AlphaGCircleOutlineIcon": 959478,
	"./AlphaGIcon": 304313,
	"./AlphaHBoxIcon": 91127,
	"./AlphaHBoxOutlineIcon": 444021,
	"./AlphaHCircleIcon": 584186,
	"./AlphaHCircleOutlineIcon": 60908,
	"./AlphaHIcon": 575579,
	"./AlphaIBoxIcon": 986666,
	"./AlphaIBoxOutlineIcon": 97319,
	"./AlphaICircleIcon": 552889,
	"./AlphaICircleOutlineIcon": 80575,
	"./AlphaIIcon": 341828,
	"./AlphaIcon": 141276,
	"./AlphaJBoxIcon": 147519,
	"./AlphaJBoxOutlineIcon": 673599,
	"./AlphaJCircleIcon": 592612,
	"./AlphaJCircleOutlineIcon": 819089,
	"./AlphaJIcon": 50223,
	"./AlphaKBoxIcon": 996779,
	"./AlphaKBoxOutlineIcon": 328321,
	"./AlphaKCircleIcon": 716193,
	"./AlphaKCircleOutlineIcon": 289979,
	"./AlphaKIcon": 433883,
	"./AlphaLBoxIcon": 470823,
	"./AlphaLBoxOutlineIcon": 566066,
	"./AlphaLCircleIcon": 985876,
	"./AlphaLCircleOutlineIcon": 677063,
	"./AlphaLIcon": 953063,
	"./AlphaMBoxIcon": 732619,
	"./AlphaMBoxOutlineIcon": 756867,
	"./AlphaMCircleIcon": 37553,
	"./AlphaMCircleOutlineIcon": 158239,
	"./AlphaMIcon": 169579,
	"./AlphaNBoxIcon": 681596,
	"./AlphaNBoxOutlineIcon": 254251,
	"./AlphaNCircleIcon": 902461,
	"./AlphaNCircleOutlineIcon": 847381,
	"./AlphaNIcon": 786507,
	"./AlphaOBoxIcon": 665949,
	"./AlphaOBoxOutlineIcon": 129060,
	"./AlphaOCircleIcon": 66471,
	"./AlphaOCircleOutlineIcon": 478501,
	"./AlphaOIcon": 322611,
	"./AlphaPBoxIcon": 569533,
	"./AlphaPBoxOutlineIcon": 280105,
	"./AlphaPCircleIcon": 190008,
	"./AlphaPCircleOutlineIcon": 510475,
	"./AlphaPIcon": 794599,
	"./AlphaQBoxIcon": 581409,
	"./AlphaQBoxOutlineIcon": 818503,
	"./AlphaQCircleIcon": 757586,
	"./AlphaQCircleOutlineIcon": 720274,
	"./AlphaQIcon": 433483,
	"./AlphaRBoxIcon": 615135,
	"./AlphaRBoxOutlineIcon": 547410,
	"./AlphaRCircleIcon": 433083,
	"./AlphaRCircleOutlineIcon": 724846,
	"./AlphaRIcon": 333912,
	"./AlphaSBoxIcon": 960818,
	"./AlphaSBoxOutlineIcon": 157893,
	"./AlphaSCircleIcon": 353617,
	"./AlphaSCircleOutlineIcon": 890681,
	"./AlphaSIcon": 401521,
	"./AlphaTBoxIcon": 814643,
	"./AlphaTBoxOutlineIcon": 201990,
	"./AlphaTCircleIcon": 295509,
	"./AlphaTCircleOutlineIcon": 465108,
	"./AlphaTIcon": 843330,
	"./AlphaUBoxIcon": 193535,
	"./AlphaUBoxOutlineIcon": 174662,
	"./AlphaUCircleIcon": 955149,
	"./AlphaUCircleOutlineIcon": 96755,
	"./AlphaUIcon": 735759,
	"./AlphaVBoxIcon": 544690,
	"./AlphaVBoxOutlineIcon": 285777,
	"./AlphaVCircleIcon": 959103,
	"./AlphaVCircleOutlineIcon": 710134,
	"./AlphaVIcon": 237647,
	"./AlphaWBoxIcon": 304249,
	"./AlphaWBoxOutlineIcon": 58271,
	"./AlphaWCircleIcon": 878845,
	"./AlphaWCircleOutlineIcon": 642269,
	"./AlphaWIcon": 259037,
	"./AlphaXBoxIcon": 387466,
	"./AlphaXBoxOutlineIcon": 670220,
	"./AlphaXCircleIcon": 452621,
	"./AlphaXCircleOutlineIcon": 743510,
	"./AlphaXIcon": 44994,
	"./AlphaYBoxIcon": 300218,
	"./AlphaYBoxOutlineIcon": 417096,
	"./AlphaYCircleIcon": 766333,
	"./AlphaYCircleOutlineIcon": 903438,
	"./AlphaYIcon": 558982,
	"./AlphaZBoxIcon": 842554,
	"./AlphaZBoxOutlineIcon": 394622,
	"./AlphaZCircleIcon": 357747,
	"./AlphaZCircleOutlineIcon": 237117,
	"./AlphaZIcon": 780980,
	"./AlphabetABoxIcon": 69287,
	"./AlphabetABoxOutlineIcon": 925269,
	"./AlphabetACircleIcon": 214378,
	"./AlphabetACircleOutlineIcon": 757773,
	"./AlphabetAIcon": 123352,
	"./AlphabetBBoxIcon": 433032,
	"./AlphabetBBoxOutlineIcon": 22285,
	"./AlphabetBCircleIcon": 650683,
	"./AlphabetBCircleOutlineIcon": 656169,
	"./AlphabetBIcon": 994451,
	"./AlphabetCBoxIcon": 302862,
	"./AlphabetCBoxOutlineIcon": 869605,
	"./AlphabetCCircleIcon": 824944,
	"./AlphabetCCircleOutlineIcon": 199103,
	"./AlphabetCIcon": 130764,
	"./AlphabetDBoxIcon": 227046,
	"./AlphabetDBoxOutlineIcon": 614724,
	"./AlphabetDCircleIcon": 617980,
	"./AlphabetDCircleOutlineIcon": 450313,
	"./AlphabetDIcon": 603488,
	"./AlphabetEBoxIcon": 305352,
	"./AlphabetEBoxOutlineIcon": 320524,
	"./AlphabetECircleIcon": 490370,
	"./AlphabetECircleOutlineIcon": 303091,
	"./AlphabetEIcon": 935201,
	"./AlphabetFBoxIcon": 307203,
	"./AlphabetFBoxOutlineIcon": 109687,
	"./AlphabetFCircleIcon": 93586,
	"./AlphabetFCircleOutlineIcon": 740083,
	"./AlphabetFIcon": 983363,
	"./AlphabetGBoxIcon": 200100,
	"./AlphabetGBoxOutlineIcon": 85652,
	"./AlphabetGCircleIcon": 186782,
	"./AlphabetGCircleOutlineIcon": 402463,
	"./AlphabetGIcon": 989963,
	"./AlphabetHBoxIcon": 369128,
	"./AlphabetHBoxOutlineIcon": 528777,
	"./AlphabetHCircleIcon": 465680,
	"./AlphabetHCircleOutlineIcon": 722999,
	"./AlphabetHIcon": 61404,
	"./AlphabetIBoxIcon": 322352,
	"./AlphabetIBoxOutlineIcon": 824559,
	"./AlphabetICircleIcon": 354740,
	"./AlphabetICircleOutlineIcon": 127276,
	"./AlphabetIIcon": 9558,
	"./AlphabetJBoxIcon": 912403,
	"./AlphabetJBoxOutlineIcon": 782692,
	"./AlphabetJCircleIcon": 222605,
	"./AlphabetJCircleOutlineIcon": 246024,
	"./AlphabetJIcon": 555438,
	"./AlphabetKBoxIcon": 504430,
	"./AlphabetKBoxOutlineIcon": 66989,
	"./AlphabetKCircleIcon": 754397,
	"./AlphabetKCircleOutlineIcon": 944605,
	"./AlphabetKIcon": 105985,
	"./AlphabetLBoxIcon": 211966,
	"./AlphabetLBoxOutlineIcon": 543826,
	"./AlphabetLCircleIcon": 731438,
	"./AlphabetLCircleOutlineIcon": 715792,
	"./AlphabetLIcon": 396940,
	"./AlphabetMBoxIcon": 98305,
	"./AlphabetMBoxOutlineIcon": 142054,
	"./AlphabetMCircleIcon": 362124,
	"./AlphabetMCircleOutlineIcon": 29353,
	"./AlphabetMIcon": 753097,
	"./AlphabetNBoxIcon": 537700,
	"./AlphabetNBoxOutlineIcon": 946976,
	"./AlphabetNCircleIcon": 374882,
	"./AlphabetNCircleOutlineIcon": 759196,
	"./AlphabetNIcon": 835013,
	"./AlphabetOBoxIcon": 953183,
	"./AlphabetOBoxOutlineIcon": 587856,
	"./AlphabetOCircleIcon": 23149,
	"./AlphabetOCircleOutlineIcon": 462951,
	"./AlphabetOIcon": 581746,
	"./AlphabetPBoxIcon": 330388,
	"./AlphabetPBoxOutlineIcon": 239462,
	"./AlphabetPCircleIcon": 775142,
	"./AlphabetPCircleOutlineIcon": 807355,
	"./AlphabetPIcon": 704559,
	"./AlphabetQBoxIcon": 757702,
	"./AlphabetQBoxOutlineIcon": 18868,
	"./AlphabetQCircleIcon": 983948,
	"./AlphabetQCircleOutlineIcon": 812667,
	"./AlphabetQIcon": 3373,
	"./AlphabetRBoxIcon": 281410,
	"./AlphabetRBoxOutlineIcon": 452453,
	"./AlphabetRCircleIcon": 757606,
	"./AlphabetRCircleOutlineIcon": 245092,
	"./AlphabetRIcon": 877265,
	"./AlphabetSBoxIcon": 159911,
	"./AlphabetSBoxOutlineIcon": 90662,
	"./AlphabetSCircleIcon": 475522,
	"./AlphabetSCircleOutlineIcon": 691516,
	"./AlphabetSIcon": 955622,
	"./AlphabetTBoxIcon": 777681,
	"./AlphabetTBoxOutlineIcon": 166724,
	"./AlphabetTCircleIcon": 797145,
	"./AlphabetTCircleOutlineIcon": 930117,
	"./AlphabetTIcon": 479609,
	"./AlphabetUBoxIcon": 695852,
	"./AlphabetUBoxOutlineIcon": 137804,
	"./AlphabetUCircleIcon": 752315,
	"./AlphabetUCircleOutlineIcon": 294915,
	"./AlphabetUIcon": 316,
	"./AlphabetVBoxIcon": 788393,
	"./AlphabetVBoxOutlineIcon": 376304,
	"./AlphabetVCircleIcon": 392196,
	"./AlphabetVCircleOutlineIcon": 376827,
	"./AlphabetVIcon": 172089,
	"./AlphabetWBoxIcon": 511630,
	"./AlphabetWBoxOutlineIcon": 410166,
	"./AlphabetWCircleIcon": 431885,
	"./AlphabetWCircleOutlineIcon": 153722,
	"./AlphabetWIcon": 644207,
	"./AlphabetXBoxIcon": 366953,
	"./AlphabetXBoxOutlineIcon": 700624,
	"./AlphabetXCircleIcon": 321978,
	"./AlphabetXCircleOutlineIcon": 939683,
	"./AlphabetXIcon": 419049,
	"./AlphabetYBoxIcon": 321264,
	"./AlphabetYBoxOutlineIcon": 233154,
	"./AlphabetYCircleIcon": 711676,
	"./AlphabetYCircleOutlineIcon": 844865,
	"./AlphabetYIcon": 293640,
	"./AlphabetZBoxIcon": 651941,
	"./AlphabetZBoxOutlineIcon": 732030,
	"./AlphabetZCircleIcon": 78305,
	"./AlphabetZCircleOutlineIcon": 111936,
	"./AlphabetZIcon": 988175,
	"./AlphabeticalIcon": 730109,
	"./AlternateEmailIcon": 525218,
	"./AlternatingCurrentIcon": 660074,
	"./AltimeterIcon": 200601,
	"./AmazonAlexaIcon": 51070,
	"./AmazonClouddriveIcon": 798383,
	"./AmazonDriveIcon": 400257,
	"./AmazonIcon": 879381,
	"./AmbulanceIcon": 512392,
	"./AmmunitionIcon": 898281,
	"./AmpIcon": 261773,
	"./AmpersandIcon": 367604,
	"./AmplifierIcon": 372340,
	"./AnchorIcon": 725219,
	"./AndIcon": 828515,
	"./AndroidAutoIcon": 626033,
	"./AndroidDebugBridgeIcon": 538185,
	"./AndroidHeadIcon": 962486,
	"./AndroidIcon": 32344,
	"./AndroidMessagesIcon": 784511,
	"./AndroidStudioIcon": 512459,
	"./AngleAcuteIcon": 556753,
	"./AngleObtuseIcon": 786970,
	"./AngleRightIcon": 372408,
	"./AngularIcon": 631434,
	"./AngularjsIcon": 757239,
	"./AnimationIcon": 329853,
	"./AnimationMinusIcon": 185668,
	"./AnimationMinusOutlineIcon": 233187,
	"./AnimationOutlineIcon": 716127,
	"./AnimationPlayIcon": 398342,
	"./AnimationPlayOutlineIcon": 8253,
	"./AnimationPlusIcon": 164623,
	"./AnimationPlusOutlineIcon": 668283,
	"./AnnouncementIcon": 225615,
	"./AnnouncementOutlineIcon": 479384,
	"./AnonymousIcon": 551028,
	"./AntiLockBrakeSystemIcon": 75626,
	"./AntiLockBrakingSystemIcon": 521952,
	"./AnvilIcon": 616599,
	"./AppleFinderIcon": 759353,
	"./AppleIcloudIcon": 790881,
	"./AppleIcon": 941135,
	"./AppleIosIcon": 515502,
	"./AppleIpodIcon": 959951,
	"./AppleKeyboardCapsIcon": 21475,
	"./AppleKeyboardCommandIcon": 160903,
	"./AppleKeyboardControlIcon": 707950,
	"./AppleKeyboardOptionIcon": 905235,
	"./AppleKeyboardShiftIcon": 1567,
	"./AppleMobilemeIcon": 896369,
	"./AppleSafariIcon": 904617,
	"./ApplicationExportIcon": 585823,
	"./ApplicationIcon": 558639,
	"./ApplicationImportIcon": 554839,
	"./ApprovalIcon": 740902,
	"./ApproveIcon": 545833,
	"./AppsBoxIcon": 248989,
	"./AppsIcon": 900449,
	"./AquariumIcon": 862322,
	"./AquariumOutlineIcon": 871860,
	"./ArchIcon": 558343,
	"./ArchitectureIcon": 129826,
	"./ArchiveIcon": 848329,
	"./ArenaIcon": 956894,
	"./ArmBarrierAlertIcon": 100165,
	"./ArmBarrierAlertOutlineIcon": 67919,
	"./ArmBarrierDownIcon": 299746,
	"./ArmBarrierDownOutlineIcon": 94877,
	"./ArmBarrierIcon": 430755,
	"./ArmBarrierOutlineIcon": 130740,
	"./ArmBarrierUpIcon": 213274,
	"./ArmBarrierUpOutlineIcon": 148091,
	"./ArrangeBringForwardIcon": 962680,
	"./ArrangeBringToFrontIcon": 543808,
	"./ArrangeSendBackwardIcon": 358618,
	"./ArrangeSendToBackIcon": 944578,
	"./ArrowAllIcon": 753150,
	"./ArrowBackCircleIcon": 641088,
	"./ArrowBackIcon": 386195,
	"./ArrowBottomBoldBoxIcon": 454687,
	"./ArrowBottomBoldBoxOutlineIcon": 713474,
	"./ArrowBottomBoldCircleIcon": 768033,
	"./ArrowBottomBoldCircleOutlineIcon": 351325,
	"./ArrowBottomBoldHexagonOutlineIcon": 974962,
	"./ArrowBottomBoldIcon": 563145,
	"./ArrowBottomBoldOutlineIcon": 865532,
	"./ArrowBottomBoxIcon": 863671,
	"./ArrowBottomCircleIcon": 170519,
	"./ArrowBottomCircleOutlineIcon": 256944,
	"./ArrowBottomDropCircleIcon": 962802,
	"./ArrowBottomDropCircleOutlineIcon": 649906,
	"./ArrowBottomIcon": 103148,
	"./ArrowBottomLeftBoldOutlineIcon": 824398,
	"./ArrowBottomLeftIcon": 786393,
	"./ArrowBottomLeftThickIcon": 133542,
	"./ArrowBottomRightBoldOutlineIcon": 100885,
	"./ArrowBottomRightIcon": 306948,
	"./ArrowBottomRightThickIcon": 341882,
	"./ArrowBottomThickIcon": 453822,
	"./ArrowCollapseAllIcon": 910713,
	"./ArrowCollapseDownIcon": 11842,
	"./ArrowCollapseHorizontalIcon": 561864,
	"./ArrowCollapseIcon": 518031,
	"./ArrowCollapseLeftIcon": 785260,
	"./ArrowCollapseRightIcon": 772948,
	"./ArrowCollapseUpIcon": 354113,
	"./ArrowCollapseVerticalIcon": 116959,
	"./ArrowCompassIcon": 103459,
	"./ArrowCompressAllIcon": 267561,
	"./ArrowCompressDownIcon": 194399,
	"./ArrowCompressIcon": 290625,
	"./ArrowCompressLeftIcon": 875775,
	"./ArrowCompressRightIcon": 4331,
	"./ArrowCompressUpIcon": 926567,
	"./ArrowDecisionAutoIcon": 914936,
	"./ArrowDecisionAutoOutlineIcon": 932317,
	"./ArrowDecisionIcon": 822766,
	"./ArrowDecisionOutlineIcon": 53247,
	"./ArrowDownBoldBoxIcon": 906855,
	"./ArrowDownBoldBoxOutlineIcon": 223374,
	"./ArrowDownBoldCircleIcon": 487957,
	"./ArrowDownBoldCircleOutlineIcon": 505306,
	"./ArrowDownBoldHexagonOutlineIcon": 638019,
	"./ArrowDownBoldIcon": 471967,
	"./ArrowDownBoldOutlineIcon": 692690,
	"./ArrowDownBoxIcon": 641788,
	"./ArrowDownCircleIcon": 20027,
	"./ArrowDownCircleOutlineIcon": 557065,
	"./ArrowDownDropCircleIcon": 965757,
	"./ArrowDownDropCircleOutlineIcon": 410032,
	"./ArrowDownIcon": 764553,
	"./ArrowDownLeftBoldOutlineIcon": 455033,
	"./ArrowDownLeftIcon": 309990,
	"./ArrowDownLeftThickIcon": 307538,
	"./ArrowDownRightBoldOutlineIcon": 787076,
	"./ArrowDownRightIcon": 596658,
	"./ArrowDownRightThickIcon": 187992,
	"./ArrowDownThickIcon": 538082,
	"./ArrowDownwardIcon": 243121,
	"./ArrowDropDownCircleIcon": 687738,
	"./ArrowDropDownIcon": 415816,
	"./ArrowDropUpIcon": 482195,
	"./ArrowExpandAllIcon": 334455,
	"./ArrowExpandDownIcon": 712597,
	"./ArrowExpandHorizontalIcon": 933594,
	"./ArrowExpandIcon": 750589,
	"./ArrowExpandLeftIcon": 722557,
	"./ArrowExpandRightIcon": 79084,
	"./ArrowExpandUpIcon": 99261,
	"./ArrowExpandVerticalIcon": 530509,
	"./ArrowForwardCircleIcon": 421351,
	"./ArrowForwardIcon": 698946,
	"./ArrowIcon": 40062,
	"./ArrowLeftBoldBoxIcon": 598168,
	"./ArrowLeftBoldBoxOutlineIcon": 900932,
	"./ArrowLeftBoldCircleIcon": 369263,
	"./ArrowLeftBoldCircleOutlineIcon": 46406,
	"./ArrowLeftBoldHexagonOutlineIcon": 477993,
	"./ArrowLeftBoldIcon": 470078,
	"./ArrowLeftBoldOutlineIcon": 304862,
	"./ArrowLeftBoxIcon": 486191,
	"./ArrowLeftCircleIcon": 309661,
	"./ArrowLeftCircleOutlineIcon": 193627,
	"./ArrowLeftDropCircleIcon": 488083,
	"./ArrowLeftDropCircleOutlineIcon": 80260,
	"./ArrowLeftIcon": 800525,
	"./ArrowLeftRightBoldIcon": 396796,
	"./ArrowLeftRightBoldOutlineIcon": 687990,
	"./ArrowLeftRightIcon": 585698,
	"./ArrowLeftThickIcon": 118778,
	"./ArrowRightBoldBoxIcon": 960356,
	"./ArrowRightBoldBoxOutlineIcon": 359523,
	"./ArrowRightBoldCircleIcon": 524338,
	"./ArrowRightBoldCircleOutlineIcon": 666395,
	"./ArrowRightBoldHexagonOutlineIcon": 488583,
	"./ArrowRightBoldIcon": 29661,
	"./ArrowRightBoldOutlineIcon": 933797,
	"./ArrowRightBoxIcon": 902373,
	"./ArrowRightCircleIcon": 726607,
	"./ArrowRightCircleOutlineIcon": 583335,
	"./ArrowRightDropCircleIcon": 547291,
	"./ArrowRightDropCircleOutlineIcon": 139755,
	"./ArrowRightIcon": 445635,
	"./ArrowRightThickIcon": 985805,
	"./ArrowRotateLeftIcon": 626166,
	"./ArrowRotateRightIcon": 993193,
	"./ArrowSplitHorizontalIcon": 821770,
	"./ArrowSplitVerticalIcon": 192415,
	"./ArrowTopBoldBoxIcon": 115381,
	"./ArrowTopBoldBoxOutlineIcon": 685782,
	"./ArrowTopBoldCircleIcon": 105346,
	"./ArrowTopBoldCircleOutlineIcon": 643013,
	"./ArrowTopBoldHexagonOutlineIcon": 170076,
	"./ArrowTopBoldIcon": 40571,
	"./ArrowTopBoldOutlineIcon": 352796,
	"./ArrowTopCircleIcon": 843441,
	"./ArrowTopCircleOutlineIcon": 850853,
	"./ArrowTopDropCircleIcon": 972362,
	"./ArrowTopDropCircleOutlineIcon": 228606,
	"./ArrowTopIcon": 997497,
	"./ArrowTopLeftBoldOutlineIcon": 738754,
	"./ArrowTopLeftBottomRightBoldIcon": 595150,
	"./ArrowTopLeftBottomRightIcon": 253158,
	"./ArrowTopLeftIcon": 571827,
	"./ArrowTopLeftThickIcon": 616782,
	"./ArrowTopRightBoldOutlineIcon": 997769,
	"./ArrowTopRightBottomLeftBoldIcon": 651187,
	"./ArrowTopRightBottomLeftIcon": 4528,
	"./ArrowTopRightIcon": 224130,
	"./ArrowTopRightThickIcon": 73544,
	"./ArrowTopThickIcon": 441630,
	"./ArrowUpBoldBoxIcon": 315538,
	"./ArrowUpBoldBoxOutlineIcon": 748152,
	"./ArrowUpBoldCircleIcon": 56572,
	"./ArrowUpBoldCircleOutlineIcon": 637788,
	"./ArrowUpBoldHexagonOutlineIcon": 370626,
	"./ArrowUpBoldIcon": 805057,
	"./ArrowUpBoldOutlineIcon": 850691,
	"./ArrowUpBoxIcon": 84092,
	"./ArrowUpCircleIcon": 440694,
	"./ArrowUpCircleOutlineIcon": 848341,
	"./ArrowUpDownBoldIcon": 990470,
	"./ArrowUpDownBoldOutlineIcon": 191528,
	"./ArrowUpDownIcon": 503881,
	"./ArrowUpDropCircleIcon": 835572,
	"./ArrowUpDropCircleOutlineIcon": 224344,
	"./ArrowUpIcon": 148399,
	"./ArrowUpLeftBoldOutlineIcon": 250152,
	"./ArrowUpLeftIcon": 696964,
	"./ArrowUpLeftThickIcon": 349692,
	"./ArrowUpRightBoldOutlineIcon": 369709,
	"./ArrowUpRightIcon": 289672,
	"./ArrowUpRightThickIcon": 440854,
	"./ArrowUpThickIcon": 926720,
	"./ArrowUpwardIcon": 508029,
	"./ArtistIcon": 866367,
	"./ArtistOutlineIcon": 874592,
	"./ArtstationIcon": 148253,
	"./AspectRatioIcon": 49021,
	"./AssessmentIcon": 748859,
	"./AssignmentIcon": 931560,
	"./AssignmentIndIcon": 815265,
	"./AssignmentIndOutlineIcon": 720652,
	"./AssignmentLateIcon": 677638,
	"./AssignmentReturnIcon": 240976,
	"./AssignmentReturnedIcon": 347483,
	"./AssignmentReturnedOutlineIcon": 833823,
	"./AssignmentTurnedInIcon": 410946,
	"./AssistantIcon": 759164,
	"./AssistantPhotoIcon": 45583,
	"./AsteriskIcon": 761439,
	"./AtIcon": 267246,
	"./AtlassianIcon": 742115,
	"./AtmIcon": 439386,
	"./AtomIcon": 103299,
	"./AtomVariantIcon": 138648,
	"./AtomicBombIcon": 368685,
	"./AttachDriveIcon": 513236,
	"./AttachFileIcon": 810026,
	"./AttachMoneyIcon": 414282,
	"./AttachmentIcon": 425769,
	"./AttachmentVerticalIcon": 611430,
	"./AudioIcon": 459795,
	"./AudioOffIcon": 916682,
	"./AudioVideoIcon": 241022,
	"./AudiobookIcon": 413194,
	"./AugmentedRealityIcon": 531744,
	"./AutoAwesomeIcon": 605852,
	"./AutoAwesomeMosaicIcon": 655712,
	"./AutoAwesomeMotionIcon": 977012,
	"./AutoFixHighIcon": 746368,
	"./AutoFixIcon": 4610,
	"./AutoStoriesIcon": 230812,
	"./AutoTowingIcon": 880887,
	"./AutoUploadIcon": 697886,
	"./AutobahnIcon": 332155,
	"./AutomaticGateAlertIcon": 385639,
	"./AutomaticGateAlertOutlineIcon": 751803,
	"./AutomaticGateDownIcon": 397115,
	"./AutomaticGateDownOutlineIcon": 287971,
	"./AutomaticGateIcon": 485331,
	"./AutomaticGateOutlineIcon": 702194,
	"./AutomaticGateUpIcon": 945259,
	"./AutomaticGateUpOutlineIcon": 837223,
	"./AutorenewIcon": 953177,
	"./AvTimerIcon": 781226,
	"./AwardIcon": 429069,
	"./AwsIcon": 286646,
	"./AxeIcon": 862740,
	"./AxisArrowIcon": 694794,
	"./AxisArrowLockIcon": 156605,
	"./AxisIcon": 979791,
	"./AxisLockIcon": 737380,
	"./AxisXArrowIcon": 512758,
	"./AxisXArrowLockIcon": 536051,
	"./AxisXRotateClockwiseIcon": 499617,
	"./AxisXRotateCounterclockwiseIcon": 790501,
	"./AxisXYArrowLockIcon": 137022,
	"./AxisYArrowIcon": 20683,
	"./AxisYArrowLockIcon": 83378,
	"./AxisYRotateClockwiseIcon": 708644,
	"./AxisYRotateCounterclockwiseIcon": 34102,
	"./AxisZArrowIcon": 530609,
	"./AxisZArrowLockIcon": 727923,
	"./AxisZRotateClockwiseIcon": 554045,
	"./AxisZRotateCounterclockwiseIcon": 143001,
	"./AzureIcon": 740507,
	"./BabelIcon": 557668,
	"./BabyBottleIcon": 337645,
	"./BabyBottleOutlineIcon": 596003,
	"./BabyBuggyIcon": 490691,
	"./BabyFaceIcon": 590442,
	"./BabyFaceOutlineIcon": 823555,
	"./BabyIcon": 296088,
	"./BackburgerIcon": 693638,
	"./BackpackIcon": 242391,
	"./BackpackOffIcon": 202970,
	"./BackpackOffOutlineIcon": 103927,
	"./BackpackOutlineIcon": 365933,
	"./BackspaceIcon": 496700,
	"./BackspaceOutlineIcon": 59910,
	"./BackspaceReverseIcon": 562959,
	"./BackspaceReverseOutlineIcon": 446187,
	"./BackupIcon": 107203,
	"./BackupOutlineIcon": 688628,
	"./BackupRestoreIcon": 658424,
	"./BacteriaIcon": 125235,
	"./BacteriaOutlineIcon": 329387,
	"./BadmintonIcon": 155608,
	"./BagCarryOnCheckIcon": 279321,
	"./BagCarryOnIcon": 670843,
	"./BagCarryOnOffIcon": 118613,
	"./BagCheckedIcon": 785147,
	"./BagPersonalIcon": 649919,
	"./BagPersonalOffIcon": 297987,
	"./BagPersonalOffOutlineIcon": 595292,
	"./BagPersonalOutlineIcon": 729034,
	"./BaguetteIcon": 171260,
	"./BakeryIcon": 660182,
	"./BalloonIcon": 874397,
	"./BallotIcon": 413542,
	"./BallotOutlineIcon": 150402,
	"./BallotRecountIcon": 387712,
	"./BallotRecountOutlineIcon": 124465,
	"./BanIcon": 159025,
	"./BandAidIcon": 423621,
	"./BandageIcon": 996519,
	"./BandcampIcon": 374198,
	"./BangladeshiTakaIcon": 723506,
	"./BankAddIcon": 382703,
	"./BankIcon": 901716,
	"./BankMinusIcon": 791061,
	"./BankOutlineIcon": 863229,
	"./BankPlusIcon": 36020,
	"./BankRemoveIcon": 460908,
	"./BankTransferIcon": 571108,
	"./BankTransferInIcon": 943227,
	"./BankTransferOutIcon": 450957,
	"./BarChartIcon": 292300,
	"./BarbecueIcon": 60121,
	"./BarcodeIcon": 817244,
	"./BarcodeScanIcon": 977532,
	"./BarcodeScannerIcon": 456635,
	"./BarleyIcon": 404666,
	"./BarleyOffIcon": 47047,
	"./BarnIcon": 913145,
	"./BarometerIcon": 563466,
	"./BarrelIcon": 947040,
	"./BarrierAlertIcon": 467836,
	"./BarrierAlertOutlineIcon": 962065,
	"./BarrierDownIcon": 597218,
	"./BarrierDownOutlineIcon": 681219,
	"./BarrierIcon": 252828,
	"./BarrierOutlineIcon": 698513,
	"./BarrierUpIcon": 690921,
	"./BarrierUpOutlineIcon": 550110,
	"./BaseballBatIcon": 700528,
	"./BaseballIcon": 181890,
	"./BasecampIcon": 183989,
	"./BasketFillIcon": 158470,
	"./BasketIcon": 284365,
	"./BasketUnfillIcon": 482483,
	"./BasketballHoopIcon": 28280,
	"./BasketballHoopOutlineIcon": 104148,
	"./BasketballIcon": 920995,
	"./BatIcon": 184906,
	"./Battery0Icon": 539678,
	"./Battery100Icon": 845881,
	"./Battery10BluetoothIcon": 376977,
	"./Battery10Icon": 123363,
	"./Battery20BluetoothIcon": 37456,
	"./Battery20Icon": 50649,
	"./Battery30BluetoothIcon": 827626,
	"./Battery30Icon": 648188,
	"./Battery40BluetoothIcon": 160799,
	"./Battery40Icon": 160589,
	"./Battery50BluetoothIcon": 372806,
	"./Battery50Icon": 961720,
	"./Battery60BluetoothIcon": 939508,
	"./Battery60Icon": 414204,
	"./Battery70BluetoothIcon": 695345,
	"./Battery70Icon": 301867,
	"./Battery80BluetoothIcon": 570546,
	"./Battery80Icon": 248996,
	"./Battery90BluetoothIcon": 450631,
	"./Battery90Icon": 356047,
	"./BatteryAddIcon": 678083,
	"./BatteryAlertBluetoothIcon": 241222,
	"./BatteryAlertIcon": 510314,
	"./BatteryBluetooth100Icon": 482832,
	"./BatteryBluetoothFullIcon": 132084,
	"./BatteryBluetoothIcon": 23031,
	"./BatteryBluetoothVariantIcon": 886933,
	"./BatteryCharging100Icon": 286432,
	"./BatteryCharging10Icon": 204034,
	"./BatteryCharging20Icon": 252076,
	"./BatteryCharging30Icon": 49521,
	"./BatteryCharging40Icon": 281592,
	"./BatteryCharging50Icon": 783488,
	"./BatteryCharging60Icon": 903329,
	"./BatteryCharging70Icon": 57126,
	"./BatteryCharging80Icon": 22311,
	"./BatteryCharging90Icon": 692315,
	"./BatteryChargingFullIcon": 939263,
	"./BatteryChargingIcon": 434240,
	"./BatteryChargingOutlineIcon": 621047,
	"./BatteryChargingWireless0Icon": 115895,
	"./BatteryChargingWireless100Icon": 813401,
	"./BatteryChargingWireless10Icon": 595284,
	"./BatteryChargingWireless20Icon": 310150,
	"./BatteryChargingWireless30Icon": 401916,
	"./BatteryChargingWireless40Icon": 245685,
	"./BatteryChargingWireless50Icon": 795876,
	"./BatteryChargingWireless60Icon": 616405,
	"./BatteryChargingWireless70Icon": 562563,
	"./BatteryChargingWireless80Icon": 817714,
	"./BatteryChargingWireless90Icon": 496196,
	"./BatteryChargingWirelessAlertIcon": 316400,
	"./BatteryChargingWirelessEmptyIcon": 329487,
	"./BatteryChargingWirelessFullIcon": 764660,
	"./BatteryChargingWirelessIcon": 603290,
	"./BatteryChargingWirelessOutlineIcon": 1820,
	"./BatteryChargingWirelessWarningIcon": 104394,
	"./BatteryEmptyIcon": 444962,
	"./BatteryFullIcon": 186886,
	"./BatteryIcon": 710508,
	"./BatteryMinusIcon": 723041,
	"./BatteryNegativeIcon": 761263,
	"./BatteryOutlineIcon": 618104,
	"./BatteryPlusIcon": 327263,
	"./BatteryPositiveIcon": 925956,
	"./BatterySaverIcon": 244031,
	"./BatteryStdIcon": 115130,
	"./BatteryUnknownBluetoothIcon": 525745,
	"./BatteryUnknownIcon": 674454,
	"./BatteryWarningBluetoothIcon": 624816,
	"./BatteryWarningIcon": 8126,
	"./BattlenetIcon": 429595,
	"./BbqIcon": 370719,
	"./BeachIcon": 575270,
	"./BeaconIcon": 873306,
	"./BeakerIcon": 824028,
	"./BeakerOutlineIcon": 968189,
	"./BeatsIcon": 183783,
	"./BedEmptyIcon": 487196,
	"./BedIcon": 508782,
	"./BeenhereIcon": 115222,
	"./BeerIcon": 194550,
	"./BehanceIcon": 88066,
	"./BellAddIcon": 555342,
	"./BellAddOutlineIcon": 100220,
	"./BellAlertIcon": 624610,
	"./BellAlertOutlineIcon": 78542,
	"./BellCircleIcon": 289773,
	"./BellCircleOutlineIcon": 125760,
	"./BellIcon": 482815,
	"./BellOffIcon": 765882,
	"./BellOffOutlineIcon": 457251,
	"./BellOutlineIcon": 350784,
	"./BellPlusIcon": 432134,
	"./BellPlusOutlineIcon": 505302,
	"./BellRingIcon": 693436,
	"./BellRingOutlineIcon": 604037,
	"./BellSleepIcon": 915148,
	"./BellSleepOutlineIcon": 730447,
	"./BellWarningIcon": 944006,
	"./BetaIcon": 708259,
	"./BetamaxIcon": 441808,
	"./BezierIcon": 595529,
	"./BiathlonIcon": 146790,
	"./BibleIcon": 662771,
	"./BicycleIcon": 580483,
	"./BikeIcon": 410616,
	"./BilliardsIcon": 942139,
	"./BilliardsRackIcon": 948202,
	"./BilliardsTriangleIcon": 745965,
	"./BinCircleIcon": 621614,
	"./BinCircleOutlineIcon": 779247,
	"./BinEmptyIcon": 354019,
	"./BinIcon": 21603,
	"./BinOutlineIcon": 624749,
	"./BinRestoreIcon": 1987,
	"./BinVariantIcon": 216676,
	"./BingIcon": 559968,
	"./BinocularsIcon": 939625,
	"./BioIcon": 210235,
	"./BiohazardIcon": 539847,
	"./BiscuitIcon": 425670,
	"./BitbucketIcon": 211882,
	"./BitcoinIcon": 881629,
	"./BlackMesaIcon": 704864,
	"./BlackberryIcon": 435798,
	"./BlackboardIcon": 500204,
	"./BlenderIcon": 257201,
	"./BlenderSoftwareIcon": 158209,
	"./BlindsIcon": 265662,
	"./BlinkyIcon": 991146,
	"./BlockHelperIcon": 643294,
	"./BlockIcon": 922883,
	"./BloggerIcon": 451007,
	"./BloodBagIcon": 716312,
	"./BloodIcon": 623013,
	"./BloodOutlineIcon": 46902,
	"./BluetoothAudioIcon": 733969,
	"./BluetoothConnectIcon": 739777,
	"./BluetoothConnectedIcon": 780653,
	"./BluetoothDisabledIcon": 154187,
	"./BluetoothIcon": 969658,
	"./BluetoothOffIcon": 525109,
	"./BluetoothSearchingIcon": 294335,
	"./BluetoothSettingsIcon": 133848,
	"./BluetoothTransferIcon": 26297,
	"./BlurCircularIcon": 981818,
	"./BlurIcon": 768977,
	"./BlurLinearIcon": 125930,
	"./BlurOffIcon": 300660,
	"./BlurOnIcon": 619976,
	"./BlurRadialIcon": 816369,
	"./BoatIcon": 209405,
	"./BolnisiCrossIcon": 757047,
	"./BoltIcon": 677930,
	"./BombIcon": 368435,
	"./BombOffIcon": 451195,
	"./BoneIcon": 56960,
	"./BookAddIcon": 438858,
	"./BookIcon": 742458,
	"./BookLockIcon": 801357,
	"./BookLockOpenIcon": 885876,
	"./BookMinusIcon": 754676,
	"./BookMinusMultipleIcon": 132068,
	"./BookMultipleAddIcon": 911216,
	"./BookMultipleIcon": 85345,
	"./BookOpenIcon": 137071,
	"./BookOpenOutlineIcon": 363177,
	"./BookOpenPageVariantIcon": 955807,
	"./BookOpenVariantIcon": 886550,
	"./BookOutlineIcon": 774504,
	"./BookPlayIcon": 394679,
	"./BookPlayOutlineIcon": 942490,
	"./BookPlusIcon": 903408,
	"./BookPlusMultipleIcon": 840123,
	"./BookRemoveIcon": 597054,
	"./BookRemoveMultipleIcon": 660489,
	"./BookSearchIcon": 22888,
	"./BookSearchOutlineIcon": 403270,
	"./BookSecureIcon": 450315,
	"./BookUnsecureIcon": 113895,
	"./BookVariantIcon": 408682,
	"./BookVariantMultipleIcon": 409445,
	"./BookmarkAddIcon": 277624,
	"./BookmarkAddOutlineIcon": 14386,
	"./BookmarkBorderIcon": 995907,
	"./BookmarkCheckIcon": 488057,
	"./BookmarkIcon": 669918,
	"./BookmarkMinusIcon": 35751,
	"./BookmarkMinusOutlineIcon": 895702,
	"./BookmarkMultipleIcon": 450613,
	"./BookmarkMultipleOutlineIcon": 289429,
	"./BookmarkMusicIcon": 333595,
	"./BookmarkOffIcon": 10044,
	"./BookmarkOffOutlineIcon": 132896,
	"./BookmarkOutlineIcon": 326449,
	"./BookmarkPlusIcon": 331362,
	"./BookmarkPlusOutlineIcon": 754415,
	"./BookmarkRemoveIcon": 7266,
	"./BookmarkTickIcon": 753808,
	"./BooksAddIcon": 198417,
	"./BooksIcon": 72998,
	"./BooksMinusIcon": 544964,
	"./BooksPlusIcon": 99291,
	"./BooksRemoveIcon": 400172,
	"./BooksVariantIcon": 717053,
	"./BoomArmAlertIcon": 141473,
	"./BoomArmAlertOutlineIcon": 438918,
	"./BoomArmDownIcon": 12817,
	"./BoomArmDownOutlineIcon": 537437,
	"./BoomArmIcon": 868872,
	"./BoomArmOutlineIcon": 916810,
	"./BoomArmUpIcon": 411999,
	"./BoomArmUpOutlineIcon": 734833,
	"./BoomBarrierAlertIcon": 904720,
	"./BoomBarrierAlertOutlineIcon": 481518,
	"./BoomBarrierDownIcon": 401501,
	"./BoomBarrierDownOutlineIcon": 558136,
	"./BoomBarrierIcon": 626874,
	"./BoomBarrierOutlineIcon": 242540,
	"./BoomBarrierUpIcon": 843755,
	"./BoomBarrierUpOutlineIcon": 706498,
	"./BoomGateAlertIcon": 400206,
	"./BoomGateAlertOutlineIcon": 104756,
	"./BoomGateDownIcon": 67329,
	"./BoomGateDownOutlineIcon": 555812,
	"./BoomGateIcon": 892247,
	"./BoomGateOutlineIcon": 984154,
	"./BoomGateUpIcon": 46338,
	"./BoomGateUpOutlineIcon": 987585,
	"./BoomboxIcon": 525946,
	"./BootstrapIcon": 203803,
	"./BorderAllIcon": 256609,
	"./BorderAllVariantIcon": 906545,
	"./BorderBottomIcon": 39348,
	"./BorderBottomVariantIcon": 36611,
	"./BorderClearIcon": 203643,
	"./BorderColorIcon": 391287,
	"./BorderColourIcon": 315420,
	"./BorderHorizontalIcon": 543164,
	"./BorderInsideIcon": 366571,
	"./BorderLeftIcon": 664061,
	"./BorderLeftVariantIcon": 383935,
	"./BorderNoneIcon": 347707,
	"./BorderNoneVariantIcon": 541517,
	"./BorderOuterIcon": 38635,
	"./BorderOutsideIcon": 296644,
	"./BorderRightIcon": 60430,
	"./BorderRightVariantIcon": 601050,
	"./BorderStyleIcon": 60390,
	"./BorderTopIcon": 600743,
	"./BorderTopVariantIcon": 732744,
	"./BorderVerticalIcon": 213954,
	"./BottleWineIcon": 602659,
	"./BowTieIcon": 872172,
	"./BowlIcon": 308906,
	"./BowlingIcon": 636076,
	"./BoxCutterIcon": 227135,
	"./BoxDownIcon": 438624,
	"./BoxIcon": 487013,
	"./BoxOutlineIcon": 337719,
	"./BoxSearchIcon": 21574,
	"./BoxSearchOutlineIcon": 389803,
	"./BoxShadowIcon": 329069,
	"./BoxUpIcon": 577907,
	"./BoxVariantClosedIcon": 155489,
	"./BoxVariantIcon": 842474,
	"./BoxingGloveIcon": 570483,
	"./BracketIcon": 398518,
	"./BrailleIcon": 416263,
	"./BrainIcon": 230405,
	"./BrandingWatermarkIcon": 711689,
	"./BrazilianRealIcon": 875319,
	"./BreadIcon": 151950,
	"./BreadSliceIcon": 382214,
	"./BreadSliceOutlineIcon": 76620,
	"./BreastFeedIcon": 234137,
	"./BricksIcon": 649525,
	"./BridgeIcon": 474830,
	"./BriefcaseAccountIcon": 847041,
	"./BriefcaseAccountOutlineIcon": 892195,
	"./BriefcaseAddIcon": 14911,
	"./BriefcaseAddOutlineIcon": 558746,
	"./BriefcaseCheckIcon": 187651,
	"./BriefcaseDownloadIcon": 244236,
	"./BriefcaseDownloadOutlineIcon": 153116,
	"./BriefcaseEditIcon": 669801,
	"./BriefcaseEditOutlineIcon": 994160,
	"./BriefcaseIcon": 294354,
	"./BriefcaseMinusIcon": 466799,
	"./BriefcaseMinusOutlineIcon": 433800,
	"./BriefcaseOutlineIcon": 84258,
	"./BriefcasePersonIcon": 990086,
	"./BriefcasePersonOutlineIcon": 306362,
	"./BriefcasePlusIcon": 155917,
	"./BriefcasePlusOutlineIcon": 993745,
	"./BriefcaseRemoveIcon": 376250,
	"./BriefcaseRemoveOutlineIcon": 401627,
	"./BriefcaseSearchIcon": 440783,
	"./BriefcaseSearchOutlineIcon": 298589,
	"./BriefcaseTickIcon": 966665,
	"./BriefcaseUploadIcon": 355705,
	"./BriefcaseUploadOutlineIcon": 136994,
	"./BriefcaseUserIcon": 90452,
	"./BriefcaseUserOutlineIcon": 838642,
	"./Brightness1Icon": 139648,
	"./Brightness2Icon": 660078,
	"./Brightness3Icon": 551071,
	"./Brightness4Icon": 605982,
	"./Brightness5Icon": 99140,
	"./Brightness6Icon": 229100,
	"./Brightness7Icon": 677050,
	"./BrightnessAutoIcon": 66901,
	"./BrightnessHighIcon": 748071,
	"./BrightnessLowIcon": 291239,
	"./BrightnessMediumIcon": 242227,
	"./BrightnessPercentIcon": 804466,
	"./BrokenImageIcon": 868263,
	"./BroomIcon": 888037,
	"./BrushIcon": 543025,
	"./BubbleChartIcon": 503655,
	"./BuddhismIcon": 721695,
	"./BufferIcon": 75339,
	"./BugCheckIcon": 330483,
	"./BugCheckOutlineIcon": 601543,
	"./BugIcon": 152270,
	"./BugOutlineIcon": 410679,
	"./BugReportIcon": 750381,
	"./BugTickIcon": 37801,
	"./BugTickOutlineIcon": 908518,
	"./BugfoodIcon": 726249,
	"./BugleIcon": 861142,
	"./BuildIcon": 24791,
	"./BuildOutlineIcon": 905664,
	"./BuildingIcon": 954693,
	"./BulbIcon": 700789,
	"./BulbOnIcon": 600717,
	"./BulbOnOutlineIcon": 924935,
	"./BulbOutlineIcon": 356985,
	"./BulldozerIcon": 750532,
	"./BulletIcon": 623795,
	"./BulletinBoardIcon": 9283,
	"./BulletsIcon": 162900,
	"./BullhornIcon": 781023,
	"./BullhornOutlineIcon": 528105,
	"./BullseyeArrowIcon": 790340,
	"./BullseyeIcon": 290902,
	"./BunnyIcon": 649695,
	"./BurstModeIcon": 199258,
	"./BusAlertIcon": 941168,
	"./BusArticulatedEndIcon": 181765,
	"./BusArticulatedFrontIcon": 84983,
	"./BusClockIcon": 70072,
	"./BusDoubleDeckerIcon": 785379,
	"./BusIcon": 419275,
	"./BusMultipleIcon": 166341,
	"./BusSchoolIcon": 585538,
	"./BusSideIcon": 116485,
	"./BusWarningIcon": 553743,
	"./BusinessIcon": 15020,
	"./CableCarIcon": 546644,
	"./CachedIcon": 180053,
	"./CactusIcon": 491325,
	"./CakeIcon": 308490,
	"./CakeLayeredIcon": 886423,
	"./CakeVariantIcon": 444150,
	"./CalculatorIcon": 735654,
	"./CalculatorVariantIcon": 928816,
	"./CalendarAccountIcon": 858101,
	"./CalendarAccountOutlineIcon": 288723,
	"./CalendarAddIcon": 215773,
	"./CalendarAlertIcon": 832201,
	"./CalendarBlankIcon": 950574,
	"./CalendarBlankOutlineIcon": 119726,
	"./CalendarCheckIcon": 278251,
	"./CalendarCheckOutlineIcon": 929409,
	"./CalendarClockIcon": 894045,
	"./CalendarDayIcon": 750389,
	"./CalendarEditIcon": 978573,
	"./CalendarExportIcon": 982986,
	"./CalendarHeartIcon": 765990,
	"./CalendarIcon": 923115,
	"./CalendarImportIcon": 410096,
	"./CalendarMinusIcon": 685583,
	"./CalendarMonthIcon": 522735,
	"./CalendarMonthOutlineIcon": 112849,
	"./CalendarMultipleCheckIcon": 520907,
	"./CalendarMultipleIcon": 297702,
	"./CalendarMultipleTickIcon": 878045,
	"./CalendarMultiselectIcon": 240470,
	"./CalendarOutlineIcon": 292865,
	"./CalendarPlusIcon": 8211,
	"./CalendarQuestionIcon": 962404,
	"./CalendarRangeIcon": 565201,
	"./CalendarRangeOutlineIcon": 359080,
	"./CalendarRemoveIcon": 694365,
	"./CalendarRemoveOutlineIcon": 436591,
	"./CalendarRepeatIcon": 894866,
	"./CalendarRepeatOutlineIcon": 140750,
	"./CalendarRsvpIcon": 510824,
	"./CalendarSearchIcon": 805702,
	"./CalendarStarIcon": 70435,
	"./CalendarSyncIcon": 597795,
	"./CalendarSyncOutlineIcon": 61595,
	"./CalendarTaskIcon": 411387,
	"./CalendarTaskOutlineIcon": 96284,
	"./CalendarTextIcon": 648736,
	"./CalendarTextOutlineIcon": 466925,
	"./CalendarTickIcon": 772223,
	"./CalendarTickOutlineIcon": 298758,
	"./CalendarTimeIcon": 620833,
	"./CalendarTodayIcon": 711595,
	"./CalendarWarningIcon": 269125,
	"./CalendarWeekBeginIcon": 449466,
	"./CalendarWeekIcon": 405138,
	"./CalendarWeekendIcon": 305285,
	"./CalendarWeekendOutlineIcon": 766518,
	"./CalendarsCheckIcon": 817916,
	"./CalendarsIcon": 918197,
	"./CalendarsTickIcon": 461565,
	"./CallEndIcon": 267651,
	"./CallIcon": 309672,
	"./CallMadeIcon": 137064,
	"./CallMergeIcon": 772673,
	"./CallMissedIcon": 450214,
	"./CallOutlineIcon": 646656,
	"./CallReceivedIcon": 718789,
	"./CallSplitIcon": 714805,
	"./CamcorderBoxIcon": 802398,
	"./CamcorderBoxOffIcon": 411223,
	"./CamcorderIcon": 605141,
	"./CamcorderOffIcon": 192531,
	"./CameraAccountIcon": 886763,
	"./CameraAltIcon": 257800,
	"./CameraBurstIcon": 79757,
	"./CameraControlIcon": 587498,
	"./CameraEnhanceIcon": 558472,
	"./CameraEnhanceOutlineIcon": 424782,
	"./CameraFrontIcon": 683180,
	"./CameraFrontVariantIcon": 148534,
	"./CameraGoproIcon": 542680,
	"./CameraIcon": 372655,
	"./CameraImageIcon": 755694,
	"./CameraIrisIcon": 240370,
	"./CameraMeteringCenterIcon": 812799,
	"./CameraMeteringCentreIcon": 506784,
	"./CameraMeteringMatrixIcon": 725839,
	"./CameraMeteringPartialIcon": 993768,
	"./CameraMeteringSpotIcon": 613146,
	"./CameraOffIcon": 229747,
	"./CameraOutlineIcon": 751731,
	"./CameraPartyModeIcon": 524716,
	"./CameraPlusIcon": 434246,
	"./CameraPlusOutlineIcon": 839625,
	"./CameraRearIcon": 206831,
	"./CameraRearVariantIcon": 967625,
	"./CameraRetakeIcon": 694256,
	"./CameraRetakeOutlineIcon": 273528,
	"./CameraRollIcon": 432479,
	"./CameraSwitchIcon": 591837,
	"./CameraTimerIcon": 223361,
	"./CameraUserIcon": 258403,
	"./CameraWirelessIcon": 34041,
	"./CameraWirelessOutlineIcon": 255346,
	"./CampfireIcon": 177936,
	"./CampingIcon": 609185,
	"./CancelIcon": 222209,
	"./CandleIcon": 162551,
	"./CandycaneIcon": 862370,
	"./CannabisIcon": 49817,
	"./CapsLockIcon": 920855,
	"./CapsuleIcon": 429827,
	"./CarBackIcon": 459233,
	"./CarBatteryIcon": 404188,
	"./CarBrakeAbsIcon": 452092,
	"./CarBrakeAlertIcon": 417786,
	"./CarBrakeHoldIcon": 698948,
	"./CarBrakeParkingIcon": 5367,
	"./CarBrakeWarningIcon": 932203,
	"./CarConnectedIcon": 971796,
	"./CarConvertibleIcon": 744316,
	"./CarCruiseControlIcon": 141231,
	"./CarDefrostFrontIcon": 236728,
	"./CarDefrostRearIcon": 113088,
	"./CarDoorIcon": 24453,
	"./CarElectricIcon": 255743,
	"./CarEmergencyBrakeIcon": 297653,
	"./CarEngineStartIcon": 997032,
	"./CarEspIcon": 959435,
	"./CarEstateIcon": 440874,
	"./CarHandbrakeIcon": 564366,
	"./CarHatchbackIcon": 821114,
	"./CarHornIcon": 846573,
	"./CarIcon": 671625,
	"./CarInsuranceIcon": 326522,
	"./CarKeyIcon": 658792,
	"./CarLightDimmedIcon": 571014,
	"./CarLightFogIcon": 794683,
	"./CarLightHighIcon": 246092,
	"./CarLimousineIcon": 38850,
	"./CarManualTransmissionIcon": 472662,
	"./CarMultipleIcon": 134420,
	"./CarOffIcon": 698313,
	"./CarParkIcon": 773422,
	"./CarParkingBrakeIcon": 542360,
	"./CarParkingLightsIcon": 135723,
	"./CarPickupIcon": 489198,
	"./CarRentalIcon": 141064,
	"./CarSecurityIcon": 729212,
	"./CarShiftPatternIcon": 761744,
	"./CarSideIcon": 846078,
	"./CarSportsIcon": 828609,
	"./CarTireAlertIcon": 378389,
	"./CarTireWarningIcon": 263815,
	"./CarTractionControlIcon": 315923,
	"./CarTransmissionIcon": 422200,
	"./CarTyreAlertIcon": 372835,
	"./CarTyreWarningIcon": 923561,
	"./CarWashIcon": 529678,
	"./CaravanIcon": 378184,
	"./CardBulletedIcon": 503510,
	"./CardBulletedOffIcon": 101637,
	"./CardBulletedOffOutlineIcon": 500515,
	"./CardBulletedOutlineIcon": 624475,
	"./CardBulletedSettingsIcon": 870280,
	"./CardBulletedSettingsOutlineIcon": 16825,
	"./CardGiftcardIcon": 344090,
	"./CardIcon": 754929,
	"./CardMembershipIcon": 19605,
	"./CardOutlineIcon": 958385,
	"./CardTextIcon": 423582,
	"./CardTextOutlineIcon": 164213,
	"./CardTravelIcon": 576600,
	"./CardsClubIcon": 364907,
	"./CardsDiamondIcon": 878293,
	"./CardsHeartIcon": 684159,
	"./CardsIcon": 81249,
	"./CardsOutlineIcon": 638990,
	"./CardsPlayingOutlineIcon": 70238,
	"./CardsSpadeIcon": 741005,
	"./CardsVariantIcon": 96004,
	"./CaretIcon": 572486,
	"./CargoShipIcon": 431365,
	"./CarpentryIcon": 619235,
	"./CarrotIcon": 784232,
	"./CarryOnBagCheckIcon": 491478,
	"./CarryOnBagTickIcon": 86351,
	"./CarryOnLuggageIcon": 86690,
	"./CarryOnLuggageOffIcon": 66467,
	"./CartAddIcon": 819729,
	"./CartArrowDownIcon": 541756,
	"./CartArrowRightIcon": 374036,
	"./CartArrowUpIcon": 143482,
	"./CartIcon": 991884,
	"./CartMinusIcon": 476101,
	"./CartOffIcon": 396321,
	"./CartOutlineIcon": 265298,
	"./CartPlusIcon": 617035,
	"./CartRemoveIcon": 545484,
	"./CaseSensitiveAltIcon": 482918,
	"./Cash100Icon": 765134,
	"./CashIcon": 575157,
	"./CashMarkerIcon": 427128,
	"./CashMultipleIcon": 36165,
	"./CashOnDeliveryIcon": 648884,
	"./CashRefundIcon": 841344,
	"./CashRegisterIcon": 436826,
	"./CashUsdIcon": 221143,
	"./CassetteIcon": 773249,
	"./CastConnectedIcon": 265135,
	"./CastEducationIcon": 713642,
	"./CastIcon": 478645,
	"./CastOffIcon": 207290,
	"./CastleIcon": 707706,
	"./CatIcon": 253023,
	"./CategoryIcon": 74258,
	"./CcIcon": 94781,
	"./CcOutlineIcon": 999587,
	"./CctvIcon": 300226,
	"./CeilingLampIcon": 875686,
	"./CeilingLightIcon": 68947,
	"./CellphoneAndroidIcon": 960138,
	"./CellphoneArrowDownIcon": 348160,
	"./CellphoneBasicIcon": 251768,
	"./CellphoneDockIcon": 129834,
	"./CellphoneEraseIcon": 956919,
	"./CellphoneIcon": 644746,
	"./CellphoneInformationIcon": 349450,
	"./CellphoneIphoneIcon": 432787,
	"./CellphoneKeyIcon": 242661,
	"./CellphoneLinkIcon": 408417,
	"./CellphoneLinkOffIcon": 893543,
	"./CellphoneLockIcon": 44042,
	"./CellphoneMessageIcon": 878933,
	"./CellphoneNfcIcon": 254795,
	"./CellphoneOffIcon": 717,
	"./CellphoneScreenshotIcon": 233832,
	"./CellphoneSettingsIcon": 197633,
	"./CellphoneSettingsVariantIcon": 326754,
	"./CellphoneSoundIcon": 849896,
	"./CellphoneSystemUpdateIcon": 652978,
	"./CellphoneTextIcon": 453632,
	"./CellphoneWirelessIcon": 212921,
	"./CelticCrossIcon": 192451,
	"./CemeteryIcon": 865100,
	"./CertificateIcon": 243783,
	"./ChairIcon": 570518,
	"./ChairOutlineIcon": 841445,
	"./ChairRollingIcon": 234162,
	"./ChairSchoolIcon": 980481,
	"./ChangeHistoryIcon": 62083,
	"./CharcoalIcon": 319964,
	"./ChargingStationIcon": 911744,
	"./CharityIcon": 322212,
	"./ChartArcIcon": 369971,
	"./ChartAreasplineIcon": 700937,
	"./ChartAreasplineVariantIcon": 570720,
	"./ChartBarIcon": 554387,
	"./ChartBarStackedIcon": 538733,
	"./ChartBellCurveIcon": 454432,
	"./ChartBubbleIcon": 251837,
	"./ChartDonutIcon": 506448,
	"./ChartDonutVariantIcon": 579837,
	"./ChartDoughnutIcon": 691559,
	"./ChartDoughnutVariantIcon": 577407,
	"./ChartFinanceIcon": 259177,
	"./ChartGanttIcon": 647553,
	"./ChartHistogramIcon": 664562,
	"./ChartHomeIcon": 955798,
	"./ChartLineIcon": 557728,
	"./ChartLineStackedIcon": 504363,
	"./ChartLineVariantIcon": 83030,
	"./ChartMultilineIcon": 1031,
	"./ChartPieIcon": 491803,
	"./ChartScatterPlotHexbinIcon": 167721,
	"./ChartScatterPlotIcon": 551454,
	"./ChartTimelineIcon": 283906,
	"./ChartTimelineVariantIcon": 526855,
	"./ChartTreeIcon": 258442,
	"./ChatAlertIcon": 92866,
	"./ChatBubbleIcon": 442070,
	"./ChatBubbleOutlineIcon": 91771,
	"./ChatIcon": 326425,
	"./ChatOutlineIcon": 878037,
	"./ChatProcessingIcon": 294257,
	"./ChatWarningIcon": 799635,
	"./CheckAllIcon": 196791,
	"./CheckBoldIcon": 825266,
	"./CheckBoxIcon": 326562,
	"./CheckBoxMultipleOutlineIcon": 91910,
	"./CheckBoxOutlineBlankIcon": 782001,
	"./CheckBoxOutlineIcon": 309105,
	"./CheckBoxesOutlineIcon": 889051,
	"./CheckCircleIcon": 193057,
	"./CheckCircleOutlineIcon": 789244,
	"./CheckDecagramIcon": 342238,
	"./CheckIcon": 324173,
	"./CheckMultipleIcon": 967870,
	"./CheckNetworkIcon": 212998,
	"./CheckNetworkOutlineIcon": 315026,
	"./CheckOutlineIcon": 203204,
	"./CheckUnderlineCircleIcon": 954001,
	"./CheckUnderlineCircleOutlineIcon": 724699,
	"./CheckUnderlineIcon": 2269,
	"./CheckbookIcon": 771948,
	"./CheckboxBlankCircleIcon": 871094,
	"./CheckboxBlankCircleOutlineIcon": 554796,
	"./CheckboxBlankIcon": 627631,
	"./CheckboxBlankOutlineIcon": 770811,
	"./CheckboxIndeterminateOutlineIcon": 529549,
	"./CheckboxIntermediateIcon": 14158,
	"./CheckboxMarkedCircleIcon": 449734,
	"./CheckboxMarkedCircleOutlineIcon": 304739,
	"./CheckboxMarkedIcon": 726514,
	"./CheckboxMarkedOutlineIcon": 727737,
	"./CheckboxMultipleBlankCircleIcon": 705663,
	"./CheckboxMultipleBlankCircleOutlineIcon": 418458,
	"./CheckboxMultipleBlankIcon": 360028,
	"./CheckboxMultipleBlankOutlineIcon": 183271,
	"./CheckboxMultipleMarkedCircleIcon": 795367,
	"./CheckboxMultipleMarkedCircleOutlineIcon": 384452,
	"./CheckboxMultipleMarkedIcon": 326439,
	"./CheckboxMultipleMarkedOutlineIcon": 349858,
	"./CheckboxesBlankCircleIcon": 704764,
	"./CheckboxesBlankCircleOutlineIcon": 231290,
	"./CheckboxesBlankIcon": 585434,
	"./CheckboxesBlankOutlineIcon": 710639,
	"./CheckboxesMarkedCircleIcon": 325501,
	"./CheckboxesMarkedCircleOutlineIcon": 698173,
	"./CheckboxesMarkedIcon": 973174,
	"./CheckboxesMarkedOutlineIcon": 331850,
	"./CheckerboardIcon": 675822,
	"./ChecksIcon": 181861,
	"./ChefHatIcon": 445370,
	"./ChemicalWeaponIcon": 3857,
	"./ChemistIcon": 686023,
	"./ChequebookIcon": 403444,
	"./ChessBishopIcon": 812833,
	"./ChessCastleIcon": 601224,
	"./ChessHorseIcon": 144737,
	"./ChessKingIcon": 328171,
	"./ChessKnightIcon": 994072,
	"./ChessPawnIcon": 278168,
	"./ChessQueenIcon": 436069,
	"./ChessRookIcon": 398324,
	"./ChevronDoubleDownIcon": 836158,
	"./ChevronDoubleLeftIcon": 933113,
	"./ChevronDoubleRightIcon": 856561,
	"./ChevronDoubleUpIcon": 771171,
	"./ChevronDownBoxIcon": 363040,
	"./ChevronDownBoxOutlineIcon": 948182,
	"./ChevronDownCircleIcon": 688846,
	"./ChevronDownCircleOutlineIcon": 612289,
	"./ChevronDownIcon": 234994,
	"./ChevronDownUpIcon": 254954,
	"./ChevronLeftBoxIcon": 179890,
	"./ChevronLeftBoxOutlineIcon": 292951,
	"./ChevronLeftCircleIcon": 277563,
	"./ChevronLeftCircleOutlineIcon": 869908,
	"./ChevronLeftIcon": 841198,
	"./ChevronLeftRightIcon": 698371,
	"./ChevronRightBoxIcon": 738457,
	"./ChevronRightBoxOutlineIcon": 933563,
	"./ChevronRightCircleIcon": 905157,
	"./ChevronRightCircleOutlineIcon": 518262,
	"./ChevronRightIcon": 853758,
	"./ChevronRightLeftIcon": 496849,
	"./ChevronTripleDownIcon": 311951,
	"./ChevronTripleLeftIcon": 332336,
	"./ChevronTripleRightIcon": 681008,
	"./ChevronTripleUpIcon": 426945,
	"./ChevronUpBoxIcon": 480521,
	"./ChevronUpBoxOutlineIcon": 900613,
	"./ChevronUpCircleIcon": 656768,
	"./ChevronUpCircleOutlineIcon": 574194,
	"./ChevronUpDownIcon": 728203,
	"./ChevronUpIcon": 625204,
	"./ChildFriendlyIcon": 891473,
	"./ChiliHotIcon": 761989,
	"./ChiliMediumIcon": 285096,
	"./ChiliMildIcon": 225727,
	"./ChilliHotIcon": 646133,
	"./ChilliMediumIcon": 448657,
	"./ChilliMildIcon": 170750,
	"./ChipIcon": 632495,
	"./ChristianityIcon": 653045,
	"./ChristianityOutlineIcon": 212916,
	"./ChromeReaderModeIcon": 326861,
	"./ChromecastIcon": 500835,
	"./ChurchIcon": 525023,
	"./CigaretteIcon": 348167,
	"./CigaretteOffIcon": 441321,
	"./CinemaIcon": 876970,
	"./CircleArrowsIcon": 34699,
	"./CircleDiameterIcon": 624016,
	"./CircleDiameterOutlineIcon": 816972,
	"./CircleDiameterVariantIcon": 303939,
	"./CircleDoubleIcon": 539031,
	"./CircleEditOutlineIcon": 77143,
	"./CircleExpandIcon": 48661,
	"./CircleIcon": 891859,
	"./CircleMediumIcon": 716836,
	"./CircleOutlineIcon": 694411,
	"./CircleRadiusIcon": 226154,
	"./CircleRadiusOutlineIcon": 202402,
	"./CircleSlice1Icon": 917849,
	"./CircleSlice2Icon": 170484,
	"./CircleSlice3Icon": 550694,
	"./CircleSlice4Icon": 315871,
	"./CircleSlice5Icon": 501114,
	"./CircleSlice6Icon": 702435,
	"./CircleSlice7Icon": 398305,
	"./CircleSlice8Icon": 172514,
	"./CircleSmallIcon": 798271,
	"./CirclesAddIcon": 288512,
	"./CircularArrowsIcon": 410812,
	"./CircularSawIcon": 264720,
	"./CiscoWebexIcon": 875046,
	"./CityIcon": 904158,
	"./CityVariantIcon": 240223,
	"./CityVariantOutlineIcon": 611066,
	"./ClapperboardIcon": 851855,
	"./ClapperboardOutlineIcon": 547223,
	"./ClassIcon": 718593,
	"./CleaningIcon": 308233,
	"./ClearIcon": 967011,
	"./ClipIcon": 67235,
	"./ClipboardAccountIcon": 420421,
	"./ClipboardAccountOutlineIcon": 109907,
	"./ClipboardAddIcon": 797994,
	"./ClipboardAlertIcon": 669699,
	"./ClipboardAlertOutlineIcon": 815916,
	"./ClipboardArrowBottomIcon": 212409,
	"./ClipboardArrowBottomOutlineIcon": 11898,
	"./ClipboardArrowDownIcon": 511446,
	"./ClipboardArrowDownOutlineIcon": 213799,
	"./ClipboardArrowLeftIcon": 438985,
	"./ClipboardArrowLeftOutlineIcon": 487945,
	"./ClipboardArrowRightIcon": 851703,
	"./ClipboardArrowRightOutlineIcon": 408505,
	"./ClipboardArrowTopIcon": 193184,
	"./ClipboardArrowTopOutlineIcon": 541825,
	"./ClipboardArrowUpIcon": 366708,
	"./ClipboardArrowUpOutlineIcon": 117885,
	"./ClipboardCheckIcon": 523465,
	"./ClipboardCheckOutlineIcon": 867443,
	"./ClipboardFlowIcon": 471167,
	"./ClipboardIcon": 625476,
	"./ClipboardOutlineIcon": 420296,
	"./ClipboardPersonIcon": 574243,
	"./ClipboardPersonOutlineIcon": 404853,
	"./ClipboardPlayIcon": 849400,
	"./ClipboardPlayOutlineIcon": 607365,
	"./ClipboardPlusIcon": 889511,
	"./ClipboardPulseIcon": 74027,
	"./ClipboardPulseOutlineIcon": 89871,
	"./ClipboardTextIcon": 213433,
	"./ClipboardTextOutlineIcon": 965391,
	"./ClipboardTextPlayIcon": 98746,
	"./ClipboardTextPlayOutlineIcon": 217557,
	"./ClipboardTickIcon": 283590,
	"./ClipboardTickOutlineIcon": 299871,
	"./ClipboardUserIcon": 535966,
	"./ClipboardUserOutlineIcon": 4283,
	"./ClipboardVitalsIcon": 226051,
	"./ClipboardVitalsOutlineIcon": 363242,
	"./ClipboardWarningIcon": 376515,
	"./ClipboardWarningOutlineIcon": 481792,
	"./ClippyIcon": 289574,
	"./ClockAlertIcon": 298767,
	"./ClockAlertOutlineIcon": 664029,
	"./ClockArrowIcon": 150818,
	"./ClockDigitalIcon": 384290,
	"./ClockEndIcon": 391974,
	"./ClockFastIcon": 526916,
	"./ClockIcon": 844060,
	"./ClockInIcon": 449373,
	"./ClockOutIcon": 996669,
	"./ClockOutlineIcon": 176502,
	"./ClockStartIcon": 813360,
	"./ClockWarningIcon": 649065,
	"./ClockwiseArrowsIcon": 534692,
	"./ClockwiseIcon": 319030,
	"./CloseBoxIcon": 890332,
	"./CloseBoxMultipleIcon": 770648,
	"./CloseBoxMultipleOutlineIcon": 306493,
	"./CloseBoxOutlineIcon": 942179,
	"./CloseBoxesIcon": 921028,
	"./CloseBoxesOutlineIcon": 386398,
	"./CloseCircleIcon": 384293,
	"./CloseCircleOutlineIcon": 54564,
	"./CloseIcon": 363052,
	"./CloseNetworkIcon": 305591,
	"./CloseNetworkOutlineIcon": 2442,
	"./CloseOctagonIcon": 553256,
	"./CloseOctagonOutlineIcon": 913569,
	"./CloseOutlineIcon": 547921,
	"./ClosedCaptionIcon": 237672,
	"./ClosedCaptionOutlineIcon": 696520,
	"./ClosedCircuitTelevisionIcon": 996481,
	"./ClosetIcon": 752842,
	"./ClosetOutlineIcon": 731861,
	"./ClothesHangerIcon": 317811,
	"./CloudAlertIcon": 272907,
	"./CloudBracesIcon": 769232,
	"./CloudCheckIcon": 52897,
	"./CloudCircleIcon": 656727,
	"./CloudDoneIcon": 134879,
	"./CloudDownloadIcon": 37430,
	"./CloudDownloadOutlineIcon": 553529,
	"./CloudIcon": 23866,
	"./CloudJsonIcon": 829302,
	"./CloudOffOutlineIcon": 328731,
	"./CloudOutlineIcon": 30396,
	"./CloudPrintIcon": 274634,
	"./CloudPrintOutlineIcon": 265855,
	"./CloudQuestionIcon": 377632,
	"./CloudQueueIcon": 773467,
	"./CloudSearchIcon": 139406,
	"./CloudSearchOutlineIcon": 124071,
	"./CloudSyncIcon": 500546,
	"./CloudTagsIcon": 108530,
	"./CloudTickIcon": 383127,
	"./CloudUploadIcon": 919122,
	"./CloudUploadOutlineIcon": 485946,
	"./CloudWarningIcon": 570656,
	"./CloudXmlIcon": 147491,
	"./CloverIcon": 51475,
	"./ClydeIcon": 378538,
	"./CoatHangerIcon": 180362,
	"./CobwebIcon": 590709,
	"./CocktailIcon": 10056,
	"./CodIcon": 550253,
	"./CodeArrayIcon": 907320,
	"./CodeBracesIcon": 2725,
	"./CodeBracketsIcon": 140632,
	"./CodeEqualIcon": 29241,
	"./CodeGreaterThanIcon": 340594,
	"./CodeGreaterThanOrEqualIcon": 78250,
	"./CodeLessThanIcon": 573772,
	"./CodeLessThanOrEqualIcon": 280283,
	"./CodeNotEqualIcon": 364179,
	"./CodeNotEqualVariantIcon": 279406,
	"./CodeParenthesesIcon": 691913,
	"./CodeStringIcon": 903782,
	"./CodeTagsCheckIcon": 761138,
	"./CodeTagsIcon": 389159,
	"./CodeTagsTickIcon": 783784,
	"./CodepenIcon": 801240,
	"./CoffeeIcon": 928511,
	"./CoffeeOffIcon": 808413,
	"./CoffeeOffOutlineIcon": 718867,
	"./CoffeeOutlineIcon": 131640,
	"./CoffeeToGoIcon": 990705,
	"./CoffinIcon": 902910,
	"./CogBoxIcon": 584175,
	"./CogIcon": 136223,
	"./CogOutlineIcon": 189124,
	"./CogsIcon": 971299,
	"./CoinIcon": 278696,
	"./CoinsIcon": 679596,
	"./ColdAlertIcon": 3817,
	"./CollageIcon": 907416,
	"./CollapseAllIcon": 59306,
	"./CollapseAllOutlineIcon": 789787,
	"./CollapseHorizontalIcon": 914734,
	"./CollapseVerticalIcon": 332982,
	"./CollectionIcon": 984921,
	"./CollectionsIcon": 899387,
	"./CollegeIcon": 718865,
	"./ColorHelperIcon": 913023,
	"./ColorLensIcon": 811265,
	"./ColorizeIcon": 939982,
	"./ColourHelperIcon": 790316,
	"./ColourLensIcon": 736918,
	"./ColouriseIcon": 530453,
	"./ColumnIcon": 326432,
	"./ComedyIcon": 284938,
	"./ComicBubbleIcon": 869867,
	"./ComicThoughtBubbleOutlineIcon": 899448,
	"./CommaBoxIcon": 451996,
	"./CommaBoxOutlineIcon": 827850,
	"./CommaCircleIcon": 654596,
	"./CommaCircleOutlineIcon": 788073,
	"./CommaIcon": 506146,
	"./CommentAccountIcon": 318906,
	"./CommentAccountOutlineIcon": 826423,
	"./CommentAddIcon": 58487,
	"./CommentAddOutlineIcon": 567828,
	"./CommentAlertIcon": 959918,
	"./CommentAlertOutlineIcon": 32838,
	"./CommentArrowLeftIcon": 856250,
	"./CommentArrowLeftOutlineIcon": 446770,
	"./CommentArrowRightIcon": 725878,
	"./CommentArrowRightOutlineIcon": 960094,
	"./CommentCheckIcon": 719164,
	"./CommentCheckOutlineIcon": 193520,
	"./CommentEyeIcon": 389204,
	"./CommentEyeOutlineIcon": 917563,
	"./CommentIcon": 578862,
	"./CommentMultipleIcon": 89286,
	"./CommentMultipleOutlineIcon": 978196,
	"./CommentNextIcon": 121963,
	"./CommentNextOutlineIcon": 136969,
	"./CommentOutlineIcon": 503920,
	"./CommentPersonIcon": 510441,
	"./CommentPersonOutlineIcon": 123322,
	"./CommentPlusIcon": 319908,
	"./CommentPlusOutlineIcon": 39733,
	"./CommentPreviousIcon": 321181,
	"./CommentPreviousOutlineIcon": 511201,
	"./CommentProcessingIcon": 271991,
	"./CommentProcessingOutlineIcon": 863226,
	"./CommentQuestionIcon": 385050,
	"./CommentQuestionOutlineIcon": 29996,
	"./CommentRemoveIcon": 634670,
	"./CommentRemoveOutlineIcon": 138793,
	"./CommentSearchIcon": 690161,
	"./CommentSearchOutlineIcon": 803286,
	"./CommentTextIcon": 38156,
	"./CommentTextMultipleIcon": 571517,
	"./CommentTextMultipleOutlineIcon": 493319,
	"./CommentTextOutlineIcon": 393490,
	"./CommentTickIcon": 980753,
	"./CommentTickOutlineIcon": 530291,
	"./CommentUserIcon": 736105,
	"./CommentUserOutlineIcon": 991258,
	"./CommentWarningIcon": 96560,
	"./CommentWarningOutlineIcon": 954815,
	"./CommentsIcon": 358866,
	"./CommentsOutlineIcon": 557887,
	"./CommentsTextIcon": 914754,
	"./CommentsTextOutlineIcon": 210822,
	"./CommuteIcon": 886573,
	"./CompanyIcon": 80324,
	"./CompareIcon": 810217,
	"./CompassIcon": 581039,
	"./CompassOffIcon": 423220,
	"./CompassOffOutlineIcon": 610396,
	"./CompassOutlineIcon": 640708,
	"./CompressIcon": 790430,
	"./ComputerClassicIcon": 209917,
	"./ComputerIcon": 861400,
	"./ConfidentialModeIcon": 59754,
	"./ConfirmationNumberIcon": 987186,
	"./ConsoleIcon": 414856,
	"./ConsoleLineIcon": 381397,
	"./ConsoleNetworkIcon": 660242,
	"./ConsoleNetworkOutlineIcon": 381600,
	"./ContactMailIcon": 593487,
	"./ContactMailOutlineIcon": 360442,
	"./ContactPhoneIcon": 656381,
	"./ContactPhoneOutlineIcon": 799098,
	"./ContactlessPaymentIcon": 584499,
	"./ContactsIcon": 850889,
	"./ContainEndIcon": 421409,
	"./ContainIcon": 386491,
	"./ContainStartIcon": 470440,
	"./ContentCopyIcon": 4013,
	"./ContentCutIcon": 774360,
	"./ContentDuplicateIcon": 585739,
	"./ContentPasteIcon": 118352,
	"./ContentSaveAlertIcon": 506309,
	"./ContentSaveAlertOutlineIcon": 383448,
	"./ContentSaveAllIcon": 547958,
	"./ContentSaveAllOutlineIcon": 685863,
	"./ContentSaveEditIcon": 197144,
	"./ContentSaveEditOutlineIcon": 621629,
	"./ContentSaveIcon": 480249,
	"./ContentSaveMoveIcon": 813856,
	"./ContentSaveMoveOutlineIcon": 889902,
	"./ContentSaveOutlineIcon": 35948,
	"./ContentSaveSettingsIcon": 517444,
	"./ContentSaveSettingsOutlineIcon": 136993,
	"./ContrastBoxIcon": 503169,
	"./ContrastCircleIcon": 667713,
	"./ContrastIcon": 310468,
	"./ControlPointDuplicateIcon": 668412,
	"./ControlPointIcon": 90663,
	"./ControllerClassicIcon": 459566,
	"./ControllerClassicOutlineIcon": 443991,
	"./CookerIcon": 245432,
	"./CookieIcon": 175136,
	"./CopyrightIcon": 773064,
	"./CordovaIcon": 902515,
	"./CornIcon": 114738,
	"./CouchIcon": 158174,
	"./CounterIcon": 444987,
	"./CounterclockwiseArrowsIcon": 522328,
	"./CounterclockwiseIcon": 767346,
	"./CouponIcon": 603970,
	"./CourierCheckIcon": 524214,
	"./CourierFastIcon": 699235,
	"./CourierIcon": 492879,
	"./CourtHammerIcon": 267999,
	"./CowIcon": 340514,
	"./CowboyIcon": 47055,
	"./Cpu32BitIcon": 159121,
	"./Cpu64BitIcon": 598452,
	"./CraneIcon": 822794,
	"./CreateIcon": 367124,
	"./CreateNewFolderIcon": 827313,
	"./CreateNewFolderOutlineIcon": 724194,
	"./CreateOutlineIcon": 10768,
	"./CreationIcon": 699901,
	"./CreativeCommonsIcon": 947105,
	"./CreditCardAddIcon": 911384,
	"./CreditCardClockIcon": 256295,
	"./CreditCardClockOutlineIcon": 912111,
	"./CreditCardContactlessIcon": 463998,
	"./CreditCardIcon": 110389,
	"./CreditCardMarkerIcon": 153656,
	"./CreditCardMultipleIcon": 333125,
	"./CreditCardOffIcon": 328610,
	"./CreditCardPlusIcon": 521846,
	"./CreditCardRefundIcon": 561479,
	"./CreditCardScanIcon": 207872,
	"./CreditCardSettingsIcon": 487573,
	"./CreditCardWirelessIcon": 919919,
	"./CreditCardsIcon": 331977,
	"./CricketBatIcon": 901376,
	"./CricketIcon": 221983,
	"./Crop54Icon": 139772,
	"./CropFreeIcon": 597830,
	"./CropIcon": 162274,
	"./CropLandscapeIcon": 271630,
	"./CropPortraitIcon": 733019,
	"./CropRotateIcon": 562529,
	"./CropSquareIcon": 26382,
	"./CrossIcon": 312506,
	"./CrossOutlineIcon": 891393,
	"./CrosshairsAccountIcon": 540394,
	"./CrosshairsGpsIcon": 47391,
	"./CrosshairsIcon": 649810,
	"./CrosshairsOffIcon": 228825,
	"./CrownIcon": 375966,
	"./CryengineIcon": 485501,
	"./CrystalBallIcon": 445650,
	"./CubeIcon": 393957,
	"./CubeOutlineIcon": 777319,
	"./CubeScanIcon": 128810,
	"./CubeSendIcon": 606010,
	"./CubeUnfoldedIcon": 769395,
	"./CupIcon": 187343,
	"./CupOffIcon": 595422,
	"./CupOutlineIcon": 274649,
	"./CupWaterIcon": 985590,
	"./CupboardIcon": 890000,
	"./CupboardOutlineIcon": 264641,
	"./CupcakeIcon": 625398,
	"./CurlingIcon": 268409,
	"./CurrencyBdtIcon": 813622,
	"./CurrencyBrlIcon": 340631,
	"./CurrencyBtcIcon": 303252,
	"./CurrencyChfIcon": 659874,
	"./CurrencyCnyIcon": 621561,
	"./CurrencyEthIcon": 890866,
	"./CurrencyEurIcon": 425076,
	"./CurrencyGbpIcon": 945541,
	"./CurrencyIlsIcon": 242313,
	"./CurrencyInrIcon": 820711,
	"./CurrencyJpyIcon": 701540,
	"./CurrencyKrwIcon": 587173,
	"./CurrencyKztIcon": 375954,
	"./CurrencyNgnIcon": 864338,
	"./CurrencyPhpIcon": 975297,
	"./CurrencyRialIcon": 595316,
	"./CurrencyRubIcon": 749971,
	"./CurrencyScarabIcon": 319978,
	"./CurrencySignIcon": 271152,
	"./CurrencyTryIcon": 694343,
	"./CurrencyTwdIcon": 370099,
	"./CurrencyUsdCircleOutlineIcon": 904667,
	"./CurrencyUsdIcon": 188509,
	"./CurrencyUsdOffIcon": 902953,
	"./CurrentAcIcon": 879519,
	"./CurrentDcIcon": 805287,
	"./CursorDefaultClickIcon": 991242,
	"./CursorDefaultClickOutlineIcon": 65759,
	"./CursorDefaultIcon": 150752,
	"./CursorDefaultOutlineIcon": 614995,
	"./CursorHandIcon": 567960,
	"./CursorMoveIcon": 727397,
	"./CursorPointerIcon": 167959,
	"./CursorTextIcon": 253044,
	"./CustomerServiceIcon": 788404,
	"./CyclingIcon": 578142,
	"./DadIcon": 13115,
	"./DaggerIcon": 829894,
	"./DangerousIcon": 387179,
	"./DataUsageIcon": 896314,
	"./DatabaseAddIcon": 696908,
	"./DatabaseCheckIcon": 89736,
	"./DatabaseEditIcon": 257133,
	"./DatabaseExportIcon": 522628,
	"./DatabaseIcon": 138850,
	"./DatabaseImportIcon": 731281,
	"./DatabaseLockIcon": 700511,
	"./DatabaseMinusIcon": 845630,
	"./DatabasePlusIcon": 73971,
	"./DatabaseRefreshIcon": 984636,
	"./DatabaseRemoveIcon": 139658,
	"./DatabaseSearchIcon": 995986,
	"./DatabaseSettingsIcon": 618622,
	"./DatabaseSyncIcon": 277951,
	"./DatabaseTickIcon": 891603,
	"./DateRangeIcon": 310337,
	"./DeathStarIcon": 245848,
	"./DeathStarVariantIcon": 823476,
	"./DeathlyHallowsIcon": 828447,
	"./DebianIcon": 403745,
	"./DebugStepIntoIcon": 104651,
	"./DebugStepOutIcon": 378508,
	"./DebugStepOverIcon": 507336,
	"./DecagramCheckIcon": 430286,
	"./DecagramIcon": 248126,
	"./DecagramOutlineIcon": 942657,
	"./DecimalDecreaseIcon": 105281,
	"./DecimalIncreaseIcon": 632958,
	"./DefibrillatorIcon": 829256,
	"./DeleteCircleIcon": 934310,
	"./DeleteCircleOutlineIcon": 845308,
	"./DeleteEmptyIcon": 500051,
	"./DeleteEmptyOutlineIcon": 517104,
	"./DeleteForeverIcon": 176098,
	"./DeleteForeverOutlineIcon": 900470,
	"./DeleteIcon": 383888,
	"./DeleteOutlineIcon": 11063,
	"./DeleteRestoreIcon": 851134,
	"./DeleteSweepIcon": 471184,
	"./DeleteSweepOutlineIcon": 193791,
	"./DeleteVariantIcon": 572920,
	"./DeltaIcon": 363390,
	"./DeniedIcon": 129384,
	"./DepartureBoardIcon": 854747,
	"./DeskLampIcon": 325941,
	"./DeskphoneIcon": 159633,
	"./DesktopClassicIcon": 907595,
	"./DesktopMacDashboardIcon": 562842,
	"./DesktopMacIcon": 528313,
	"./DesktopTowerIcon": 109566,
	"./DesktopTowerMonitorIcon": 940086,
	"./DesktopWindowsIcon": 368352,
	"./DetailsIcon": 20647,
	"./DevToIcon": 468881,
	"./DeveloperBoardIcon": 729314,
	"./DeviantartIcon": 725543,
	"./DevicesIcon": 709774,
	"./DharmaWheelIcon": 924792,
	"./DharmachakraIcon": 711733,
	"./DialpadIcon": 433139,
	"./DiameterIcon": 326922,
	"./DiameterOutlineIcon": 800465,
	"./DiameterVariantIcon": 957187,
	"./DiamondIcon": 187452,
	"./DiamondOutlineIcon": 741702,
	"./DiamondStoneIcon": 938874,
	"./Dice1Icon": 950179,
	"./Dice2Icon": 614519,
	"./Dice3Icon": 319323,
	"./Dice4Icon": 543198,
	"./Dice5Icon": 325560,
	"./Dice6Icon": 223455,
	"./DiceD10Icon": 758947,
	"./DiceD12Icon": 867039,
	"./DiceD20Icon": 833596,
	"./DiceD4Icon": 654004,
	"./DiceD6Icon": 859514,
	"./DiceD8Icon": 500163,
	"./DiceFiveIcon": 157328,
	"./DiceFourIcon": 374728,
	"./DiceMultipleIcon": 527839,
	"./DiceOneIcon": 533898,
	"./DiceSixIcon": 399006,
	"./DiceThreeIcon": 266038,
	"./DiceTwoIcon": 897781,
	"./DictionaryIcon": 952451,
	"./Die1Icon": 469193,
	"./Die2Icon": 705989,
	"./Die3Icon": 384333,
	"./Die4Icon": 753650,
	"./Die5Icon": 740797,
	"./Die6Icon": 929597,
	"./DieD10Icon": 301538,
	"./DieD20Icon": 455004,
	"./DieD4Icon": 175650,
	"./DieD6Icon": 111788,
	"./DieD8Icon": 155674,
	"./DieMultipleIcon": 307567,
	"./DifferenceLeftIcon": 418041,
	"./DifferenceRightIcon": 371512,
	"./DipSwitchIcon": 923382,
	"./DirectCurrentIcon": 712577,
	"./DirectionsBikeIcon": 637278,
	"./DirectionsBoatIcon": 681473,
	"./DirectionsBusIcon": 732839,
	"./DirectionsCarIcon": 103038,
	"./DirectionsFerryIcon": 563848,
	"./DirectionsForkIcon": 826176,
	"./DirectionsIcon": 16565,
	"./DirectionsRailwayIcon": 642949,
	"./DirectionsRunIcon": 871852,
	"./DirectionsSubwayIcon": 715540,
	"./DirectionsTransitIcon": 93658,
	"./DirectionsWalkIcon": 901419,
	"./DiscAlertIcon": 709359,
	"./DiscFullIcon": 254696,
	"./DiscIcon": 942591,
	"./DiscPlayerIcon": 422074,
	"./DiscWarningIcon": 893031,
	"./DiscordIcon": 363240,
	"./DiscountIcon": 44418,
	"./DishwasherIcon": 626939,
	"./DislikeIcon": 794162,
	"./DislikeOutlineIcon": 173944,
	"./DisqusIcon": 118590,
	"./DisqusOutlineIcon": 840531,
	"./DivingFlippersIcon": 420007,
	"./DivingHelmetIcon": 990040,
	"./DivingScubaFlagIcon": 621107,
	"./DivingScubaIcon": 439156,
	"./DivingScubaTankIcon": 283178,
	"./DivingScubaTankMultipleIcon": 526997,
	"./DivingSnorkelIcon": 297223,
	"./DivisionBoxIcon": 387691,
	"./DivisionIcon": 958772,
	"./DlnaIcon": 78930,
	"./DnaIcon": 595249,
	"./DnsIcon": 606273,
	"./DnsOutlineIcon": 575062,
	"./DoNotDisturbAltIcon": 846676,
	"./DoNotDisturbIcon": 351343,
	"./DoNotDisturbOffIcon": 311374,
	"./DoNotDisturbOnIcon": 378052,
	"./DockerIcon": 289637,
	"./DoctorIcon": 970459,
	"./DogIcon": 96192,
	"./DogServiceIcon": 856951,
	"./DogSideIcon": 504180,
	"./DolbyIcon": 919189,
	"./DollarIcon": 980262,
	"./DollarOffIcon": 786195,
	"./DollyIcon": 932097,
	"./DomainIcon": 328992,
	"./DomainOffIcon": 61351,
	"./DonateIcon": 318513,
	"./DoneAllIcon": 341714,
	"./DoneIcon": 180466,
	"./DoneOutlineIcon": 338447,
	"./DonkeyIcon": 958672,
	"./DoorClosedIcon": 658106,
	"./DoorIcon": 562065,
	"./DoorOpenIcon": 288176,
	"./DoorbellVideoIcon": 148533,
	"./DotNetIcon": 139130,
	"./DotsHorizontalCircleIcon": 376392,
	"./DotsHorizontalCircleOutlineIcon": 813043,
	"./DotsHorizontalIcon": 456276,
	"./DotsVerticalCircleIcon": 499424,
	"./DotsVerticalCircleOutlineIcon": 767366,
	"./DotsVerticalIcon": 109296,
	"./DoubanIcon": 884218,
	"./DownloadIcon": 703189,
	"./DownloadMultipleIcon": 822747,
	"./DownloadNetworkIcon": 139044,
	"./DownloadNetworkOutlineIcon": 520927,
	"./DownloadOutlineIcon": 653068,
	"./DownloadsIcon": 31901,
	"./DraftIcon": 634118,
	"./DraftsIcon": 302548,
	"./DragHorizontalIcon": 900050,
	"./DragIcon": 794695,
	"./DragVariantIcon": 46687,
	"./DragVerticalIcon": 188877,
	"./DramaMasksIcon": 95035,
	"./DrawIcon": 540648,
	"./DrawingBoxIcon": 152151,
	"./DrawingIcon": 979747,
	"./DresserIcon": 406570,
	"./DresserOutlineIcon": 152019,
	"./DribbbleBoxIcon": 974665,
	"./DribbbleIcon": 953253,
	"./DriveEtaIcon": 225916,
	"./DriveIcon": 927007,
	"./DroneIcon": 981321,
	"./DropIcon": 750470,
	"./DropOutlineIcon": 117362,
	"./DropboxIcon": 738201,
	"./DrupalIcon": 755376,
	"./DuckIcon": 612838,
	"./DumbbellIcon": 71180,
	"./DumpTruckIcon": 392355,
	"./EarHearingIcon": 665238,
	"./EarHearingOffIcon": 135368,
	"./EarthBoxIcon": 318490,
	"./EarthBoxOffIcon": 139179,
	"./EarthIcon": 501077,
	"./EarthOffIcon": 239112,
	"./EdgeIcon": 109669,
	"./EditIcon": 314098,
	"./EditOffIcon": 199887,
	"./EditOffOutlineIcon": 111448,
	"./EditOutlineIcon": 247155,
	"./EggEasterIcon": 475878,
	"./EggIcon": 321422,
	"./EightBallIcon": 155963,
	"./EightTrackIcon": 293320,
	"./EjectIcon": 246880,
	"./EjectOutlineIcon": 308063,
	"./ElectricSwitchIcon": 611006,
	"./ElectricalResistanceIcon": 658639,
	"./ElectricityIcon": 843917,
	"./ElectronicStabilityProgramIcon": 73211,
	"./ElephantIcon": 371746,
	"./ElevationDeclineIcon": 685763,
	"./ElevationRiseIcon": 647258,
	"./ElevatorIcon": 969168,
	"./EllipseIcon": 565132,
	"./EllipseOutlineIcon": 5215,
	"./EllipsisHorizontalCircleIcon": 39678,
	"./EllipsisHorizontalCircleOutlineIcon": 611927,
	"./EllipsisHorizontalIcon": 905618,
	"./EllipsisVerticalCircleIcon": 715094,
	"./EllipsisVerticalCircleOutlineIcon": 902269,
	"./EllipsisVerticalIcon": 779540,
	"./EmailAddIcon": 827512,
	"./EmailAddOutlineIcon": 238540,
	"./EmailAlertIcon": 608499,
	"./EmailBoxIcon": 749120,
	"./EmailCheckIcon": 403854,
	"./EmailCheckOutlineIcon": 645046,
	"./EmailEditIcon": 987728,
	"./EmailEditOutlineIcon": 387494,
	"./EmailIcon": 370548,
	"./EmailLockIcon": 423183,
	"./EmailMarkAsUnreadIcon": 202886,
	"./EmailMinusIcon": 986518,
	"./EmailMinusOutlineIcon": 237970,
	"./EmailMultipleIcon": 619454,
	"./EmailMultipleOutlineIcon": 648599,
	"./EmailOpenIcon": 631729,
	"./EmailOpenMultipleIcon": 826699,
	"./EmailOpenMultipleOutlineIcon": 771962,
	"./EmailOpenOutlineIcon": 423215,
	"./EmailOutlineIcon": 563894,
	"./EmailPlusIcon": 508187,
	"./EmailPlusOutlineIcon": 39004,
	"./EmailSearchIcon": 909253,
	"./EmailSearchOutlineIcon": 20182,
	"./EmailSecureIcon": 971793,
	"./EmailTickIcon": 956965,
	"./EmailTickOutlineIcon": 352688,
	"./EmailVariantIcon": 331619,
	"./EmailWarningIcon": 922916,
	"./EmberIcon": 34019,
	"./EmbyIcon": 133152,
	"./EmergencyExitIcon": 237105,
	"./EmoticonAngryIcon": 734168,
	"./EmoticonAngryOutlineIcon": 852029,
	"./EmoticonCoolIcon": 639112,
	"./EmoticonCoolOutlineIcon": 888580,
	"./EmoticonCryIcon": 194591,
	"./EmoticonCryOutlineIcon": 109337,
	"./EmoticonDeadIcon": 487691,
	"./EmoticonDeadOutlineIcon": 382804,
	"./EmoticonDevilIcon": 770380,
	"./EmoticonDevilOutlineIcon": 745976,
	"./EmoticonExcitedIcon": 882194,
	"./EmoticonExcitedOutlineIcon": 961840,
	"./EmoticonFrownIcon": 556939,
	"./EmoticonFrownOutlineIcon": 228744,
	"./EmoticonHappyIcon": 277833,
	"./EmoticonHappyOutlineIcon": 915949,
	"./EmoticonIcon": 625211,
	"./EmoticonKissIcon": 286930,
	"./EmoticonKissOutlineIcon": 373084,
	"./EmoticonNeutralIcon": 792956,
	"./EmoticonNeutralOutlineIcon": 150175,
	"./EmoticonOutlineIcon": 944098,
	"./EmoticonPoopIcon": 669968,
	"./EmoticonPoopOutlineIcon": 246097,
	"./EmoticonSadIcon": 733629,
	"./EmoticonSadOutlineIcon": 564619,
	"./EmoticonTongueIcon": 360978,
	"./EmoticonTongueOutlineIcon": 475356,
	"./EmoticonWinkIcon": 175997,
	"./EmoticonWinkOutlineIcon": 41240,
	"./EngineIcon": 45139,
	"./EngineOffIcon": 446589,
	"./EngineOffOutlineIcon": 803690,
	"./EngineOutlineIcon": 998625,
	"./EnhancedEncryptionIcon": 774159,
	"./EnvelopeAddIcon": 238981,
	"./EnvelopeAddOutlineIcon": 288348,
	"./EnvelopeAlertIcon": 319863,
	"./EnvelopeBoxIcon": 668625,
	"./EnvelopeIcon": 514685,
	"./EnvelopeLockIcon": 369211,
	"./EnvelopeOpenIcon": 677228,
	"./EnvelopeOpenOutlineIcon": 472206,
	"./EnvelopeOutlineIcon": 758089,
	"./EnvelopePlusIcon": 241025,
	"./EnvelopePlusOutlineIcon": 869053,
	"./EnvelopeSecureIcon": 91916,
	"./EnvelopeVariantIcon": 901796,
	"./EnvelopeWarningIcon": 136368,
	"./EqualBoxIcon": 956542,
	"./EqualIcon": 555867,
	"./EqualiserIcon": 903766,
	"./EqualiserVerticalIcon": 287888,
	"./EqualizerIcon": 755664,
	"./EqualizerOutlineIcon": 153542,
	"./EraserIcon": 434269,
	"./EraserVariantIcon": 789751,
	"./ErrorIcon": 209151,
	"./ErrorOutlineIcon": 817854,
	"./EscalatorIcon": 388948,
	"./EslintIcon": 729498,
	"./EstateIcon": 708335,
	"./EtIcon": 925276,
	"./EthereumIcon": 866336,
	"./EthernetCableIcon": 141754,
	"./EthernetCableOffIcon": 864576,
	"./EthernetIcon": 50646,
	"./EtsyIcon": 965379,
	"./EuroIcon": 565370,
	"./EuroSymbolIcon": 284706,
	"./EvStationIcon": 597150,
	"./EventAddIcon": 271868,
	"./EventAlertIcon": 410472,
	"./EventAvailableIcon": 638143,
	"./EventAvailableOutlineIcon": 66085,
	"./EventBlankOutlineIcon": 550858,
	"./EventBusyIcon": 928758,
	"./EventBusyOutlineIcon": 548317,
	"./EventCheckIcon": 832836,
	"./EventCheckOutlineIcon": 326822,
	"./EventClockIcon": 697459,
	"./EventEditIcon": 624094,
	"./EventHeartIcon": 118925,
	"./EventIcon": 608395,
	"./EventMinusIcon": 149451,
	"./EventMultipleCheckIcon": 199886,
	"./EventMultipleIcon": 796972,
	"./EventMultipleTickIcon": 326125,
	"./EventNoteIcon": 174008,
	"./EventNoteOutlineIcon": 641463,
	"./EventOutlineIcon": 490410,
	"./EventPlusIcon": 679643,
	"./EventQuestionIcon": 501284,
	"./EventRangeIcon": 389631,
	"./EventRangeOutlineIcon": 404221,
	"./EventRemoveIcon": 195720,
	"./EventRemoveOutlineIcon": 768558,
	"./EventSearchIcon": 628190,
	"./EventSeatIcon": 671810,
	"./EventSeatOutlineIcon": 253512,
	"./EventStarIcon": 514643,
	"./EventTextIcon": 393478,
	"./EventTextOutlineIcon": 341383,
	"./EventTickIcon": 856546,
	"./EventTickOutlineIcon": 991778,
	"./EventTimeIcon": 537629,
	"./EventWeekBeginIcon": 577614,
	"./EventWeekIcon": 588647,
	"./EventbriteIcon": 268885,
	"./EventsCheckIcon": 122578,
	"./EventsIcon": 442653,
	"./EventsTickIcon": 45421,
	"./EvernoteIcon": 835986,
	"./ExclamationIcon": 246583,
	"./ExclusionIcon": 805094,
	"./ExitRunIcon": 126598,
	"./ExitToAppIcon": 989494,
	"./ExpandAllIcon": 414545,
	"./ExpandAllOutlineIcon": 402863,
	"./ExpandHorizontalIcon": 652768,
	"./ExpandLessIcon": 393419,
	"./ExpandMoreIcon": 179375,
	"./ExpandVerticalIcon": 51606,
	"./ExploreIcon": 589907,
	"./ExploreNearbyIcon": 65533,
	"./ExponentBoxIcon": 611671,
	"./ExponentIcon": 100119,
	"./ExportIcon": 621932,
	"./ExportVariantIcon": 773782,
	"./ExtensionIcon": 524656,
	"./ExtensionOutlineIcon": 201537,
	"./ExternalLinkIcon": 808540,
	"./ExtraLifeIcon": 276107,
	"./EyeAddIcon": 327320,
	"./EyeAddOutlineIcon": 226341,
	"./EyeCheckIcon": 958896,
	"./EyeCheckOutlineIcon": 785399,
	"./EyeCircleIcon": 407536,
	"./EyeCircleOutlineIcon": 615683,
	"./EyeIcon": 959031,
	"./EyeOffIcon": 531926,
	"./EyeOffOutlineIcon": 473742,
	"./EyeOutlineIcon": 287203,
	"./EyePlusIcon": 594476,
	"./EyePlusOutlineIcon": 355682,
	"./EyeSettingsIcon": 553309,
	"./EyeSettingsOutlineIcon": 247990,
	"./EyeTickIcon": 99195,
	"./EyeTickOutlineIcon": 874012,
	"./EyedropperIcon": 798794,
	"./EyedropperVariantIcon": 211111,
	"./FaceAgentIcon": 356138,
	"./FaceIcon": 245137,
	"./FaceOutlineIcon": 857970,
	"./FaceProfileIcon": 323053,
	"./FaceRecognitionIcon": 53047,
	"./FacebookBoxIcon": 772581,
	"./FacebookIcon": 706892,
	"./FacebookMessengerIcon": 909501,
	"./FacebookWorkplaceIcon": 615899,
	"./FacialRecognitionIcon": 963937,
	"./FactorialIcon": 634183,
	"./FactoryIcon": 741524,
	"./FamilyIcon": 362314,
	"./FanIcon": 72651,
	"./FanOffIcon": 823329,
	"./FaqIcon": 657317,
	"./FastFoodIcon": 814044,
	"./FastFoodOffIcon": 211441,
	"./FastForward10Icon": 597102,
	"./FastForward30Icon": 562793,
	"./FastForwardIcon": 399717,
	"./FastForwardOutlineIcon": 297852,
	"./FastRewindIcon": 853635,
	"./FatherIcon": 232691,
	"./FavoriteBorderIcon": 807366,
	"./FavoriteIcon": 710088,
	"./FavoriteOutlineIcon": 59619,
	"./FavouriteBorderIcon": 168381,
	"./FavouriteIcon": 500276,
	"./FavouriteOutlineIcon": 140113,
	"./FaxIcon": 987835,
	"./FeatherIcon": 576960,
	"./FeatureHighlightIcon": 33366,
	"./FeatureSearchIcon": 432709,
	"./FeatureSearchOutlineIcon": 325814,
	"./FedoraIcon": 803834,
	"./FeedbackIcon": 881518,
	"./FeedbackOutlineIcon": 3127,
	"./FerrisWheelIcon": 644936,
	"./FerryIcon": 94023,
	"./FiberManualRecordIcon": 522819,
	"./FiberNewIcon": 753003,
	"./FileAccountIcon": 429354,
	"./FileAcrobatBoxIcon": 430719,
	"./FileAcrobatIcon": 820981,
	"./FileAcrobatOutlineIcon": 684915,
	"./FileAlertIcon": 609709,
	"./FileAlertOutlineIcon": 491503,
	"./FileCabinetIcon": 218632,
	"./FileCadBoxIcon": 887880,
	"./FileCadIcon": 369616,
	"./FileCancelIcon": 320324,
	"./FileCancelOutlineIcon": 199186,
	"./FileChartIcon": 570911,
	"./FileCheckIcon": 292490,
	"./FileCheckOutlineIcon": 68868,
	"./FileCloudIcon": 311450,
	"./FileCompareIcon": 958507,
	"./FileCsvIcon": 621761,
	"./FileCsvOutlineIcon": 916598,
	"./FileDelimitedIcon": 907646,
	"./FileDelimitedOutlineIcon": 35525,
	"./FileDiscardIcon": 781246,
	"./FileDocumentBoxCheckIcon": 378115,
	"./FileDocumentBoxCheckOutlineIcon": 964080,
	"./FileDocumentBoxIcon": 609649,
	"./FileDocumentBoxMinusIcon": 688395,
	"./FileDocumentBoxMinusOutlineIcon": 238693,
	"./FileDocumentBoxMultipleIcon": 175643,
	"./FileDocumentBoxMultipleOutlineIcon": 720433,
	"./FileDocumentBoxOutlineIcon": 687338,
	"./FileDocumentBoxPlusIcon": 950030,
	"./FileDocumentBoxPlusOutlineIcon": 458340,
	"./FileDocumentBoxRemoveIcon": 910086,
	"./FileDocumentBoxRemoveOutlineIcon": 387271,
	"./FileDocumentBoxSearchIcon": 39621,
	"./FileDocumentBoxSearchOutlineIcon": 194354,
	"./FileDocumentBoxTickIcon": 927905,
	"./FileDocumentBoxTickOutlineIcon": 463458,
	"./FileDocumentBoxesIcon": 312134,
	"./FileDocumentBoxesOutlineIcon": 811680,
	"./FileDocumentEditIcon": 58652,
	"./FileDocumentEditOutlineIcon": 464986,
	"./FileDocumentIcon": 984525,
	"./FileDocumentOutlineIcon": 541827,
	"./FileDownloadIcon": 684338,
	"./FileDownloadOutlineIcon": 82381,
	"./FileExcelBoxIcon": 930618,
	"./FileExcelIcon": 363180,
	"./FileExportIcon": 993243,
	"./FileEyeIcon": 498617,
	"./FileEyeOutlineIcon": 947561,
	"./FileFindIcon": 574478,
	"./FileFindOutlineIcon": 397020,
	"./FileHiddenIcon": 621353,
	"./FileIcon": 409550,
	"./FileImageIcon": 811215,
	"./FileImageOutlineIcon": 470953,
	"./FileImportIcon": 527169,
	"./FileLockIcon": 525000,
	"./FileMoveIcon": 595265,
	"./FileMultipleIcon": 628152,
	"./FileMusicIcon": 302971,
	"./FileMusicOutlineIcon": 682423,
	"./FileOutlineIcon": 140322,
	"./FilePdfBoxIcon": 269983,
	"./FilePdfIcon": 742122,
	"./FilePdfOutlineIcon": 877206,
	"./FilePercentIcon": 396792,
	"./FilePlusIcon": 809129,
	"./FilePlusOutlineIcon": 723518,
	"./FilePowerpointBoxIcon": 550926,
	"./FilePowerpointIcon": 12810,
	"./FilePresentationBoxIcon": 472470,
	"./FileQuestionIcon": 338049,
	"./FileRemoveIcon": 281541,
	"./FileReplaceIcon": 992635,
	"./FileReplaceOutlineIcon": 807281,
	"./FileReportIcon": 920110,
	"./FileRestoreIcon": 448120,
	"./FileRevertIcon": 856009,
	"./FileSearchIcon": 662395,
	"./FileSearchOutlineIcon": 877850,
	"./FileSendIcon": 384375,
	"./FileTableIcon": 44043,
	"./FileTableOutlineIcon": 186872,
	"./FileTickIcon": 286650,
	"./FileTreeIcon": 454330,
	"./FileUndoIcon": 795974,
	"./FileUploadIcon": 170700,
	"./FileUploadOutlineIcon": 224862,
	"./FileUserIcon": 408799,
	"./FileVideoIcon": 12858,
	"./FileVideoOutlineIcon": 148874,
	"./FileWarningIcon": 351476,
	"./FileWarningOutlineIcon": 769090,
	"./FileWordBoxIcon": 841918,
	"./FileWordIcon": 401126,
	"./FileXmlIcon": 407448,
	"./FilesIcon": 886,
	"./FilingCabinetIcon": 332184,
	"./FilmIcon": 930446,
	"./FilmOutlineIcon": 722474,
	"./FilmReelIcon": 459006,
	"./FilmstripIcon": 229748,
	"./FilmstripOffIcon": 448491,
	"./Filter1Icon": 129967,
	"./Filter2Icon": 544013,
	"./Filter3Icon": 153206,
	"./Filter4Icon": 465114,
	"./Filter5Icon": 708664,
	"./Filter6Icon": 9825,
	"./Filter7Icon": 870249,
	"./Filter8Icon": 13629,
	"./Filter9Icon": 527774,
	"./Filter9PlusIcon": 76555,
	"./FilterBAndWIcon": 8619,
	"./FilterIcon": 637285,
	"./FilterListIcon": 859104,
	"./FilterMinusIcon": 954712,
	"./FilterMinusOutlineIcon": 582960,
	"./FilterOutlineIcon": 347531,
	"./FilterPlusIcon": 687719,
	"./FilterPlusOutlineIcon": 618208,
	"./FilterRemoveIcon": 87292,
	"./FilterRemoveOutlineIcon": 751115,
	"./FilterVariantIcon": 880885,
	"./FinanceIcon": 718146,
	"./FindInPageIcon": 198500,
	"./FindReplaceIcon": 99991,
	"./FingerprintIcon": 356207,
	"./FingerprintOffIcon": 455406,
	"./FireEngineIcon": 224833,
	"./FireExtinguisherIcon": 717768,
	"./FireIcon": 713436,
	"./FireTruckIcon": 425692,
	"./FirebaseIcon": 811630,
	"./FirefoxIcon": 622039,
	"./FireplaceIcon": 130690,
	"./FireplaceOffIcon": 436107,
	"./FireworkIcon": 427563,
	"./FirstAidKitIcon": 508241,
	"./FirstPageIcon": 619889,
	"./FishIcon": 920628,
	"./FishbowlIcon": 290941,
	"./FishbowlOutlineIcon": 256852,
	"./FitToPageIcon": 910497,
	"./FitToPageOutlineIcon": 823291,
	"./FlagAddIcon": 538021,
	"./FlagCheckeredIcon": 288355,
	"./FlagIcon": 671163,
	"./FlagMinusIcon": 106755,
	"./FlagOutlineIcon": 577669,
	"./FlagPlusIcon": 954002,
	"./FlagRemoveIcon": 962931,
	"./FlagTriangleIcon": 640994,
	"./FlagVariantIcon": 652673,
	"./FlagVariantOutlineIcon": 121176,
	"./FlameIcon": 218050,
	"./FlareIcon": 671110,
	"./FlashAlertIcon": 299112,
	"./FlashAlertOutlineIcon": 917542,
	"./FlashAutoIcon": 681417,
	"./FlashCircleIcon": 905488,
	"./FlashIcon": 298257,
	"./FlashOffIcon": 932061,
	"./FlashOnIcon": 958313,
	"./FlashOutlineIcon": 272553,
	"./FlashRedEyeIcon": 534441,
	"./FlashlightIcon": 598577,
	"./FlashlightOffIcon": 21302,
	"./FlaskEmptyIcon": 814178,
	"./FlaskEmptyOutlineIcon": 427717,
	"./FlaskIcon": 956432,
	"./FlaskOutlineIcon": 704573,
	"./FlattrIcon": 702375,
	"./FleetIcon": 177781,
	"./FlickrIcon": 252170,
	"./FlightIcon": 626978,
	"./FlightLandIcon": 845548,
	"./FlightModeIcon": 162497,
	"./FlightModeOffIcon": 396213,
	"./FlightTakeoffIcon": 714612,
	"./FlipToBackIcon": 460743,
	"./FlipToFrontIcon": 769274,
	"./FloodIcon": 456415,
	"./FloorLampIcon": 317708,
	"./FloorPlanIcon": 982110,
	"./FloppyIcon": 455068,
	"./FloppyVariantIcon": 231091,
	"./FlowchartIcon": 836433,
	"./FlowerIcon": 428571,
	"./FlowerLotusIcon": 479837,
	"./FlowerLotusOutlineIcon": 833123,
	"./FlowerOutlineIcon": 879348,
	"./FlowerPoppyIcon": 994626,
	"./FlowerTulipIcon": 35118,
	"./FlowerTulipOutlineIcon": 79422,
	"./FocusAutoIcon": 902763,
	"./FocusFieldHorizontalIcon": 201883,
	"./FocusFieldIcon": 364153,
	"./FocusFieldVerticalIcon": 823424,
	"./FolderAccountIcon": 192647,
	"./FolderAccountOutlineIcon": 631637,
	"./FolderAddIcon": 487654,
	"./FolderAddOutlineIcon": 52610,
	"./FolderAlertIcon": 955754,
	"./FolderAlertOutlineIcon": 659465,
	"./FolderClockIcon": 649689,
	"./FolderClockOutlineIcon": 801841,
	"./FolderDownloadIcon": 516606,
	"./FolderEditIcon": 552115,
	"./FolderEditOutlineIcon": 271974,
	"./FolderGoogleDriveIcon": 39097,
	"./FolderHashIcon": 709229,
	"./FolderHashOutlineIcon": 899539,
	"./FolderIcon": 140016,
	"./FolderImageIcon": 510281,
	"./FolderKeyIcon": 522662,
	"./FolderKeyNetworkIcon": 748474,
	"./FolderKeyNetworkOutlineIcon": 331013,
	"./FolderLockIcon": 406463,
	"./FolderLockOpenIcon": 720773,
	"./FolderMoveIcon": 746521,
	"./FolderMultipleIcon": 480198,
	"./FolderMultipleImageIcon": 716923,
	"./FolderMultipleOutlineIcon": 125920,
	"./FolderMydriveIcon": 777258,
	"./FolderNetworkIcon": 677093,
	"./FolderNetworkOutlineIcon": 464831,
	"./FolderOpenIcon": 781837,
	"./FolderOpenOutlineIcon": 410339,
	"./FolderOutlineIcon": 936128,
	"./FolderPlusIcon": 433086,
	"./FolderPlusOutlineIcon": 727796,
	"./FolderPoundIcon": 236854,
	"./FolderPoundOutlineIcon": 49065,
	"./FolderRemoveIcon": 843850,
	"./FolderRemoveOutlineIcon": 980521,
	"./FolderSearchIcon": 670064,
	"./FolderSearchOutlineIcon": 416336,
	"./FolderSharedIcon": 175272,
	"./FolderSharedOutlineIcon": 884388,
	"./FolderSpecialIcon": 187819,
	"./FolderSpecialOutlineIcon": 527390,
	"./FolderStarIcon": 284352,
	"./FolderStarOutlineIcon": 583211,
	"./FolderSyncIcon": 327984,
	"./FolderSyncOutlineIcon": 237342,
	"./FolderTextIcon": 703178,
	"./FolderTextOutlineIcon": 967146,
	"./FolderUploadIcon": 326704,
	"./FolderUserIcon": 458744,
	"./FolderUserOutlineIcon": 17466,
	"./FolderWarningIcon": 482830,
	"./FolderWarningOutlineIcon": 322334,
	"./FoldersIcon": 338571,
	"./FoldersImageIcon": 354945,
	"./FoldersOutlineIcon": 45165,
	"./FontAwesomeIcon": 851739,
	"./FoodAppleIcon": 201864,
	"./FoodAppleOutlineIcon": 113305,
	"./FoodCroissantIcon": 557573,
	"./FoodForkDrinkIcon": 372167,
	"./FoodIcon": 287650,
	"./FoodOffIcon": 564014,
	"./FoodVariantIcon": 881185,
	"./FootPrintIcon": 949074,
	"./FootballAmericanIcon": 637676,
	"./FootballAustralianIcon": 679639,
	"./FootballHelmetIcon": 906805,
	"./FootballIcon": 448408,
	"./FootballPitchIcon": 377176,
	"./FootprintsIcon": 978285,
	"./ForbidIcon": 545862,
	"./ForestIcon": 591832,
	"./ForgotPasswordIcon": 691855,
	"./ForkliftIcon": 591923,
	"./FormatAlignBottomIcon": 385479,
	"./FormatAlignCenterIcon": 38099,
	"./FormatAlignCentreIcon": 972299,
	"./FormatAlignJustifyIcon": 755153,
	"./FormatAlignLeftIcon": 439758,
	"./FormatAlignMiddleIcon": 638477,
	"./FormatAlignRightIcon": 697633,
	"./FormatAlignTopIcon": 575346,
	"./FormatAnnotationAddIcon": 435403,
	"./FormatAnnotationMinusIcon": 619338,
	"./FormatAnnotationPlusIcon": 238736,
	"./FormatBoldIcon": 159106,
	"./FormatClearIcon": 293532,
	"./FormatColorFillIcon": 658111,
	"./FormatColorHighlightIcon": 995672,
	"./FormatColorResetIcon": 574618,
	"./FormatColorTextIcon": 530593,
	"./FormatColourFillIcon": 569881,
	"./FormatColourHighlightIcon": 545086,
	"./FormatColourTextIcon": 645622,
	"./FormatColumnsIcon": 999982,
	"./FormatFloatCenterIcon": 423074,
	"./FormatFloatCentreIcon": 44640,
	"./FormatFloatLeftIcon": 789914,
	"./FormatFloatNoneIcon": 454407,
	"./FormatFloatRightIcon": 109060,
	"./FormatFontIcon": 615485,
	"./FormatFontSizeDecreaseIcon": 58935,
	"./FormatFontSizeIncreaseIcon": 104638,
	"./FormatHeader1Icon": 533197,
	"./FormatHeader2Icon": 416778,
	"./FormatHeader3Icon": 535001,
	"./FormatHeader4Icon": 50848,
	"./FormatHeader5Icon": 307202,
	"./FormatHeader6Icon": 266776,
	"./FormatHeaderDecreaseIcon": 69675,
	"./FormatHeaderEqualIcon": 865336,
	"./FormatHeaderHashIcon": 519771,
	"./FormatHeaderIncreaseIcon": 356787,
	"./FormatHeaderPoundIcon": 895535,
	"./FormatHorizontalAlignCenterIcon": 92431,
	"./FormatHorizontalAlignCentreIcon": 305167,
	"./FormatHorizontalAlignLeftIcon": 23969,
	"./FormatHorizontalAlignRightIcon": 216373,
	"./FormatIndentDecreaseIcon": 544678,
	"./FormatIndentIncreaseIcon": 256987,
	"./FormatItalicIcon": 489018,
	"./FormatLetterCaseIcon": 227266,
	"./FormatLetterCaseLowerIcon": 691936,
	"./FormatLetterCaseUpperIcon": 95127,
	"./FormatLineSpacingIcon": 684995,
	"./FormatLineStyleIcon": 532642,
	"./FormatLineWeightIcon": 93221,
	"./FormatListBulletedIcon": 739760,
	"./FormatListBulletedSquareIcon": 846457,
	"./FormatListBulletedTypeIcon": 843409,
	"./FormatListCheckboxIcon": 394630,
	"./FormatListChecksIcon": 101673,
	"./FormatListNumberedIcon": 748039,
	"./FormatListNumberedRightToLeftIcon": 929242,
	"./FormatListNumberedRtlIcon": 330775,
	"./FormatListNumbersIcon": 395363,
	"./FormatListTriangleIcon": 885609,
	"./FormatLowercaseIcon": 142098,
	"./FormatOverlineIcon": 201472,
	"./FormatPageBreakIcon": 443117,
	"./FormatPaintIcon": 824862,
	"./FormatParagraphIcon": 297980,
	"./FormatPilcrowIcon": 277707,
	"./FormatQuoteCloseIcon": 980252,
	"./FormatQuoteOpenIcon": 7094,
	"./FormatRotate90Icon": 262786,
	"./FormatRotateNinetyIcon": 308369,
	"./FormatSectionIcon": 220542,
	"./FormatSizeIcon": 822487,
	"./FormatStrikethroughIcon": 515517,
	"./FormatStrikethroughVariantIcon": 871834,
	"./FormatSubscriptIcon": 40409,
	"./FormatSuperscriptIcon": 449113,
	"./FormatTextIcon": 675992,
	"./FormatTextRotationDownIcon": 855595,
	"./FormatTextRotationNoneIcon": 781308,
	"./FormatTextVariantIcon": 83608,
	"./FormatTextWrappingClipIcon": 217419,
	"./FormatTextWrappingOverflowIcon": 468565,
	"./FormatTextWrappingWrapIcon": 267919,
	"./FormatTextboxIcon": 843587,
	"./FormatTextdirectionLToRIcon": 668912,
	"./FormatTextdirectionRToLIcon": 747114,
	"./FormatTitleIcon": 646099,
	"./FormatUnderlineIcon": 151346,
	"./FormatUnderlinedIcon": 114312,
	"./FormatUppercaseIcon": 853336,
	"./FormatVerticalAlignBottomIcon": 650348,
	"./FormatVerticalAlignCenterIcon": 765414,
	"./FormatVerticalAlignCentreIcon": 829646,
	"./FormatVerticalAlignTopIcon": 386795,
	"./FormatWrapInlineIcon": 290536,
	"./FormatWrapSquareIcon": 336422,
	"./FormatWrapTightIcon": 912243,
	"./FormatWrapTopBottomIcon": 115333,
	"./FortniteIcon": 894930,
	"./ForumIcon": 366955,
	"./ForumOutlineIcon": 436258,
	"./ForwardIcon": 874610,
	"./ForwardOffIcon": 348345,
	"./ForwardOffOutlineIcon": 998386,
	"./ForwardOutlineIcon": 195171,
	"./ForwardburgerIcon": 230773,
	"./FountainIcon": 231005,
	"./FountainPenIcon": 623374,
	"./FountainPenTipIcon": 188459,
	"./FoursquareIcon": 691693,
	"./FrameBackwardIcon": 488369,
	"./FrameForwardIcon": 799638,
	"./FrancIcon": 296284,
	"./FreeBreakfastIcon": 246040,
	"./FreebsdIcon": 985429,
	"./FreehandLineIcon": 909423,
	"./FreezeAdvisoryIcon": 110009,
	"./FrenchBaguetteIcon": 875505,
	"./FrequentlyAskedQuestionsIcon": 10298,
	"./FridgeBottomIcon": 241973,
	"./FridgeFilledBottomIcon": 433607,
	"./FridgeFilledIcon": 246250,
	"./FridgeFilledTopIcon": 749066,
	"./FridgeIcon": 111793,
	"./FridgeOutlineIcon": 285036,
	"./FridgeTopIcon": 380851,
	"./FuelIcon": 553051,
	"./FuelPumpIcon": 468803,
	"./FuelPumpOutlineIcon": 271256,
	"./FuelStationIcon": 315838,
	"./FuelStationOutlineIcon": 917275,
	"./FullOuterJoinIcon": 923334,
	"./FullscreenExitIcon": 765829,
	"./FullscreenIcon": 395380,
	"./FunctionIcon": 181181,
	"./FunctionVariantIcon": 159639,
	"./FungusIcon": 963202,
	"./FungusOutlineIcon": 192913,
	"./FunnelIcon": 431393,
	"./FunnelMinusIcon": 606654,
	"./FunnelMinusOutlineIcon": 579308,
	"./FunnelOutlineIcon": 192901,
	"./FunnelPlusIcon": 1157,
	"./FunnelPlusOutlineIcon": 874361,
	"./FunnelRemoveIcon": 529951,
	"./FunnelRemoveOutlineIcon": 975069,
	"./FuseBladeIcon": 517636,
	"./FuseIcon": 200922,
	"./GTranslateIcon": 83294,
	"./GamepadCircleDownIcon": 786061,
	"./GamepadCircleIcon": 813950,
	"./GamepadCircleLeftIcon": 145666,
	"./GamepadCircleOutlineIcon": 785809,
	"./GamepadCircleRightIcon": 239278,
	"./GamepadCircleUpIcon": 437584,
	"./GamepadDownIcon": 285561,
	"./GamepadIcon": 503285,
	"./GamepadLeftIcon": 251419,
	"./GamepadRightIcon": 712728,
	"./GamepadRoundDownIcon": 13735,
	"./GamepadRoundIcon": 494673,
	"./GamepadRoundLeftIcon": 992301,
	"./GamepadRoundOutlineIcon": 745599,
	"./GamepadRoundRightIcon": 592001,
	"./GamepadRoundUpIcon": 215522,
	"./GamepadSquareIcon": 812971,
	"./GamepadSquareOutlineIcon": 724953,
	"./GamepadUpIcon": 161233,
	"./GamepadVariantIcon": 127893,
	"./GamepadVariantOutlineIcon": 356906,
	"./GamesIcon": 129093,
	"./GantryCraneIcon": 527441,
	"./GarageAlertIcon": 755778,
	"./GarageIcon": 530490,
	"./GarageOpenIcon": 761942,
	"./GarageWarningIcon": 140668,
	"./GarbageCanCircleIcon": 365133,
	"./GarbageCanCircleOutlineIcon": 503262,
	"./GarbageCanEmptyIcon": 214115,
	"./GarbageCanIcon": 922879,
	"./GarbageCanOutlineIcon": 322168,
	"./GarbageCircleIcon": 364134,
	"./GarbageCircleOutlineIcon": 227592,
	"./GarbageEmptyIcon": 443923,
	"./GarbageIcon": 279475,
	"./GarbageOutlineIcon": 924948,
	"./GasCylinderIcon": 468326,
	"./GasPumpIcon": 349407,
	"./GasPumpOutlineIcon": 1558,
	"./GasStationIcon": 261264,
	"./GasStationOutlineIcon": 267990,
	"./GateAndIcon": 381214,
	"./GateIcon": 652289,
	"./GateNandIcon": 302289,
	"./GateNorIcon": 195678,
	"./GateNotIcon": 10221,
	"./GateOrIcon": 177530,
	"./GateXnorIcon": 893864,
	"./GateXorIcon": 337249,
	"./GatsbyIcon": 741057,
	"./GaugeEmptyIcon": 405802,
	"./GaugeFullIcon": 919549,
	"./GaugeIcon": 739337,
	"./GaugeLowIcon": 422281,
	"./GavelIcon": 399945,
	"./GearBoxIcon": 675316,
	"./GearIcon": 828147,
	"./GearOutlineIcon": 349949,
	"./GenderFemaleIcon": 220440,
	"./GenderMaleFemaleIcon": 479613,
	"./GenderMaleIcon": 370542,
	"./GenderTransgenderIcon": 854451,
	"./GenieLampIcon": 900588,
	"./GentooIcon": 389521,
	"./GestureDoubleTapIcon": 391334,
	"./GestureIcon": 883638,
	"./GesturePinchIcon": 184493,
	"./GestureSpreadIcon": 456907,
	"./GestureSwipeDownIcon": 805415,
	"./GestureSwipeHorizontalIcon": 612448,
	"./GestureSwipeIcon": 274724,
	"./GestureSwipeLeftIcon": 972293,
	"./GestureSwipeRightIcon": 939744,
	"./GestureSwipeUpIcon": 128699,
	"./GestureSwipeVerticalIcon": 718112,
	"./GestureTapHoldIcon": 315035,
	"./GestureTapIcon": 65112,
	"./GestureTwoDoubleTapIcon": 273970,
	"./GestureTwoTapIcon": 695739,
	"./GetAppIcon": 680715,
	"./GhostIcon": 220770,
	"./GhostOffIcon": 980666,
	"./GifIcon": 383585,
	"./GiftIcon": 5690,
	"./GiftOutlineIcon": 733792,
	"./GitIcon": 959442,
	"./GitIssueIcon": 245982,
	"./GitRepositoryIcon": 319300,
	"./GithubBoxIcon": 752907,
	"./GithubCircleIcon": 493720,
	"./GithubFaceIcon": 241388,
	"./GitlabIcon": 84891,
	"./GlassCocktailIcon": 697515,
	"./GlassFluteIcon": 814667,
	"./GlassMugIcon": 604429,
	"./GlassStangeIcon": 522982,
	"./GlassTulipIcon": 57615,
	"./GlassWineIcon": 571065,
	"./GlassdoorIcon": 556930,
	"./GlassesIcon": 105741,
	"./GlobeIcon": 254098,
	"./GlobeModelIcon": 772335,
	"./GloveIcon": 991650,
	"./GlutenFreeIcon": 373576,
	"./GmailIcon": 599182,
	"./GnomeIcon": 810769,
	"./GoKartIcon": 516733,
	"./GoKartTrackIcon": 823449,
	"./GogComIcon": 454542,
	"./GogIcon": 886658,
	"./GolfCourseIcon": 300820,
	"./GolfIcon": 569681,
	"./GondolaIcon": 900375,
	"./GoodreadsIcon": 262064,
	"./GoogleAdwordsIcon": 742302,
	"./GoogleAlloIcon": 705499,
	"./GoogleAnalyticsIcon": 851828,
	"./GoogleAssistantIcon": 969056,
	"./GoogleCardboardIcon": 390372,
	"./GoogleChromeIcon": 243251,
	"./GoogleCirclesCommunitiesIcon": 631897,
	"./GoogleCirclesExtendedIcon": 947347,
	"./GoogleCirclesGroupIcon": 381617,
	"./GoogleCirclesIcon": 933772,
	"./GoogleClassroomIcon": 667495,
	"./GoogleControllerIcon": 604668,
	"./GoogleControllerOffIcon": 444364,
	"./GoogleDriveIcon": 27948,
	"./GoogleEarthIcon": 846044,
	"./GoogleFitIcon": 470485,
	"./GoogleGlassIcon": 729609,
	"./GoogleHangoutsIcon": 555271,
	"./GoogleHomeIcon": 365382,
	"./GoogleIcon": 796155,
	"./GoogleKeepIcon": 31789,
	"./GoogleLensIcon": 247049,
	"./GoogleMapsIcon": 774210,
	"./GoogleNearbyIcon": 971036,
	"./GooglePagesIcon": 372219,
	"./GooglePhotosIcon": 224553,
	"./GooglePhysicalWebIcon": 57142,
	"./GooglePlayIcon": 550025,
	"./GooglePlusBoxIcon": 107480,
	"./GooglePlusIcon": 482997,
	"./GooglePodcastIcon": 128248,
	"./GoogleSpreadsheetIcon": 278641,
	"./GoogleStreetViewIcon": 884219,
	"./GoogleTranslateIcon": 70177,
	"./GpsFixedIcon": 414500,
	"./GpsNotFixedIcon": 165970,
	"./GpuIcon": 48153,
	"./GradeIcon": 207285,
	"./GradientIcon": 988344,
	"./GraduationCapIcon": 969135,
	"./GrainIcon": 47775,
	"./GrainOffIcon": 981269,
	"./GraphqlIcon": 439303,
	"./GraveStoneIcon": 749687,
	"./GraveyardIcon": 945324,
	"./GreasePencilIcon": 531559,
	"./GreaterThanIcon": 703598,
	"./GreaterThanOrEqualIcon": 737815,
	"./GridIcon": 354023,
	"./GridLargeIcon": 569948,
	"./GridOffIcon": 911804,
	"./GridOnIcon": 268167,
	"./GrillIcon": 813493,
	"./GroupAddIcon": 579327,
	"./GroupAddOutlineIcon": 281609,
	"./GroupIcon": 875529,
	"./GuardianIcon": 891158,
	"./GuideDogIcon": 948982,
	"./GuitarAcousticIcon": 735989,
	"./GuitarElectricIcon": 231532,
	"./GuitarPickIcon": 303540,
	"./GuitarPickOutlineIcon": 835121,
	"./GunIcon": 877778,
	"./GuyFawkesMaskIcon": 206510,
	"./GyroIcon": 578156,
	"./HackernewsIcon": 14936,
	"./HailIcon": 949243,
	"./HalloweenIcon": 116322,
	"./HamburgerIcon": 371190,
	"./HamburgerMenuBackIcon": 12357,
	"./HamburgerMenuIcon": 288384,
	"./HammerIcon": 621578,
	"./HandDoubleTapIcon": 871150,
	"./HandIcon": 773087,
	"./HandLeftIcon": 161763,
	"./HandOkayIcon": 220813,
	"./HandPeaceIcon": 997014,
	"./HandPeaceVariantIcon": 554116,
	"./HandPointingDownIcon": 150278,
	"./HandPointingLeftIcon": 886817,
	"./HandPointingRightIcon": 903978,
	"./HandPointingUpIcon": 87513,
	"./HandRightIcon": 31777,
	"./HandSawIcon": 510601,
	"./HandTapIcon": 721631,
	"./HandTruckIcon": 9957,
	"./HandballIcon": 785019,
	"./HangerIcon": 813961,
	"./HardHatIcon": 568644,
	"./HarddiskIcon": 443529,
	"./HarryPotterIcon": 732634,
	"./HashtagBoxIcon": 34829,
	"./HashtagIcon": 766278,
	"./HatFedoraIcon": 942227,
	"./HazardLightsIcon": 120042,
	"./HdBoxIcon": 641297,
	"./HdIcon": 273066,
	"./HdrIcon": 273743,
	"./HdrOffIcon": 413903,
	"./HeadLightDimmedIcon": 671026,
	"./HeadLightFogIcon": 431414,
	"./HeadLightHighIcon": 305651,
	"./HeadphonesBluetoothIcon": 539799,
	"./HeadphonesBoxIcon": 252439,
	"./HeadphonesIcon": 325576,
	"./HeadphonesOffIcon": 102536,
	"./HeadphonesSettingsIcon": 616373,
	"./HeadsetDockIcon": 361393,
	"./HeadsetIcon": 801449,
	"./HeadsetMicIcon": 408611,
	"./HeadsetOffIcon": 46298,
	"./HeadstoneIcon": 581251,
	"./HearingImpairedIcon": 225345,
	"./HeartBoxIcon": 801712,
	"./HeartBoxOutlineIcon": 57215,
	"./HeartBrokenIcon": 972874,
	"./HeartBrokenOutlineIcon": 457533,
	"./HeartCircleIcon": 930795,
	"./HeartCircleOutlineIcon": 278036,
	"./HeartFlashIcon": 30526,
	"./HeartHalfFullIcon": 837193,
	"./HeartHalfIcon": 762776,
	"./HeartHalfOutlineIcon": 60327,
	"./HeartIcon": 378700,
	"./HeartMultipleIcon": 216343,
	"./HeartMultipleOutlineIcon": 197166,
	"./HeartOffIcon": 42991,
	"./HeartOutlineIcon": 419750,
	"./HeartPulseIcon": 250147,
	"./HeartVitalsIcon": 17098,
	"./HeartsIcon": 588958,
	"./HeartsOutlineIcon": 401241,
	"./HeatAdvisoryIcon": 41349,
	"./HeatAlertIcon": 737449,
	"./HeaterDisabledIcon": 832598,
	"./HeaterIcon": 477243,
	"./HeaterOffIcon": 87618,
	"./HelicopterIcon": 535579,
	"./HelipadIcon": 932424,
	"./HelixIcon": 241151,
	"./HelpBoxIcon": 666127,
	"./HelpCircleIcon": 698445,
	"./HelpCircleOutlineIcon": 111643,
	"./HelpIcon": 295247,
	"./HelpNetworkIcon": 570365,
	"./HelpNetworkOutlineIcon": 861765,
	"./HelpOutlineIcon": 179112,
	"./HelpRhombusIcon": 990632,
	"./HelpRhombusOutlineIcon": 443699,
	"./HexagonIcon": 540245,
	"./HexagonMultipleIcon": 875508,
	"./HexagonOutlineIcon": 316289,
	"./HexagonSlice1Icon": 306741,
	"./HexagonSlice2Icon": 505229,
	"./HexagonSlice3Icon": 408209,
	"./HexagonSlice4Icon": 861516,
	"./HexagonSlice5Icon": 345048,
	"./HexagonSlice6Icon": 918617,
	"./HexagonsIcon": 434726,
	"./HexagramIcon": 197594,
	"./HexagramOutlineIcon": 207266,
	"./HideIcon": 456462,
	"./HideOutlineIcon": 29669,
	"./HighBeamIcon": 343241,
	"./HighDefinitionBoxIcon": 339199,
	"./HighDefinitionIcon": 426889,
	"./HighQualityIcon": 143138,
	"./HighlightOffIcon": 83456,
	"./HighlighterIcon": 757110,
	"./HighwayIcon": 671975,
	"./HikingIcon": 286818,
	"./HinduismIcon": 697338,
	"./HistoricIcon": 550001,
	"./HistoryIcon": 686006,
	"./HockeyPuckIcon": 747810,
	"./HockeySticksIcon": 73681,
	"./HololensIcon": 868545,
	"./HomeAccountIcon": 385288,
	"./HomeAddIcon": 593668,
	"./HomeAlertIcon": 857680,
	"./HomeAnalyticsIcon": 974499,
	"./HomeAssistantIcon": 376369,
	"./HomeAutomationIcon": 139817,
	"./HomeChartIcon": 152947,
	"./HomeCircleIcon": 466277,
	"./HomeCityIcon": 797460,
	"./HomeCityOutlineIcon": 338832,
	"./HomeClimateIcon": 642661,
	"./HomeClimateOutlineIcon": 410269,
	"./HomeCurrencyUsdIcon": 688505,
	"./HomeExportOutlineIcon": 17366,
	"./HomeFloodIcon": 460902,
	"./HomeFloor0Icon": 702525,
	"./HomeFloor1Icon": 460539,
	"./HomeFloor2Icon": 9295,
	"./HomeFloor3Icon": 93677,
	"./HomeFloorAIcon": 903667,
	"./HomeFloorAtticIcon": 761870,
	"./HomeFloorBIcon": 510649,
	"./HomeFloorBasementIcon": 358972,
	"./HomeFloorFirstIcon": 909686,
	"./HomeFloorGIcon": 812089,
	"./HomeFloorGroundIcon": 910253,
	"./HomeFloorLIcon": 643309,
	"./HomeFloorLoftIcon": 344625,
	"./HomeFloorLowerIcon": 396492,
	"./HomeFloorMinus1Icon": 149081,
	"./HomeFloorMinusOneIcon": 401773,
	"./HomeFloorNegative1Icon": 759911,
	"./HomeFloorNegativeOneIcon": 819962,
	"./HomeFloorOneIcon": 76669,
	"./HomeFloorSecondIcon": 180501,
	"./HomeFloorThirdIcon": 491596,
	"./HomeFloorThreeIcon": 612276,
	"./HomeFloorTwoIcon": 360887,
	"./HomeFloorZeroIcon": 952347,
	"./HomeGroupIcon": 441197,
	"./HomeHeartIcon": 237504,
	"./HomeIcon": 50811,
	"./HomeImportOutlineIcon": 708606,
	"./HomeLockIcon": 754673,
	"./HomeLockOpenIcon": 3063,
	"./HomeMapMarkerIcon": 602401,
	"./HomeMinusIcon": 248013,
	"./HomeModernIcon": 509806,
	"./HomeOutlineIcon": 921926,
	"./HomePlusIcon": 346865,
	"./HomeTemperatureIcon": 922812,
	"./HomeTemperatureOutlineIcon": 687051,
	"./HomeThermometerIcon": 660083,
	"./HomeThermometerOutlineIcon": 730621,
	"./HomeUserIcon": 865074,
	"./HomeVariantIcon": 246711,
	"./HomeVariantOutlineIcon": 680879,
	"./HomeWarningIcon": 776921,
	"./HookIcon": 677616,
	"./HookOffIcon": 478313,
	"./HopsIcon": 351489,
	"./HorizontalLineIcon": 985448,
	"./HoroscopeAquariusIcon": 668732,
	"./HoroscopeAriesIcon": 129465,
	"./HoroscopeCancerIcon": 510144,
	"./HoroscopeCapricornIcon": 358789,
	"./HoroscopeGeminiIcon": 959067,
	"./HoroscopeLeoIcon": 506428,
	"./HoroscopeLibraIcon": 380979,
	"./HoroscopePiscesIcon": 622501,
	"./HoroscopeSagittariusIcon": 161768,
	"./HoroscopeScorpioIcon": 788133,
	"./HoroscopeTaurusIcon": 894644,
	"./HoroscopeVirgoIcon": 53234,
	"./HorseshoeIcon": 50540,
	"./HospitalBuildingIcon": 687430,
	"./HospitalIcon": 172012,
	"./HospitalMarkerIcon": 659142,
	"./HotAirBalloonIcon": 606771,
	"./HotTubIcon": 502618,
	"./HotelIcon": 77647,
	"./HourglassEmptyIcon": 655381,
	"./HourglassFullIcon": 928788,
	"./HourglassIcon": 233582,
	"./HouseCircleIcon": 237607,
	"./HouseCityIcon": 412053,
	"./HouseCityOutlineIcon": 285752,
	"./HouseFloor0Icon": 442416,
	"./HouseFloor1Icon": 517676,
	"./HouseFloor2Icon": 748741,
	"./HouseFloor3Icon": 891989,
	"./HouseFloorAIcon": 591065,
	"./HouseFloorAtticIcon": 196469,
	"./HouseFloorBIcon": 439786,
	"./HouseFloorBasementIcon": 174419,
	"./HouseFloorFirstIcon": 738386,
	"./HouseFloorGIcon": 876477,
	"./HouseFloorGroundIcon": 223095,
	"./HouseFloorLIcon": 795175,
	"./HouseFloorLoftIcon": 302735,
	"./HouseFloorLowerIcon": 263020,
	"./HouseFloorMinus1Icon": 734266,
	"./HouseFloorMinusOneIcon": 82855,
	"./HouseFloorNegative1Icon": 777406,
	"./HouseFloorNegativeOneIcon": 423042,
	"./HouseFloorOneIcon": 771895,
	"./HouseFloorSecondIcon": 347630,
	"./HouseFloorThirdIcon": 647640,
	"./HouseFloorThreeIcon": 737637,
	"./HouseFloorTwoIcon": 342474,
	"./HouseFloorZeroIcon": 846563,
	"./HouseGroupIcon": 783501,
	"./HouseIcon": 7707,
	"./HouseMapMarkerIcon": 918157,
	"./HouseModernIcon": 84064,
	"./HouseOutlineIcon": 294803,
	"./HouseVariantIcon": 686750,
	"./HouseVariantOutlineIcon": 131715,
	"./HousingEstateIcon": 236681,
	"./HouzzBoxIcon": 474975,
	"./HouzzIcon": 920338,
	"./HowToVoteIcon": 970595,
	"./HowToVoteOutlineIcon": 594248,
	"./HqIcon": 895444,
	"./HttpsIcon": 106179,
	"./HubspotIcon": 585529,
	"./HuluIcon": 427068,
	"./HumanChildIcon": 545118,
	"./HumanFemaleBoyIcon": 642956,
	"./HumanFemaleFemaleIcon": 758243,
	"./HumanFemaleGirlIcon": 421110,
	"./HumanFemaleIcon": 558118,
	"./HumanGreetingIcon": 106469,
	"./HumanHandsdownIcon": 322484,
	"./HumanHandsupIcon": 613815,
	"./HumanIcon": 212765,
	"./HumanMaleBoyIcon": 378784,
	"./HumanMaleFemaleIcon": 682157,
	"./HumanMaleGirlIcon": 933649,
	"./HumanMaleHeightIcon": 100056,
	"./HumanMaleHeightVariantIcon": 153086,
	"./HumanMaleIcon": 864601,
	"./HumanMaleMaleIcon": 90916,
	"./HumanPregnantIcon": 815975,
	"./HumbleBundleIcon": 999717,
	"./HumidityIcon": 477000,
	"./IceCreamIcon": 296217,
	"./IcePopIcon": 674461,
	"./IceSkateIcon": 927447,
	"./IdeaIcon": 366680,
	"./IdentifierIcon": 3209,
	"./IframeIcon": 523608,
	"./IframeOutlineIcon": 194680,
	"./ImageAddIcon": 816179,
	"./ImageAlbumIcon": 862542,
	"./ImageAreaCloseIcon": 379584,
	"./ImageAreaIcon": 565862,
	"./ImageAspectRatioIcon": 177879,
	"./ImageBrokenIcon": 255138,
	"./ImageBrokenVariantIcon": 683054,
	"./ImageFilterBlackWhiteIcon": 997884,
	"./ImageFilterCenterFocusIcon": 730909,
	"./ImageFilterCenterFocusStrongIcon": 932738,
	"./ImageFilterCenterFocusStrongOutlineIcon": 296727,
	"./ImageFilterCenterFocusWeakIcon": 705114,
	"./ImageFilterCentreFocusIcon": 398282,
	"./ImageFilterCentreFocusWeakIcon": 910457,
	"./ImageFilterDramaIcon": 103674,
	"./ImageFilterFramesIcon": 72943,
	"./ImageFilterHdrIcon": 892317,
	"./ImageFilterIcon": 417543,
	"./ImageFilterNoneIcon": 42744,
	"./ImageFilterTiltShiftIcon": 932393,
	"./ImageFilterVintageIcon": 278539,
	"./ImageFrameIcon": 729959,
	"./ImageIcon": 347548,
	"./ImageMoveIcon": 309131,
	"./ImageMultipleIcon": 115840,
	"./ImageMultipleOutlineIcon": 901082,
	"./ImageOffIcon": 370822,
	"./ImageOutlineIcon": 23974,
	"./ImagePlusIcon": 925453,
	"./ImageSearchIcon": 428610,
	"./ImageSearchOutlineIcon": 161282,
	"./ImageSizeSelectActualIcon": 994058,
	"./ImageSizeSelectLargeIcon": 194855,
	"./ImageSizeSelectSmallIcon": 532696,
	"./ImagesIcon": 888341,
	"./ImagesOutlineIcon": 85107,
	"./ImportContactsIcon": 726614,
	"./ImportExportBoldIcon": 837415,
	"./ImportExportIcon": 217730,
	"./ImportIcon": 906715,
	"./ImportantDevicesIcon": 350543,
	"./InboxArrowDownIcon": 861799,
	"./InboxArrowUpIcon": 393966,
	"./InboxIcon": 999882,
	"./InboxMultipleIcon": 488391,
	"./InboxMultipleOutlineIcon": 115330,
	"./InboxesIcon": 75439,
	"./InboxesOutlineIcon": 149173,
	"./IncognitoIcon": 617037,
	"./IndeterminateCheckBoxIcon": 75567,
	"./IndustrialIcon": 941640,
	"./InfinityIcon": 733618,
	"./InfoCircleIcon": 657956,
	"./InfoCircleOutlineIcon": 98391,
	"./InfoOutlineIcon": 2072,
	"./InfoVariantIcon": 669231,
	"./InformationCircleIcon": 543363,
	"./InformationCircleOutlineIcon": 157014,
	"./InformationIcon": 152585,
	"./InformationOutlineIcon": 459991,
	"./InformationVariantIcon": 424239,
	"./InjectionIcon": 565964,
	"./InkyIcon": 45423,
	"./InnerJoinIcon": 62525,
	"./InsertChartIcon": 772812,
	"./InsertCommentIcon": 476890,
	"./InsertDriveFileIcon": 130895,
	"./InsertEmoticonIcon": 880100,
	"./InsertInvitationIcon": 83747,
	"./InsertLinkIcon": 719136,
	"./InsertPhotoIcon": 307234,
	"./InstagramIcon": 971778,
	"./InstantMixIcon": 981163,
	"./InstapaperIcon": 114986,
	"./InteractionDoubleTapIcon": 38652,
	"./InteractionTapIcon": 763392,
	"./InternetExplorerIcon": 459436,
	"./InvertColorsIcon": 604850,
	"./InvertColorsOffIcon": 904864,
	"./InvertColoursIcon": 178011,
	"./InvertColoursOffIcon": 744242,
	"./InvoiceIcon": 189564,
	"./IpIcon": 687866,
	"./IpNetworkIcon": 301893,
	"./IpNetworkOutlineIcon": 544627,
	"./IpodIcon": 764122,
	"./IslamIcon": 355251,
	"./ItunesIcon": 234802,
	"./JabberIcon": 287332,
	"./JackOLanternIcon": 361949,
	"./JeepneyIcon": 696476,
	"./JellyfishIcon": 619213,
	"./JellyfishOutlineIcon": 78230,
	"./JewelIcon": 129630,
	"./JewishIcon": 965658,
	"./JigsawIcon": 627335,
	"./JigsawOutlineIcon": 223149,
	"./JiraIcon": 596342,
	"./JollyRogerIcon": 467221,
	"./JollyRogerOutlineIcon": 687113,
	"./JqueryIcon": 787740,
	"./JsfiddleIcon": 474005,
	"./JsonIcon": 927574,
	"./JudaismIcon": 751244,
	"./KabaddiIcon": 597279,
	"./KarateIcon": 371650,
	"./KazakhstaniTengeIcon": 695357,
	"./KeepIcon": 118185,
	"./KeepOffIcon": 293141,
	"./KeepOffOutlineIcon": 650063,
	"./KeepOutlineIcon": 282541,
	"./KegIcon": 883036,
	"./KettleEmptyIcon": 822549,
	"./KettleFullIcon": 221436,
	"./KettleIcon": 170854,
	"./KettleOutlineIcon": 158406,
	"./KeyAddIcon": 174409,
	"./KeyChangeIcon": 87733,
	"./KeyIcon": 639948,
	"./KeyMinusIcon": 498349,
	"./KeyOutlineIcon": 979592,
	"./KeyPlusIcon": 494543,
	"./KeyRemoveIcon": 312976,
	"./KeyVariantIcon": 161116,
	"./KeyboardArrowDownIcon": 668945,
	"./KeyboardArrowLeftIcon": 944087,
	"./KeyboardArrowRightIcon": 259648,
	"./KeyboardArrowUpIcon": 923727,
	"./KeyboardBackspaceIcon": 169682,
	"./KeyboardCapsIcon": 120408,
	"./KeyboardCapslockIcon": 411525,
	"./KeyboardCloseIcon": 563424,
	"./KeyboardHideIcon": 42414,
	"./KeyboardIcon": 890384,
	"./KeyboardOffIcon": 80649,
	"./KeyboardOffOutlineIcon": 848715,
	"./KeyboardOutlineIcon": 156592,
	"./KeyboardReturnIcon": 162641,
	"./KeyboardSettingsIcon": 771980,
	"./KeyboardSettingsOutlineIcon": 424856,
	"./KeyboardTabIcon": 202147,
	"./KeyboardVariantIcon": 245160,
	"./KeyboardVoiceIcon": 485165,
	"./KeypadIcon": 721421,
	"./KickboxingIcon": 902361,
	"./KickstarterIcon": 367007,
	"./KitchenIcon": 274529,
	"./KnifeIcon": 959564,
	"./KnifeMilitaryIcon": 268490,
	"./KodiIcon": 359938,
	"./LabelIcon": 390426,
	"./LabelOffIcon": 84474,
	"./LabelOffOutlineIcon": 719458,
	"./LabelOutlineIcon": 981674,
	"./LabelVariantIcon": 199940,
	"./LabelVariantOutlineIcon": 995988,
	"./LacrosseIcon": 14812,
	"./LadybirdIcon": 78556,
	"./LadybugIcon": 296689,
	"./LakeIcon": 868963,
	"./LambdaIcon": 283977,
	"./LampIcon": 590946,
	"./LanConnectIcon": 672240,
	"./LanDisconnectIcon": 51073,
	"./LanIcon": 273573,
	"./LanPendingIcon": 385463,
	"./LandscapeIcon": 450859,
	"./LanguageBoxIcon": 290944,
	"./LanguageCIcon": 67498,
	"./LanguageCppIcon": 740614,
	"./LanguageCsharpIcon": 479562,
	"./LanguageCss3Icon": 610426,
	"./LanguageGoIcon": 20807,
	"./LanguageHaskellIcon": 565080,
	"./LanguageHtml5Icon": 206890,
	"./LanguageIcon": 493339,
	"./LanguageJavaIcon": 186183,
	"./LanguageJavascriptIcon": 705068,
	"./LanguageLuaIcon": 929787,
	"./LanguagePhpIcon": 955570,
	"./LanguagePythonIcon": 51843,
	"./LanguagePythonTextIcon": 741555,
	"./LanguageRIcon": 511217,
	"./LanguageRubyOnRailsIcon": 629267,
	"./LanguageSwiftIcon": 277931,
	"./LanguageTypescriptIcon": 33028,
	"./LaptopChromebookIcon": 537699,
	"./LaptopIcon": 192402,
	"./LaptopMacIcon": 941408,
	"./LaptopOffIcon": 861186,
	"./LaptopWindowsIcon": 388059,
	"./LaravelIcon": 537625,
	"./LassoIcon": 273411,
	"./LastPageIcon": 786148,
	"./LastfmIcon": 156609,
	"./LastpassIcon": 521494,
	"./LatestIcon": 650462,
	"./LatitudeIcon": 616001,
	"./LaunchIcon": 951686,
	"./LaundretteIcon": 850943,
	"./LavaLampIcon": 343767,
	"./LayersClearIcon": 548766,
	"./LayersIcon": 543148,
	"./LayersMinusIcon": 207351,
	"./LayersOffIcon": 237449,
	"./LayersOffOutlineIcon": 334497,
	"./LayersOutlineIcon": 519778,
	"./LayersPlusIcon": 745081,
	"./LayersRemoveIcon": 635804,
	"./LayersTripleIcon": 743149,
	"./LayersTripleOutlineIcon": 195183,
	"./LeadPencilIcon": 117491,
	"./LeafIcon": 588795,
	"./LeafMapleIcon": 662709,
	"./LeakIcon": 816311,
	"./LeakOffIcon": 950421,
	"./LectureIcon": 106774,
	"./LedOffIcon": 310349,
	"./LedOnIcon": 441942,
	"./LedOutlineIcon": 472002,
	"./LedStripIcon": 229172,
	"./LedVariantOffIcon": 400078,
	"./LedVariantOnIcon": 590338,
	"./LedVariantOutlineIcon": 606497,
	"./LensIcon": 991443,
	"./LessThanIcon": 68336,
	"./LessThanOrEqualIcon": 331988,
	"./LetterABoxIcon": 401804,
	"./LetterABoxOutlineIcon": 112479,
	"./LetterACircleIcon": 136053,
	"./LetterACircleOutlineIcon": 182644,
	"./LetterAIcon": 124258,
	"./LetterBBoxIcon": 360899,
	"./LetterBBoxOutlineIcon": 210370,
	"./LetterBCircleIcon": 305246,
	"./LetterBCircleOutlineIcon": 267117,
	"./LetterBIcon": 762786,
	"./LetterCBoxIcon": 2948,
	"./LetterCBoxOutlineIcon": 692887,
	"./LetterCCircleIcon": 568976,
	"./LetterCCircleOutlineIcon": 64189,
	"./LetterCIcon": 220981,
	"./LetterDBoxIcon": 636097,
	"./LetterDBoxOutlineIcon": 968294,
	"./LetterDCircleIcon": 390558,
	"./LetterDCircleOutlineIcon": 276447,
	"./LetterDIcon": 211090,
	"./LetterEBoxIcon": 130920,
	"./LetterEBoxOutlineIcon": 33661,
	"./LetterECircleIcon": 397120,
	"./LetterECircleOutlineIcon": 355445,
	"./LetterEIcon": 266004,
	"./LetterFBoxIcon": 811587,
	"./LetterFBoxOutlineIcon": 598203,
	"./LetterFCircleIcon": 720399,
	"./LetterFCircleOutlineIcon": 280356,
	"./LetterFIcon": 447651,
	"./LetterGBoxIcon": 709923,
	"./LetterGBoxOutlineIcon": 945736,
	"./LetterGCircleIcon": 836041,
	"./LetterGCircleOutlineIcon": 363497,
	"./LetterGIcon": 612803,
	"./LetterHBoxIcon": 750739,
	"./LetterHBoxOutlineIcon": 197364,
	"./LetterHCircleIcon": 33227,
	"./LetterHCircleOutlineIcon": 535711,
	"./LetterHIcon": 319897,
	"./LetterIBoxIcon": 607346,
	"./LetterIBoxOutlineIcon": 302154,
	"./LetterICircleIcon": 64368,
	"./LetterICircleOutlineIcon": 674720,
	"./LetterIIcon": 505363,
	"./LetterJBoxIcon": 540285,
	"./LetterJBoxOutlineIcon": 197420,
	"./LetterJCircleIcon": 881155,
	"./LetterJCircleOutlineIcon": 269570,
	"./LetterJIcon": 942041,
	"./LetterKBoxIcon": 405051,
	"./LetterKBoxOutlineIcon": 162752,
	"./LetterKCircleIcon": 232755,
	"./LetterKCircleOutlineIcon": 860251,
	"./LetterKIcon": 432321,
	"./LetterLBoxIcon": 888407,
	"./LetterLBoxOutlineIcon": 495862,
	"./LetterLCircleIcon": 516576,
	"./LetterLCircleOutlineIcon": 197407,
	"./LetterLIcon": 336962,
	"./LetterMBoxIcon": 412962,
	"./LetterMBoxOutlineIcon": 402493,
	"./LetterMCircleIcon": 427692,
	"./LetterMCircleOutlineIcon": 678006,
	"./LetterMIcon": 708865,
	"./LetterNBoxIcon": 776610,
	"./LetterNBoxOutlineIcon": 289001,
	"./LetterNCircleIcon": 277658,
	"./LetterNCircleOutlineIcon": 88182,
	"./LetterNIcon": 775734,
	"./LetterOBoxIcon": 952744,
	"./LetterOBoxOutlineIcon": 487209,
	"./LetterOCircleIcon": 453984,
	"./LetterOCircleOutlineIcon": 268318,
	"./LetterOIcon": 150277,
	"./LetterPBoxIcon": 146517,
	"./LetterPBoxOutlineIcon": 276403,
	"./LetterPCircleIcon": 39202,
	"./LetterPCircleOutlineIcon": 689215,
	"./LetterPIcon": 816627,
	"./LetterQBoxIcon": 671099,
	"./LetterQBoxOutlineIcon": 418135,
	"./LetterQCircleIcon": 524190,
	"./LetterQCircleOutlineIcon": 128396,
	"./LetterQIcon": 687950,
	"./LetterRBoxIcon": 370511,
	"./LetterRBoxOutlineIcon": 707099,
	"./LetterRCircleIcon": 259216,
	"./LetterRCircleOutlineIcon": 255475,
	"./LetterRIcon": 761414,
	"./LetterSBoxIcon": 980633,
	"./LetterSBoxOutlineIcon": 824319,
	"./LetterSCircleIcon": 857734,
	"./LetterSCircleOutlineIcon": 371694,
	"./LetterSIcon": 204216,
	"./LetterTBoxIcon": 298593,
	"./LetterTBoxOutlineIcon": 824063,
	"./LetterTCircleIcon": 771196,
	"./LetterTCircleOutlineIcon": 583903,
	"./LetterTIcon": 694103,
	"./LetterUBoxIcon": 481685,
	"./LetterUBoxOutlineIcon": 793786,
	"./LetterUCircleIcon": 517533,
	"./LetterUCircleOutlineIcon": 931811,
	"./LetterUIcon": 263346,
	"./LetterVBoxIcon": 810918,
	"./LetterVBoxOutlineIcon": 718558,
	"./LetterVCircleIcon": 343249,
	"./LetterVCircleOutlineIcon": 264044,
	"./LetterVIcon": 773037,
	"./LetterWBoxIcon": 100815,
	"./LetterWBoxOutlineIcon": 526053,
	"./LetterWCircleIcon": 286065,
	"./LetterWCircleOutlineIcon": 708241,
	"./LetterWIcon": 890687,
	"./LetterXBoxIcon": 34121,
	"./LetterXBoxOutlineIcon": 70530,
	"./LetterXCircleIcon": 191217,
	"./LetterXCircleOutlineIcon": 89359,
	"./LetterXIcon": 140187,
	"./LetterYBoxIcon": 3917,
	"./LetterYBoxOutlineIcon": 276921,
	"./LetterYCircleIcon": 707074,
	"./LetterYCircleOutlineIcon": 252074,
	"./LetterYIcon": 77174,
	"./LetterZBoxIcon": 148044,
	"./LetterZBoxOutlineIcon": 230612,
	"./LetterZCircleIcon": 69119,
	"./LetterZCircleOutlineIcon": 469908,
	"./LetterZIcon": 918587,
	"./LibraryAddIcon": 391967,
	"./LibraryBooksIcon": 350010,
	"./LibraryIcon": 561006,
	"./LibraryMovieIcon": 255459,
	"./LibraryMusicIcon": 53507,
	"./LibraryMusicOutlineIcon": 245082,
	"./LibraryPlusIcon": 660256,
	"./LibraryShelvesIcon": 59831,
	"./LibraryVideoIcon": 677433,
	"./LifePreserverIcon": 290190,
	"./LifebuoyIcon": 986282,
	"./LightSwitchIcon": 562099,
	"./LightbulbIcon": 140014,
	"./LightbulbOffIcon": 159916,
	"./LightbulbOffOutlineIcon": 11120,
	"./LightbulbOnIcon": 180590,
	"./LightbulbOnOutlineIcon": 253859,
	"./LightbulbOutlineIcon": 307805,
	"./LighthouseIcon": 949080,
	"./LighthouseOnIcon": 59046,
	"./LightningAlertIcon": 770427,
	"./LightningAlertOutlineIcon": 642648,
	"./LightningBoltCircleIcon": 374190,
	"./LightningBoltIcon": 659464,
	"./LightningBoltOutlineIcon": 554755,
	"./LikeDislikeIcon": 900847,
	"./LikeIcon": 453039,
	"./LikeOutlineIcon": 920593,
	"./LinkAddIcon": 913966,
	"./LinkBoxIcon": 569253,
	"./LinkBoxOutlineIcon": 417216,
	"./LinkBoxVariantIcon": 945119,
	"./LinkBoxVariantOutlineIcon": 215840,
	"./LinkIcon": 367158,
	"./LinkOffIcon": 916389,
	"./LinkPlusIcon": 16791,
	"./LinkVariantIcon": 628521,
	"./LinkVariantOffIcon": 922986,
	"./LinkedinBoxIcon": 385222,
	"./LinkedinIcon": 245947,
	"./LinuxIcon": 258190,
	"./LinuxMintIcon": 28587,
	"./LiraIcon": 190299,
	"./LitecoinIcon": 673547,
	"./LoadingIcon": 719507,
	"./LoafIcon": 262135,
	"./LocalActivityIcon": 194231,
	"./LocalAirportIcon": 410447,
	"./LocalAreaNetworkConnectIcon": 249526,
	"./LocalAreaNetworkDisconnectIcon": 129056,
	"./LocalAreaNetworkIcon": 368445,
	"./LocalAreaNetworkPendingIcon": 382349,
	"./LocalAtmIcon": 394562,
	"./LocalAttractionIcon": 698963,
	"./LocalBarIcon": 293170,
	"./LocalCafeIcon": 598846,
	"./LocalCarWashIcon": 765404,
	"./LocalConvenienceStoreIcon": 722673,
	"./LocalDiningIcon": 876086,
	"./LocalDrinkIcon": 154927,
	"./LocalFloristIcon": 32441,
	"./LocalFloristOutlineIcon": 335925,
	"./LocalGasStationIcon": 394823,
	"./LocalGroceryStoreIcon": 826678,
	"./LocalHospitalIcon": 468886,
	"./LocalHotelIcon": 441522,
	"./LocalLaundryServiceIcon": 947430,
	"./LocalLibraryIcon": 369401,
	"./LocalMallIcon": 520829,
	"./LocalMoviesIcon": 607915,
	"./LocalOfferIcon": 843681,
	"./LocalParkingIcon": 199635,
	"./LocalPharmacyIcon": 947914,
	"./LocalPhoneIcon": 306437,
	"./LocalPizzaIcon": 59152,
	"./LocalPlayIcon": 752006,
	"./LocalPostOfficeIcon": 724612,
	"./LocalPrintshopIcon": 311055,
	"./LocalRestaurantIcon": 699603,
	"./LocalSeeIcon": 434534,
	"./LocalShippingIcon": 915366,
	"./LocalTaxiIcon": 396485,
	"./LocationCityIcon": 66815,
	"./LocationIcon": 20178,
	"./LocationOffIcon": 769665,
	"./LocationOnIcon": 118224,
	"./LocationSearchingIcon": 236861,
	"./LockAddIcon": 742530,
	"./LockAlertIcon": 906894,
	"./LockClockIcon": 284570,
	"./LockIcon": 200147,
	"./LockOpenIcon": 727650,
	"./LockOpenOutlineIcon": 615994,
	"./LockOutlineIcon": 645684,
	"./LockPatternIcon": 175334,
	"./LockPlusIcon": 228555,
	"./LockQuestionIcon": 41635,
	"./LockResetIcon": 86199,
	"./LockSmartIcon": 426025,
	"./LockWarningIcon": 443535,
	"./LockerIcon": 494176,
	"./LockerMultipleIcon": 412834,
	"./LockersIcon": 160542,
	"./LogicGateAndIcon": 867391,
	"./LogicGateNandIcon": 982488,
	"./LogicGateNorIcon": 863146,
	"./LogicGateNotIcon": 103121,
	"./LogicGateOrIcon": 942444,
	"./LogicGateXnorIcon": 931622,
	"./LogicGateXorIcon": 323758,
	"./LoginIcon": 995982,
	"./LoginVariantIcon": 442850,
	"./LogoutIcon": 44123,
	"./LogoutVariantIcon": 614015,
	"./LongitudeIcon": 766859,
	"./Looks3Icon": 589694,
	"./Looks4Icon": 60578,
	"./Looks5Icon": 564949,
	"./Looks6Icon": 427858,
	"./LooksIcon": 996215,
	"./LooksOneIcon": 71839,
	"./LooksTwoIcon": 68046,
	"./LoopIcon": 751827,
	"./LorryCheckIcon": 37988,
	"./LorryDeliveryIcon": 166555,
	"./LorryFastIcon": 710781,
	"./LorryIcon": 617210,
	"./LoupeIcon": 121984,
	"./LowBeamIcon": 513411,
	"./LowPriorityIcon": 494269,
	"./LowQualityIcon": 39572,
	"./LoyaltyIcon": 80375,
	"./LqIcon": 445127,
	"./LuckIcon": 705865,
	"./LuggageIcon": 802017,
	"./LumxIcon": 628233,
	"./LyftIcon": 785146,
	"./MagenDavidIcon": 984362,
	"./MagicIcon": 405365,
	"./MagnetIcon": 852958,
	"./MagnetOnIcon": 708684,
	"./MagnifyAddCursorIcon": 991478,
	"./MagnifyAddIcon": 14051,
	"./MagnifyAddOutlineIcon": 440212,
	"./MagnifyCloseIcon": 304029,
	"./MagnifyIcon": 918799,
	"./MagnifyMinusCursorIcon": 319161,
	"./MagnifyMinusIcon": 267852,
	"./MagnifyMinusOutlineIcon": 797172,
	"./MagnifyPlusCursorIcon": 329751,
	"./MagnifyPlusIcon": 337648,
	"./MagnifyPlusOutlineIcon": 662031,
	"./MailIcon": 3731,
	"./MailOutlineIcon": 364075,
	"./MailRuIcon": 393417,
	"./MailboxIcon": 729565,
	"./MailboxOpenIcon": 89201,
	"./MailboxOpenOutlineIcon": 601457,
	"./MailboxOpenUpIcon": 850175,
	"./MailboxOpenUpOutlineIcon": 696,
	"./MailboxOutlineIcon": 426330,
	"./MailboxUpIcon": 194896,
	"./MailboxUpOutlineIcon": 914793,
	"./ManChildIcon": 671444,
	"./ManIcon": 143888,
	"./ManManIcon": 671840,
	"./ManWomanIcon": 799805,
	"./ManufacturingIcon": 157858,
	"./MapAddIcon": 330484,
	"./MapCheckIcon": 787026,
	"./MapCheckOutlineIcon": 361150,
	"./MapClockIcon": 590491,
	"./MapClockOutlineIcon": 675951,
	"./MapIcon": 456665,
	"./MapLegendIcon": 500628,
	"./MapMarkerAlertIcon": 183294,
	"./MapMarkerAlertOutlineIcon": 791743,
	"./MapMarkerCheckIcon": 163849,
	"./MapMarkerCircleIcon": 520761,
	"./MapMarkerDistanceIcon": 8437,
	"./MapMarkerIcon": 50293,
	"./MapMarkerMinusIcon": 193102,
	"./MapMarkerMultipleIcon": 331574,
	"./MapMarkerOffIcon": 460057,
	"./MapMarkerOutlineIcon": 949138,
	"./MapMarkerPathIcon": 947093,
	"./MapMarkerPlusIcon": 800484,
	"./MapMarkerQuestionIcon": 928193,
	"./MapMarkerQuestionOutlineIcon": 562282,
	"./MapMarkerRadiusIcon": 241738,
	"./MapMarkerRemoveIcon": 773675,
	"./MapMarkerRemoveVariantIcon": 577603,
	"./MapMarkerTickIcon": 235987,
	"./MapMarkersIcon": 588826,
	"./MapMinusIcon": 950499,
	"./MapOutlineIcon": 607483,
	"./MapPlusIcon": 848791,
	"./MapSearchIcon": 709961,
	"./MapSearchOutlineIcon": 861848,
	"./MapTickIcon": 659047,
	"./MapTickOutlineIcon": 707057,
	"./MapboxIcon": 450997,
	"./MarginIcon": 351153,
	"./MarkdownIcon": 969264,
	"./MarkdownOutlineIcon": 599381,
	"./MarkerCancelIcon": 807733,
	"./MarkerCheckIcon": 251509,
	"./MarkerIcon": 253726,
	"./MarkerTickIcon": 818486,
	"./MarkunreadIcon": 725767,
	"./MartialArtsIcon": 621199,
	"./MartiniIcon": 226748,
	"./MaskedTransitionsIcon": 125038,
	"./MastodonIcon": 211220,
	"./MastodonVariantIcon": 66337,
	"./MaterialDesignIcon": 125885,
	"./MaterialUiIcon": 55691,
	"./MathCompassIcon": 287178,
	"./MathCompassVariantIcon": 310691,
	"./MathCosIcon": 711439,
	"./MathCosineIcon": 177792,
	"./MathSinIcon": 294006,
	"./MathSineIcon": 542004,
	"./MathTanIcon": 141758,
	"./MathTangentIcon": 773527,
	"./MathsCompassIcon": 959457,
	"./MathsCosIcon": 394197,
	"./MathsSinIcon": 594611,
	"./MathsTanIcon": 564504,
	"./MatrixIcon": 254087,
	"./MaxcdnIcon": 898832,
	"./MdiIcon": 562382,
	"./MeasuringTapeIcon": 631864,
	"./MedalIcon": 791791,
	"./MediaNetworkIcon": 604551,
	"./MediaNetworkOutlineIcon": 461772,
	"./MedicalBagIcon": 590409,
	"./MedicineIcon": 854706,
	"./MediumIcon": 936829,
	"./MediumQualityIcon": 936090,
	"./MeetupIcon": 130448,
	"./MegaphoneIcon": 597978,
	"./MegaphoneOutlineIcon": 371522,
	"./MemoryIcon": 690077,
	"./MenIcon": 858611,
	"./MenuDownIcon": 288251,
	"./MenuDownOutlineIcon": 812932,
	"./MenuIcon": 148889,
	"./MenuLeftIcon": 120735,
	"./MenuLeftOutlineIcon": 585488,
	"./MenuOpenIcon": 608445,
	"./MenuRightIcon": 531663,
	"./MenuRightOutlineIcon": 442245,
	"./MenuSwapIcon": 125474,
	"./MenuSwapOutlineIcon": 27703,
	"./MenuUpIcon": 593502,
	"./MenuUpOutlineIcon": 796201,
	"./MergeIcon": 520176,
	"./MergeTypeIcon": 166173,
	"./MessageAddIcon": 282905,
	"./MessageAlertIcon": 308977,
	"./MessageAlertOutlineIcon": 203356,
	"./MessageBulletedIcon": 894309,
	"./MessageBulletedOffIcon": 89747,
	"./MessageDrawIcon": 38242,
	"./MessageGroupIcon": 541962,
	"./MessageIcon": 3803,
	"./MessageImageIcon": 607147,
	"./MessageOutlineIcon": 360069,
	"./MessagePlusIcon": 340862,
	"./MessageProcessingIcon": 229279,
	"./MessageReplyIcon": 107788,
	"./MessageReplyTextIcon": 125957,
	"./MessageSettingsIcon": 533924,
	"./MessageSettingsVariantIcon": 399419,
	"./MessageTextIcon": 581688,
	"./MessageTextOutlineIcon": 572692,
	"./MessageVideoIcon": 708665,
	"./MessageWarningIcon": 146218,
	"./MessageWarningOutlineIcon": 540995,
	"./MeteorIcon": 997000,
	"./MetroIcon": 287037,
	"./MetroVariantIcon": 207584,
	"./MetronomeIcon": 404710,
	"./MetronomeTickIcon": 432623,
	"./MicNoneIcon": 661768,
	"./MicOffIcon": 124948,
	"./MicroSdIcon": 248234,
	"./MicrophoneAddIcon": 200222,
	"./MicrophoneIcon": 235316,
	"./MicrophoneMessageIcon": 332228,
	"./MicrophoneMessageOffIcon": 783839,
	"./MicrophoneMinusIcon": 774401,
	"./MicrophoneOffIcon": 764057,
	"./MicrophoneOutlineIcon": 208902,
	"./MicrophonePlusIcon": 314666,
	"./MicrophoneRemoveIcon": 979929,
	"./MicrophoneSettingsIcon": 14632,
	"./MicrophoneVariantIcon": 606864,
	"./MicrophoneVariantOffIcon": 369465,
	"./MicroscopeIcon": 240520,
	"./MicrosoftDynamicsIcon": 749259,
	"./MicrosoftEdgeIcon": 887790,
	"./MicrosoftIcon": 795540,
	"./MicrosoftOfficeIcon": 298707,
	"./MicrosoftOnenoteIcon": 328714,
	"./MicrosoftOutlookIcon": 423883,
	"./MicrosoftWindowsClassicIcon": 988744,
	"./MicrosoftWindowsIcon": 568196,
	"./MicrosoftXamarinIcon": 433184,
	"./MicrosoftXamarinOutlineIcon": 656142,
	"./MicrowaveIcon": 279761,
	"./MicrowaveOvenIcon": 397100,
	"./MiddlewareIcon": 417113,
	"./MiddlewareOutlineIcon": 985783,
	"./MidiIcon": 697051,
	"./MidiPortIcon": 5528,
	"./MilestoneIcon": 582698,
	"./MineIcon": 400320,
	"./MinecraftIcon": 744625,
	"./MiniSdIcon": 882830,
	"./MinidiscIcon": 206500,
	"./MinusBoxIcon": 454030,
	"./MinusBoxOutlineIcon": 815095,
	"./MinusCircleIcon": 335609,
	"./MinusCircleOutlineIcon": 136345,
	"./MinusIcon": 610996,
	"./MinusNetworkIcon": 336426,
	"./MinusNetworkOutlineIcon": 433287,
	"./MixcloudIcon": 120139,
	"./MixedMartialArtsIcon": 170950,
	"./MixedRealityIcon": 486724,
	"./MixerIcon": 267405,
	"./MixerSettingsIcon": 467888,
	"./MmaIcon": 243188,
	"./MmsIcon": 281964,
	"./MobileDevicesIcon": 309192,
	"./MobileOffIcon": 945958,
	"./MobilePhoneAndroidIcon": 739543,
	"./MobilePhoneArrowDownIcon": 321179,
	"./MobilePhoneBasicIcon": 457326,
	"./MobilePhoneDockIcon": 678931,
	"./MobilePhoneEraseIcon": 381481,
	"./MobilePhoneIcon": 217490,
	"./MobilePhoneInformationIcon": 238396,
	"./MobilePhoneIphoneIcon": 98256,
	"./MobilePhoneKeyIcon": 323865,
	"./MobilePhoneLinkIcon": 458621,
	"./MobilePhoneLinkOffIcon": 890333,
	"./MobilePhoneLockIcon": 441537,
	"./MobilePhoneMessageIcon": 739547,
	"./MobilePhoneOffIcon": 973502,
	"./MobilePhoneSettingsIcon": 482585,
	"./MobilePhoneSettingsVariantIcon": 84990,
	"./MobilePhoneSoundIcon": 916284,
	"./MobilePhoneTextIcon": 148757,
	"./MobilePhoneWirelessIcon": 228042,
	"./ModeCommentIcon": 810912,
	"./ModeEditIcon": 211761,
	"./ModeEditOutlineIcon": 578311,
	"./MoleculeIcon": 159548,
	"./MomIcon": 446513,
	"./Money100Icon": 950154,
	"./MoneyIcon": 158512,
	"./MoneyOffIcon": 365158,
	"./MoneyUsdIcon": 507765,
	"./MonitorCellphoneIcon": 15448,
	"./MonitorCellphoneStarIcon": 134891,
	"./MonitorDashboardIcon": 499367,
	"./MonitorIcon": 26122,
	"./MonitorLockIcon": 285815,
	"./MonitorMobilePhoneIcon": 952428,
	"./MonitorMobilePhoneStarIcon": 612382,
	"./MonitorMultipleIcon": 886064,
	"./MonitorOffIcon": 373869,
	"./MonitorScreenshotIcon": 940612,
	"./MonitorSmartphoneIcon": 858809,
	"./MonitorSmartphoneStarIcon": 6594,
	"./MonitorSpeakerIcon": 567293,
	"./MonitorSpeakerOffIcon": 813313,
	"./MonitorStarIcon": 462226,
	"./MonitorsIcon": 537054,
	"./MoodIcon": 524234,
	"./MoonAndStarsIcon": 307580,
	"./MoonFirstQuarterIcon": 826266,
	"./MoonFullIcon": 678500,
	"./MoonLastQuarterIcon": 365570,
	"./MoonNewIcon": 876952,
	"./MoonWaningCrescentIcon": 132473,
	"./MoonWaningGibbousIcon": 50680,
	"./MoonWaxingCrescentIcon": 753074,
	"./MoonWaxingGibbousIcon": 114172,
	"./MoreCircleIcon": 426071,
	"./MoreCircleOutlineIcon": 949599,
	"./MoreHorizIcon": 438784,
	"./MoreIcon": 971139,
	"./MoreVertIcon": 105327,
	"./MotherIcon": 892204,
	"./MotherNurseIcon": 40569,
	"./MotionDetectorIcon": 408207,
	"./MotionIcon": 226741,
	"./MotionSensorIcon": 783305,
	"./MotorIcon": 500809,
	"./MotorOffIcon": 764047,
	"./MotorOffOutlineIcon": 474795,
	"./MotorOutlineIcon": 411895,
	"./MotorbikeIcon": 649647,
	"./MotorcycleIcon": 965526,
	"./MotorwayIcon": 891498,
	"./MountainIcon": 798500,
	"./MouseBluetoothIcon": 149175,
	"./MouseIcon": 177626,
	"./MouseOffIcon": 167192,
	"./MouseVariantIcon": 10468,
	"./MouseVariantOffIcon": 639555,
	"./MoveResizeIcon": 493812,
	"./MoveResizeVariantIcon": 786182,
	"./MoveToInboxIcon": 226097,
	"./MovieCreationIcon": 420217,
	"./MovieIcon": 828564,
	"./MovieOutlineIcon": 513927,
	"./MovieRollIcon": 488532,
	"./MozillaFirefoxIcon": 538574,
	"./MqIcon": 986050,
	"./MuffinIcon": 368805,
	"./MultiplicationBoxIcon": 397448,
	"./MultiplicationIcon": 118595,
	"./MultiplyBoxIcon": 335822,
	"./MultiplyCircleIcon": 8090,
	"./MultiplyIcon": 921662,
	"./MultiplyOctagonIcon": 92361,
	"./MumIcon": 59476,
	"./MuseumIcon": 21174,
	"./MuseumOutlineIcon": 533910,
	"./MushroomIcon": 601863,
	"./MushroomOutlineIcon": 343070,
	"./MusicAccidentalDoubleFlatIcon": 765622,
	"./MusicAccidentalDoubleSharpIcon": 209422,
	"./MusicAccidentalFlatIcon": 561779,
	"./MusicAccidentalNaturalIcon": 26562,
	"./MusicAccidentalSharpIcon": 18309,
	"./MusicBoxIcon": 345035,
	"./MusicBoxOutlineIcon": 666369,
	"./MusicCClefIcon": 538049,
	"./MusicCircleIcon": 43628,
	"./MusicCircleOutlineIcon": 219193,
	"./MusicClefAltoIcon": 724911,
	"./MusicClefBaritoneIcon": 857234,
	"./MusicClefBassIcon": 313675,
	"./MusicClefSopranoIcon": 680038,
	"./MusicClefTenorIcon": 752896,
	"./MusicClefTrebleIcon": 513370,
	"./MusicFClefIcon": 301911,
	"./MusicGClefIcon": 851954,
	"./MusicIcon": 773579,
	"./MusicNoteAddIcon": 476645,
	"./MusicNoteBluetoothIcon": 139629,
	"./MusicNoteBluetoothOffIcon": 525553,
	"./MusicNoteEighthDottedIcon": 403735,
	"./MusicNoteEighthIcon": 83454,
	"./MusicNoteHalfDottedIcon": 537696,
	"./MusicNoteHalfIcon": 780822,
	"./MusicNoteIcon": 738329,
	"./MusicNoteOffIcon": 475600,
	"./MusicNoteOffOutlineIcon": 808432,
	"./MusicNoteOutlineIcon": 734550,
	"./MusicNotePlusIcon": 707310,
	"./MusicNoteQuarterDottedIcon": 500797,
	"./MusicNoteQuarterIcon": 772578,
	"./MusicNoteSixteenthDottedIcon": 810759,
	"./MusicNoteSixteenthIcon": 589154,
	"./MusicNoteWholeDottedIcon": 836429,
	"./MusicNoteWholeIcon": 719372,
	"./MusicOffIcon": 463823,
	"./MusicRestEighthIcon": 139998,
	"./MusicRestHalfIcon": 801942,
	"./MusicRestQuarterIcon": 614178,
	"./MusicRestSixteenthIcon": 934670,
	"./MusicRestWholeIcon": 277090,
	"./MuteIcon": 327133,
	"./MyLocationIcon": 378138,
	"./NailIcon": 697893,
	"./NairaIcon": 14792,
	"./NasIcon": 978128,
	"./NativescriptIcon": 532989,
	"./NatureIcon": 340699,
	"./NaturePeopleIcon": 507291,
	"./NavigateBeforeIcon": 743625,
	"./NavigateNextIcon": 313113,
	"./NavigationIcon": 175153,
	"./NearFieldCommunicationIcon": 85419,
	"./NearFieldCommunicationTapIcon": 441625,
	"./NearFieldCommunicationVariantIcon": 480780,
	"./NearMeIcon": 932899,
	"./NeatoIcon": 471050,
	"./NecklaceIcon": 311328,
	"./NeedleIcon": 424353,
	"./NeighbourhoodIcon": 3750,
	"./NestIcon": 154099,
	"./NestProtectIcon": 558678,
	"./NetflixIcon": 779880,
	"./NetworkAttachedStorageIcon": 96771,
	"./NetworkFavouriteIcon": 202336,
	"./NetworkIcon": 380106,
	"./NetworkOffIcon": 376019,
	"./NetworkOffOutlineIcon": 20067,
	"./NetworkOutlineIcon": 859352,
	"./NetworkStrength0Icon": 462882,
	"./NetworkStrength1AlertIcon": 124257,
	"./NetworkStrength1Icon": 285899,
	"./NetworkStrength1WarningIcon": 931936,
	"./NetworkStrength2AlertIcon": 444513,
	"./NetworkStrength2Icon": 983957,
	"./NetworkStrength2WarningIcon": 906722,
	"./NetworkStrength3AlertIcon": 169762,
	"./NetworkStrength3Icon": 692842,
	"./NetworkStrength3WarningIcon": 558856,
	"./NetworkStrength4AlertIcon": 866405,
	"./NetworkStrength4Icon": 469157,
	"./NetworkStrength4WarningIcon": 315050,
	"./NetworkStrengthOffIcon": 321299,
	"./NetworkStrengthOffOutlineIcon": 487168,
	"./NetworkStrengthOutlineIcon": 217932,
	"./NeutralIcon": 149384,
	"./NewBoxIcon": 543534,
	"./NewReleasesIcon": 10113,
	"./NewTaiwanDollarIcon": 921873,
	"./NewspaperIcon": 728860,
	"./NewspaperMinusIcon": 712191,
	"./NewspaperPlusIcon": 510117,
	"./NextTitleIcon": 890634,
	"./NfcIcon": 102410,
	"./NfcOffIcon": 685576,
	"./NfcSearchVariantIcon": 278506,
	"./NfcTapIcon": 532524,
	"./NfcVariantIcon": 896223,
	"./NfcVariantOffIcon": 720379,
	"./NightSkyIcon": 874922,
	"./NinjaIcon": 346387,
	"./NintendoSwitchIcon": 388502,
	"./NintendoSwitchOnlineIcon": 209711,
	"./NintendoWiiIcon": 206406,
	"./NintendoWiiuIcon": 525099,
	"./NoEntryIcon": 799223,
	"./NoSmokingIcon": 360932,
	"./NodejsIcon": 965982,
	"./NotEqualIcon": 635126,
	"./NotEqualVariantIcon": 290845,
	"./NoteAddIcon": 243715,
	"./NoteAddOutlineIcon": 941081,
	"./NoteCircleIcon": 286381,
	"./NoteIcon": 264012,
	"./NoteMultipleIcon": 119124,
	"./NoteMultipleOutlineIcon": 765511,
	"./NoteOutlineIcon": 59401,
	"./NotePlusIcon": 27899,
	"./NotePlusOutlineIcon": 178400,
	"./NoteTextIcon": 274163,
	"./NotebookIcon": 44365,
	"./NotebookMultipleIcon": 737781,
	"./NotebookOutlineIcon": 45968,
	"./NotesIcon": 886283,
	"./NotesOutlineIcon": 926993,
	"./NoticeBoardIcon": 638356,
	"./NotificationClearAllIcon": 803373,
	"./NotificationsActiveIcon": 8602,
	"./NotificationsIcon": 805254,
	"./NotificationsNoneIcon": 637158,
	"./NotificationsOffIcon": 752316,
	"./NotificationsPausedIcon": 944446,
	"./NpmIcon": 223617,
	"./NpmVariantIcon": 18570,
	"./NpmVariantOutlineIcon": 913032,
	"./NuclearIcon": 301097,
	"./NukeIcon": 579951,
	"./NullIcon": 812650,
	"./Number0BoxIcon": 627161,
	"./Number0BoxMultipleOutlineIcon": 755647,
	"./Number0BoxOutlineIcon": 316486,
	"./Number0CircleIcon": 424742,
	"./Number0CircleOutlineIcon": 565364,
	"./Number0Icon": 783956,
	"./Number1BoxIcon": 606027,
	"./Number1BoxMultipleOutlineIcon": 70414,
	"./Number1BoxOutlineIcon": 842732,
	"./Number1CircleIcon": 689202,
	"./Number1CircleOutlineIcon": 18457,
	"./Number1Icon": 440070,
	"./Number2BoxIcon": 931016,
	"./Number2BoxMultipleOutlineIcon": 171155,
	"./Number2BoxOutlineIcon": 726653,
	"./Number2CircleIcon": 132836,
	"./Number2CircleOutlineIcon": 371735,
	"./Number2Icon": 354556,
	"./Number3BoxIcon": 894548,
	"./Number3BoxMultipleOutlineIcon": 187193,
	"./Number3BoxOutlineIcon": 98597,
	"./Number3CircleIcon": 714961,
	"./Number3CircleOutlineIcon": 770459,
	"./Number3Icon": 580314,
	"./Number4BoxIcon": 536314,
	"./Number4BoxMultipleOutlineIcon": 778980,
	"./Number4BoxOutlineIcon": 400139,
	"./Number4CircleIcon": 635752,
	"./Number4CircleOutlineIcon": 927378,
	"./Number4Icon": 605929,
	"./Number5BoxIcon": 87342,
	"./Number5BoxMultipleOutlineIcon": 357252,
	"./Number5BoxOutlineIcon": 252745,
	"./Number5CircleIcon": 364340,
	"./Number5CircleOutlineIcon": 671818,
	"./Number5Icon": 589585,
	"./Number6BoxIcon": 867037,
	"./Number6BoxMultipleOutlineIcon": 433959,
	"./Number6BoxOutlineIcon": 617465,
	"./Number6CircleIcon": 791613,
	"./Number6CircleOutlineIcon": 579465,
	"./Number6Icon": 752734,
	"./Number7BoxIcon": 772902,
	"./Number7BoxMultipleOutlineIcon": 620693,
	"./Number7BoxOutlineIcon": 676402,
	"./Number7CircleIcon": 713105,
	"./Number7CircleOutlineIcon": 744095,
	"./Number7Icon": 502807,
	"./Number8BoxIcon": 855870,
	"./Number8BoxMultipleOutlineIcon": 596144,
	"./Number8BoxOutlineIcon": 245978,
	"./Number8CircleIcon": 29390,
	"./Number8CircleOutlineIcon": 373276,
	"./Number8Icon": 166167,
	"./Number9BoxIcon": 596167,
	"./Number9BoxMultipleOutlineIcon": 595260,
	"./Number9BoxOutlineIcon": 887988,
	"./Number9CircleIcon": 891556,
	"./Number9CircleOutlineIcon": 714207,
	"./Number9Icon": 222757,
	"./Number9PlusBoxIcon": 837069,
	"./Number9PlusBoxMultipleOutlineIcon": 115353,
	"./Number9PlusBoxOutlineIcon": 980298,
	"./Number9PlusCircleIcon": 369457,
	"./Number9PlusCircleOutlineIcon": 67661,
	"./NumberEightCircleIcon": 28688,
	"./NumberEightCircleOutlineIcon": 16291,
	"./NumberFiveCircleIcon": 399817,
	"./NumberFiveCircleOutlineIcon": 448101,
	"./NumberFourCircleIcon": 521461,
	"./NumberFourCircleOutlineIcon": 787584,
	"./NumberNineCircleIcon": 724528,
	"./NumberNineCircleOutlineIcon": 879609,
	"./NumberNinePlusCircleIcon": 319186,
	"./NumberNinePlusCircleOutlineIcon": 271167,
	"./NumberOneCircleIcon": 716434,
	"./NumberOneCircleOutlineIcon": 525873,
	"./NumberSevenCircleIcon": 345175,
	"./NumberSevenCircleOutlineIcon": 449541,
	"./NumberSixCircleIcon": 553330,
	"./NumberSixCircleOutlineIcon": 975599,
	"./NumberThreeCircleIcon": 705158,
	"./NumberThreeCircleOutlineIcon": 188638,
	"./NumberTwoCircleIcon": 658627,
	"./NumberTwoCircleOutlineIcon": 855763,
	"./NumberZeroCircleIcon": 399241,
	"./NumberZeroCircleOutlineIcon": 287509,
	"./NumbersIcon": 376562,
	"./Numeric0BoxIcon": 119134,
	"./Numeric0BoxMultipleIcon": 122211,
	"./Numeric0BoxMultipleOutlineIcon": 382477,
	"./Numeric0BoxOutlineIcon": 768587,
	"./Numeric0BoxesOutlineIcon": 629502,
	"./Numeric0CircleIcon": 310060,
	"./Numeric0CircleOutlineIcon": 227856,
	"./Numeric0Icon": 796114,
	"./Numeric10BoxIcon": 107362,
	"./Numeric10BoxOutlineIcon": 229155,
	"./Numeric1BoxIcon": 239354,
	"./Numeric1BoxMultipleIcon": 498436,
	"./Numeric1BoxMultipleOutlineIcon": 2033,
	"./Numeric1BoxOutlineIcon": 973165,
	"./Numeric1BoxesOutlineIcon": 202432,
	"./Numeric1CircleIcon": 71594,
	"./Numeric1CircleOutlineIcon": 628352,
	"./Numeric1Icon": 483061,
	"./Numeric2BoxIcon": 971890,
	"./Numeric2BoxMultipleIcon": 138999,
	"./Numeric2BoxMultipleOutlineIcon": 704031,
	"./Numeric2BoxOutlineIcon": 867146,
	"./Numeric2BoxesOutlineIcon": 247655,
	"./Numeric2CircleIcon": 64135,
	"./Numeric2CircleOutlineIcon": 82340,
	"./Numeric2Icon": 809491,
	"./Numeric3BoxIcon": 361638,
	"./Numeric3BoxMultipleIcon": 228639,
	"./Numeric3BoxMultipleOutlineIcon": 458359,
	"./Numeric3BoxOutlineIcon": 833977,
	"./Numeric3BoxesOutlineIcon": 156454,
	"./Numeric3CircleIcon": 366846,
	"./Numeric3CircleOutlineIcon": 786687,
	"./Numeric3Icon": 221256,
	"./Numeric4BoxIcon": 435568,
	"./Numeric4BoxMultipleIcon": 426630,
	"./Numeric4BoxMultipleOutlineIcon": 583512,
	"./Numeric4BoxOutlineIcon": 127175,
	"./Numeric4BoxesOutlineIcon": 238406,
	"./Numeric4CircleIcon": 464549,
	"./Numeric4CircleOutlineIcon": 789665,
	"./Numeric4Icon": 521101,
	"./Numeric5BoxIcon": 890657,
	"./Numeric5BoxMultipleIcon": 818894,
	"./Numeric5BoxMultipleOutlineIcon": 46535,
	"./Numeric5BoxOutlineIcon": 917585,
	"./Numeric5BoxesOutlineIcon": 231872,
	"./Numeric5CircleIcon": 774390,
	"./Numeric5CircleOutlineIcon": 817506,
	"./Numeric5Icon": 350017,
	"./Numeric6BoxIcon": 816408,
	"./Numeric6BoxMultipleIcon": 116347,
	"./Numeric6BoxMultipleOutlineIcon": 668919,
	"./Numeric6BoxOutlineIcon": 403490,
	"./Numeric6BoxesOutlineIcon": 532689,
	"./Numeric6CircleIcon": 415173,
	"./Numeric6CircleOutlineIcon": 684591,
	"./Numeric6Icon": 603407,
	"./Numeric7BoxIcon": 120310,
	"./Numeric7BoxMultipleIcon": 254306,
	"./Numeric7BoxMultipleOutlineIcon": 217937,
	"./Numeric7BoxOutlineIcon": 74706,
	"./Numeric7BoxesOutlineIcon": 828705,
	"./Numeric7CircleIcon": 471953,
	"./Numeric7CircleOutlineIcon": 367141,
	"./Numeric7Icon": 55371,
	"./Numeric8BoxIcon": 373798,
	"./Numeric8BoxMultipleIcon": 81728,
	"./Numeric8BoxMultipleOutlineIcon": 224946,
	"./Numeric8BoxOutlineIcon": 68932,
	"./Numeric8BoxesOutlineIcon": 446481,
	"./Numeric8CircleIcon": 827807,
	"./Numeric8CircleOutlineIcon": 55196,
	"./Numeric8Icon": 791968,
	"./Numeric9BoxIcon": 198098,
	"./Numeric9BoxMultipleIcon": 793614,
	"./Numeric9BoxMultipleOutlineIcon": 36827,
	"./Numeric9BoxOutlineIcon": 741526,
	"./Numeric9BoxesOutlineIcon": 37295,
	"./Numeric9CircleIcon": 391460,
	"./Numeric9CircleOutlineIcon": 920674,
	"./Numeric9Icon": 396003,
	"./Numeric9PlusBoxIcon": 867685,
	"./Numeric9PlusBoxMultipleIcon": 755998,
	"./Numeric9PlusBoxMultipleOutlineIcon": 605193,
	"./Numeric9PlusBoxOutlineIcon": 454658,
	"./Numeric9PlusBoxesOutlineIcon": 467999,
	"./Numeric9PlusCircleIcon": 118765,
	"./Numeric9PlusCircleOutlineIcon": 644723,
	"./NumericEightBoxIcon": 698240,
	"./NumericEightBoxMultipleOutlineIcon": 594860,
	"./NumericEightBoxOutlineIcon": 998044,
	"./NumericEightCircleIcon": 318341,
	"./NumericEightCircleOutlineIcon": 583365,
	"./NumericEightIcon": 107182,
	"./NumericFiveBoxIcon": 643865,
	"./NumericFiveBoxMultipleOutlineIcon": 300044,
	"./NumericFiveBoxOutlineIcon": 185397,
	"./NumericFiveCircleIcon": 106743,
	"./NumericFiveCircleOutlineIcon": 358743,
	"./NumericFiveIcon": 28970,
	"./NumericFourBoxIcon": 38187,
	"./NumericFourBoxMultipleOutlineIcon": 301149,
	"./NumericFourBoxOutlineIcon": 443424,
	"./NumericFourCircleIcon": 298095,
	"./NumericFourCircleOutlineIcon": 144700,
	"./NumericFourIcon": 231247,
	"./NumericIcon": 949091,
	"./NumericNineBoxIcon": 519478,
	"./NumericNineBoxMultipleOutlineIcon": 849300,
	"./NumericNineBoxOutlineIcon": 982325,
	"./NumericNineCircleIcon": 127467,
	"./NumericNineCircleOutlineIcon": 374847,
	"./NumericNineIcon": 822889,
	"./NumericNinePlusBoxIcon": 290948,
	"./NumericNinePlusBoxMultipleOutlineIcon": 82307,
	"./NumericNinePlusBoxOutlineIcon": 616722,
	"./NumericNinePlusCircleIcon": 482731,
	"./NumericNinePlusCircleOutlineIcon": 479669,
	"./NumericOneBoxIcon": 809957,
	"./NumericOneBoxMultipleOutlineIcon": 920415,
	"./NumericOneBoxOutlineIcon": 257979,
	"./NumericOneCircleIcon": 906413,
	"./NumericOneCircleOutlineIcon": 522021,
	"./NumericOneIcon": 898060,
	"./NumericSevenBoxIcon": 803719,
	"./NumericSevenBoxMultipleOutlineIcon": 395566,
	"./NumericSevenBoxOutlineIcon": 968839,
	"./NumericSevenCircleIcon": 171945,
	"./NumericSevenCircleOutlineIcon": 299229,
	"./NumericSevenIcon": 174083,
	"./NumericSixBoxIcon": 663687,
	"./NumericSixBoxMultipleOutlineIcon": 324949,
	"./NumericSixBoxOutlineIcon": 742547,
	"./NumericSixCircleIcon": 282553,
	"./NumericSixCircleOutlineIcon": 605120,
	"./NumericSixIcon": 513881,
	"./NumericThreeBoxIcon": 661872,
	"./NumericThreeBoxMultipleOutlineIcon": 786286,
	"./NumericThreeBoxOutlineIcon": 546279,
	"./NumericThreeCircleIcon": 321101,
	"./NumericThreeCircleOutlineIcon": 472803,
	"./NumericThreeIcon": 755846,
	"./NumericTwoBoxIcon": 208675,
	"./NumericTwoBoxMultipleOutlineIcon": 121589,
	"./NumericTwoBoxOutlineIcon": 701625,
	"./NumericTwoCircleIcon": 440712,
	"./NumericTwoCircleOutlineIcon": 61937,
	"./NumericTwoIcon": 375633,
	"./NumericZeroBoxIcon": 277635,
	"./NumericZeroBoxMultipleOutlineIcon": 593473,
	"./NumericZeroBoxOutlineIcon": 985975,
	"./NumericZeroCircleIcon": 612280,
	"./NumericZeroCircleOutlineIcon": 485461,
	"./NumericZeroIcon": 495445,
	"./NutIcon": 389788,
	"./NutritionIcon": 177930,
	"./OarIcon": 756364,
	"./ObelusIcon": 980680,
	"./OcarinaIcon": 756317,
	"./OceanIcon": 117893,
	"./OctagonIcon": 840826,
	"./OctagonOutlineIcon": 204697,
	"./OctagramIcon": 53687,
	"./OctagramOutlineIcon": 705608,
	"./OdnoklassnikiIcon": 121554,
	"./OdometerIcon": 382311,
	"./OfficeBuildingIcon": 439798,
	"./OfficeIcon": 798693,
	"./OfflineBoltIcon": 746920,
	"./OhmIcon": 160286,
	"./OilIcon": 238679,
	"./OilLampIcon": 395713,
	"./OilTemperatureIcon": 512230,
	"./OkRuIcon": 533799,
	"./OmIcon": 364115,
	"./OmegaIcon": 665125,
	"./OneTwoThreeIcon": 895419,
	"./OneUpIcon": 239255,
	"./OnedriveIcon": 385931,
	"./OnenoteIcon": 893919,
	"./OnepasswordIcon": 961353,
	"./OpacityIcon": 766682,
	"./OpenInAppIcon": 842143,
	"./OpenInBrowserIcon": 39445,
	"./OpenInNewIcon": 728879,
	"./OpenSourceInitiativeIcon": 562776,
	"./OpenidIcon": 87182,
	"./OperaIcon": 505357,
	"./OrbitIcon": 990289,
	"./OriginIcon": 693148,
	"./OrnamentIcon": 243882,
	"./OrnamentVariantIcon": 16586,
	"./OuterJoinLeftIcon": 697509,
	"./OuterJoinRightIcon": 575756,
	"./OutlookIcon": 871773,
	"./OvenIcon": 255318,
	"./OwlIcon": 791414,
	"./OxygenTankIcon": 730420,
	"./PacManIcon": 306534,
	"./PackageDownIcon": 646156,
	"./PackageIcon": 446702,
	"./PackageUpIcon": 20805,
	"./PackageVariantClosedIcon": 476727,
	"./PackageVariantIcon": 230555,
	"./PageFirstIcon": 714603,
	"./PageLastIcon": 683434,
	"./PageLayoutBodyIcon": 273797,
	"./PageLayoutFooterIcon": 465778,
	"./PageLayoutHeaderFooterIcon": 499059,
	"./PageLayoutHeaderIcon": 251587,
	"./PageLayoutMarginalsIcon": 641782,
	"./PageLayoutSidebarLeftIcon": 238857,
	"./PageLayoutSidebarRightIcon": 45446,
	"./PageNextIcon": 917523,
	"./PageNextOutlineIcon": 367700,
	"./PagePreviousIcon": 539554,
	"./PagePreviousOutlineIcon": 233850,
	"./PaintBucketIcon": 230186,
	"./PaintIcon": 337400,
	"./PaintbrushIcon": 652595,
	"./PaletteAdvancedIcon": 195828,
	"./PaletteIcon": 841152,
	"./PaletteOutlineIcon": 234059,
	"./PaletteSwatchIcon": 143938,
	"./PanBottomLeftIcon": 128813,
	"./PanBottomRightIcon": 568336,
	"./PanDownIcon": 769247,
	"./PanDownLeftIcon": 931660,
	"./PanDownRightIcon": 402131,
	"./PanHorizontalIcon": 717583,
	"./PanIcon": 608639,
	"./PanLeftIcon": 294920,
	"./PanRightIcon": 547165,
	"./PanTopLeftIcon": 863238,
	"./PanTopRightIcon": 818979,
	"./PanUpIcon": 484741,
	"./PanUpLeftIcon": 344588,
	"./PanUpRightIcon": 950450,
	"./PanVerticalIcon": 666956,
	"./PandaIcon": 221182,
	"./PandoraIcon": 887105,
	"./PanoramaFisheyeIcon": 825958,
	"./PanoramaHorizontalIcon": 399990,
	"./PanoramaIcon": 991585,
	"./PanoramaVerticalIcon": 660815,
	"./PanoramaWideAngleIcon": 240908,
	"./PaperCutVerticalIcon": 118972,
	"./PaperIcon": 15731,
	"./PaperOutlineIcon": 229393,
	"./PaperclipHorizontalIcon": 325505,
	"./PaperclipIcon": 381553,
	"./ParachuteIcon": 460258,
	"./ParachuteOutlineIcon": 239927,
	"./ParasolIcon": 48925,
	"./ParkIcon": 701413,
	"./ParkingIcon": 754753,
	"./PassportBiometricIcon": 766534,
	"./PassportElectronicIcon": 80058,
	"./PassportIcon": 734408,
	"./PasswordResetIcon": 319505,
	"./PatioHeaterIcon": 307146,
	"./PatreonIcon": 688527,
	"./PauseCircleFilledIcon": 148375,
	"./PauseCircleIcon": 416793,
	"./PauseCircleOutlineIcon": 661690,
	"./PauseIcon": 315529,
	"./PauseOctagonIcon": 562921,
	"./PauseOctagonOutlineIcon": 254079,
	"./PawIcon": 713729,
	"./PawOffIcon": 281830,
	"./PaymentIcon": 68535,
	"./PaymentOnDeliveryIcon": 963973,
	"./PaymentSettingsIcon": 314476,
	"./PaypalIcon": 336328,
	"./PdfBoxIcon": 829775,
	"./PeaceIcon": 444440,
	"./PeakIcon": 613467,
	"./PegmanIcon": 420036,
	"./PenAddIcon": 500254,
	"./PenIcon": 45062,
	"./PenLockIcon": 114434,
	"./PenMinusIcon": 505931,
	"./PenOffIcon": 963874,
	"./PenPlusIcon": 903599,
	"./PenRemoveIcon": 141670,
	"./PencilAddIcon": 427592,
	"./PencilAddOutlineIcon": 175593,
	"./PencilBoxIcon": 618194,
	"./PencilBoxOutlineIcon": 88882,
	"./PencilCircleIcon": 282427,
	"./PencilCircleOutlineIcon": 357348,
	"./PencilIcon": 879367,
	"./PencilLockIcon": 602008,
	"./PencilLockOutlineIcon": 148830,
	"./PencilMinusIcon": 538396,
	"./PencilMinusOutlineIcon": 963800,
	"./PencilOffIcon": 394769,
	"./PencilOffOutlineIcon": 249890,
	"./PencilOutlineIcon": 359823,
	"./PencilPlusIcon": 500062,
	"./PencilPlusOutlineIcon": 687953,
	"./PencilRemoveIcon": 73822,
	"./PencilRemoveOutlineIcon": 743564,
	"./PenguinIcon": 423374,
	"./PentagonIcon": 813457,
	"./PentagonOutlineIcon": 932864,
	"./PeopleAddIcon": 187043,
	"./PeopleAddOutlineIcon": 144334,
	"./PeopleCheckIcon": 840233,
	"./PeopleGroupIcon": 821802,
	"./PeopleGroupOutlineIcon": 523331,
	"./PeopleIcon": 228440,
	"./PeopleMinusIcon": 315746,
	"./PeopleMinusOutlineIcon": 116833,
	"./PeopleOutlineIcon": 733101,
	"./PeoplePlusIcon": 748267,
	"./PeoplePlusOutlineIcon": 573054,
	"./PeopleSwitchIcon": 314710,
	"./PeopleTickIcon": 467249,
	"./PepperIcon": 77368,
	"./PercentIcon": 88745,
	"./PeriodicTableCarbonDioxideIcon": 704494,
	"./PeriodicTableCo2Icon": 327275,
	"./PeriodicTableIcon": 167640,
	"./PeriscopeIcon": 487170,
	"./PermIdentityIcon": 426432,
	"./PermMediaIcon": 217877,
	"./PersonAddIcon": 541324,
	"./PersonAddOutlineIcon": 293364,
	"./PersonCircleIcon": 732949,
	"./PersonCircleOutlineIcon": 459529,
	"./PersonClockIcon": 791794,
	"./PersonClockOutlineIcon": 957946,
	"./PersonConvertIcon": 450576,
	"./PersonDetailsIcon": 957820,
	"./PersonEditIcon": 108101,
	"./PersonGroupIcon": 420101,
	"./PersonGroupOutlineIcon": 199136,
	"./PersonHeartIcon": 647945,
	"./PersonHeartOutlineIcon": 616453,
	"./PersonHelpIcon": 293576,
	"./PersonHelpOutlineIcon": 209453,
	"./PersonIcon": 181127,
	"./PersonKeyIcon": 192852,
	"./PersonKeyOutlineIcon": 675664,
	"./PersonMinusIcon": 466995,
	"./PersonMinusOutlineIcon": 975795,
	"./PersonMultipleAddIcon": 296728,
	"./PersonMultipleAddOutlineIcon": 502489,
	"./PersonMultipleCheckIcon": 108739,
	"./PersonMultipleIcon": 590290,
	"./PersonMultipleMinusIcon": 279253,
	"./PersonMultipleMinusOutlineIcon": 957510,
	"./PersonMultiplePlusIcon": 414658,
	"./PersonMultiplePlusOutlineIcon": 113988,
	"./PersonMultipleTickIcon": 853552,
	"./PersonNetworkIcon": 410433,
	"./PersonNetworkOutlineIcon": 9039,
	"./PersonOffIcon": 468742,
	"./PersonOffOutlineIcon": 416929,
	"./PersonOutlineIcon": 594085,
	"./PersonPlusIcon": 931265,
	"./PersonPlusOutlineIcon": 403643,
	"./PersonQuestionIcon": 158334,
	"./PersonQuestionOutlineIcon": 120117,
	"./PersonRemoveIcon": 420853,
	"./PersonRemoveOutlineIcon": 49344,
	"./PersonSearchIcon": 849799,
	"./PersonSearchOutlineIcon": 981853,
	"./PersonSettingsIcon": 597381,
	"./PersonStarIcon": 815472,
	"./PersonStarOutlineIcon": 469281,
	"./PersonSupervisorCircleIcon": 524757,
	"./PersonSupervisorIcon": 76103,
	"./PersonSwitchIcon": 159834,
	"./PersonTieIcon": 278423,
	"./PerspectiveDecreaseIcon": 958786,
	"./PerspectiveIncreaseIcon": 977021,
	"./PerspectiveLessIcon": 689443,
	"./PerspectiveMoreIcon": 76210,
	"./PetrolPumpIcon": 265449,
	"./PetrolPumpOutlineIcon": 155628,
	"./PetrolStationIcon": 72437,
	"./PetrolStationOutlineIcon": 870213,
	"./PetsIcon": 366469,
	"./PharmacyIcon": 885304,
	"./PhilippinePesoIcon": 224959,
	"./PhoneAlertIcon": 540277,
	"./PhoneBluetoothIcon": 559530,
	"./PhoneBluetoothSpeakerIcon": 485218,
	"./PhoneClassicIcon": 84011,
	"./PhoneForwardIcon": 69551,
	"./PhoneForwardedIcon": 717290,
	"./PhoneHangupIcon": 709926,
	"./PhoneIcon": 187132,
	"./PhoneInTalkIcon": 967909,
	"./PhoneIncomingIcon": 991290,
	"./PhoneLockIcon": 712169,
	"./PhoneLockedIcon": 275731,
	"./PhoneLogIcon": 819287,
	"./PhoneMinusIcon": 914500,
	"./PhoneMissedIcon": 479403,
	"./PhoneOffIcon": 285800,
	"./PhoneOutgoingIcon": 854581,
	"./PhoneOutlineIcon": 661847,
	"./PhonePausedIcon": 785836,
	"./PhonePlusIcon": 335065,
	"./PhoneReturnIcon": 983799,
	"./PhoneRotateLandscapeIcon": 673734,
	"./PhoneRotatePortraitIcon": 331934,
	"./PhoneSettingsIcon": 714287,
	"./PhoneVoipIcon": 123942,
	"./PhonelinkEraseIcon": 356661,
	"./PhonelinkLockIcon": 473186,
	"./PhonelinkOffIcon": 317509,
	"./PhonelinkRingIcon": 245023,
	"./PhonelinkSetupIcon": 868057,
	"./PhotoAlbumIcon": 143037,
	"./PhotoCameraIcon": 929237,
	"./PhotoLibraryIcon": 375997,
	"./PhotographyIcon": 814306,
	"./PiBoxIcon": 834637,
	"./PiHoleIcon": 796100,
	"./PiIcon": 429284,
	"./PianoIcon": 847937,
	"./PickaxeIcon": 951236,
	"./PictureInPictureBottomRightIcon": 825233,
	"./PictureInPictureBottomRightOutlineIcon": 7114,
	"./PictureInPictureTopRightIcon": 688850,
	"./PictureInPictureTopRightOutlineIcon": 728120,
	"./PierCraneIcon": 686439,
	"./PierIcon": 766745,
	"./PigIcon": 626412,
	"./PillIcon": 973930,
	"./PillarIcon": 821622,
	"./PinIcon": 930391,
	"./PinOffIcon": 603020,
	"./PinOffOutlineIcon": 280427,
	"./PinOutlineIcon": 524306,
	"./PineTreeBoxIcon": 936272,
	"./PineTreeIcon": 774239,
	"./PinkyIcon": 799077,
	"./PinterestBoxIcon": 963743,
	"./PinterestIcon": 718115,
	"./PinwheelIcon": 800472,
	"./PinwheelOutlineIcon": 876410,
	"./PipeDisconnectedIcon": 598052,
	"./PipeIcon": 211883,
	"./PipeLeakIcon": 220853,
	"./PirateIcon": 944813,
	"./PistolIcon": 852370,
	"./PistonIcon": 133295,
	"./PizzaIcon": 605933,
	"./PizzeriaIcon": 15350,
	"./PlaceIcon": 774884,
	"./PlaneIcon": 861764,
	"./PlaneLandingIcon": 1305,
	"./PlaneOffIcon": 886147,
	"./PlaneShieldIcon": 750646,
	"./PlaneTakeoffIcon": 47698,
	"./PlanetIcon": 829271,
	"./PlantIcon": 358605,
	"./PlantOutlineIcon": 415708,
	"./PlasterIcon": 589027,
	"./PlayArrowIcon": 289781,
	"./PlayBoxOutlineIcon": 143994,
	"./PlayCircleFilledIcon": 981018,
	"./PlayCircleIcon": 894480,
	"./PlayCircleOutlineIcon": 873485,
	"./PlayIcon": 341635,
	"./PlayNetworkIcon": 776303,
	"./PlayNetworkOutlineIcon": 794405,
	"./PlayOutlineIcon": 413756,
	"./PlayPauseIcon": 970281,
	"./PlayProtectedContentIcon": 331491,
	"./PlaySpeedIcon": 494889,
	"./PlaylistAddCheckIcon": 632674,
	"./PlaylistAddIcon": 549191,
	"./PlaylistCheckIcon": 673935,
	"./PlaylistEditIcon": 59203,
	"./PlaylistMinusIcon": 201907,
	"./PlaylistMusicIcon": 984390,
	"./PlaylistMusicOutlineIcon": 987852,
	"./PlaylistNoteIcon": 545660,
	"./PlaylistNoteOutlineIcon": 90819,
	"./PlaylistPlayIcon": 747032,
	"./PlaylistPlusIcon": 768161,
	"./PlaylistRemoveIcon": 37835,
	"./PlaylistStarIcon": 143187,
	"./PlaylistTickIcon": 722625,
	"./PlaystationIcon": 334937,
	"./PlaystationNetworkIcon": 615949,
	"./PlexIcon": 679589,
	"./PlugSocketAuIcon": 510326,
	"./PlugSocketEuIcon": 360562,
	"./PlugSocketIcon": 201583,
	"./PlugSocketUkIcon": 201871,
	"./PlugSocketUsIcon": 17245,
	"./PlusBoxIcon": 693103,
	"./PlusBoxOutlineIcon": 172592,
	"./PlusCircleIcon": 684822,
	"./PlusCircleMultipleOutlineIcon": 962119,
	"./PlusCircleOutlineIcon": 640631,
	"./PlusCirclesOutlineIcon": 399342,
	"./PlusIcon": 422467,
	"./PlusMinusBoxIcon": 816706,
	"./PlusMinusIcon": 945888,
	"./PlusNetworkIcon": 972653,
	"./PlusNetworkOutlineIcon": 639687,
	"./PlusOneIcon": 50158,
	"./PlusOutlineIcon": 58977,
	"./PocketIcon": 298476,
	"./PodcastIcon": 251582,
	"./PodiumBronzeIcon": 436346,
	"./PodiumFirstIcon": 432180,
	"./PodiumGoldIcon": 663877,
	"./PodiumIcon": 330361,
	"./PodiumSecondIcon": 606962,
	"./PodiumSilverIcon": 874453,
	"./PodiumThirdIcon": 624473,
	"./PointOfSaleIcon": 284922,
	"./PokeballIcon": 674230,
	"./PokemonGoIcon": 153887,
	"./PokerChipIcon": 127784,
	"./PolaroidIcon": 471889,
	"./PollBoxIcon": 2861,
	"./PollIcon": 514429,
	"./PolymerIcon": 96719,
	"./PoolIcon": 428618,
	"./PoolRackIcon": 599865,
	"./PoolTableIcon": 746869,
	"./PoolTriangleIcon": 283639,
	"./PopcornIcon": 543069,
	"./PopsicleIcon": 105210,
	"./PostageStampIcon": 737459,
	"./PotIcon": 953842,
	"./PotMixIcon": 384532,
	"./PoundBoxIcon": 356709,
	"./PoundIcon": 503405,
	"./PowerBoxIcon": 326506,
	"./PowerCycleIcon": 319582,
	"./PowerIcon": 206963,
	"./PowerOffIcon": 191047,
	"./PowerOnIcon": 963622,
	"./PowerPlugIcon": 124343,
	"./PowerPlugOffIcon": 819103,
	"./PowerSettingsIcon": 437616,
	"./PowerSettingsNewIcon": 419953,
	"./PowerSleepIcon": 402825,
	"./PowerSocketArIcon": 459697,
	"./PowerSocketArgentinaIcon": 987829,
	"./PowerSocketAuIcon": 848252,
	"./PowerSocketAustraliaIcon": 405716,
	"./PowerSocketCaIcon": 568958,
	"./PowerSocketCanadaIcon": 115170,
	"./PowerSocketChinaIcon": 455335,
	"./PowerSocketCnIcon": 220049,
	"./PowerSocketCyIcon": 308486,
	"./PowerSocketCyprusIcon": 437742,
	"./PowerSocketEuIcon": 419158,
	"./PowerSocketEuropeIcon": 67287,
	"./PowerSocketHkIcon": 683443,
	"./PowerSocketHongKongIcon": 408348,
	"./PowerSocketIcon": 452518,
	"./PowerSocketIeIcon": 389404,
	"./PowerSocketIrelandIcon": 642995,
	"./PowerSocketJapanIcon": 172758,
	"./PowerSocketJpIcon": 505825,
	"./PowerSocketMalaysiaIcon": 426427,
	"./PowerSocketMaltaIcon": 265276,
	"./PowerSocketMexicoIcon": 597118,
	"./PowerSocketMtIcon": 926699,
	"./PowerSocketMxIcon": 444306,
	"./PowerSocketMyIcon": 950685,
	"./PowerSocketNewZealandIcon": 458489,
	"./PowerSocketNzIcon": 292138,
	"./PowerSocketPapuaNewGuineaIcon": 696249,
	"./PowerSocketPgIcon": 574697,
	"./PowerSocketSgIcon": 858761,
	"./PowerSocketSingaporeIcon": 175825,
	"./PowerSocketTypeBIcon": 493869,
	"./PowerSocketTypeGIcon": 660859,
	"./PowerSocketTypeIIcon": 382766,
	"./PowerSocketUkIcon": 186838,
	"./PowerSocketUnitedKingdomIcon": 592619,
	"./PowerSocketUnitedStatesIcon": 995407,
	"./PowerSocketUsIcon": 849414,
	"./PowerStandbyIcon": 935372,
	"./PowershellIcon": 245777,
	"./PregnantWomanIcon": 840631,
	"./PrescriptionIcon": 299775,
	"./PresentIcon": 861026,
	"./PresentationIcon": 386002,
	"./PresentationPlayIcon": 198872,
	"./PreviousTitleIcon": 861979,
	"./PrintPreviewIcon": 834303,
	"./Printer3dIcon": 585926,
	"./Printer3dNozzleIcon": 556391,
	"./Printer3dNozzleOutlineIcon": 888047,
	"./PrinterAlertIcon": 988452,
	"./PrinterIcon": 493227,
	"./PrinterOffIcon": 373850,
	"./PrinterSettingsIcon": 815047,
	"./PrinterWarningIcon": 639848,
	"./PrinterWirelessIcon": 564478,
	"./PriorityHighIcon": 642170,
	"./PriorityLowIcon": 565397,
	"./PrizeIcon": 562861,
	"./ProfessionalHexagonIcon": 955059,
	"./ProgressAlertIcon": 309416,
	"./ProgressCheckIcon": 849594,
	"./ProgressClockIcon": 33337,
	"./ProgressDownloadIcon": 435445,
	"./ProgressSpannerIcon": 592973,
	"./ProgressTickIcon": 475741,
	"./ProgressUploadIcon": 718749,
	"./ProgressWarningIcon": 760771,
	"./ProgressWrenchIcon": 548754,
	"./ProhibitedIcon": 925521,
	"./ProjectorIcon": 786165,
	"./ProjectorScreenIcon": 805639,
	"./ProximitySensorIcon": 456721,
	"./ProximitySensorOffIcon": 133721,
	"./ProxyAutoIcon": 799352,
	"./ProxyAutoOutlineIcon": 667983,
	"./ProxyIcon": 769172,
	"./ProxyOutlineIcon": 892311,
	"./PublicIcon": 613763,
	"./PublishIcon": 168302,
	"./PulseIcon": 694711,
	"./PumpkinCarvedIcon": 119222,
	"./PumpkinFaceIcon": 975491,
	"./PumpkinIcon": 460682,
	"./PurseIcon": 450903,
	"./PurseOutlineIcon": 930345,
	"./PuzzleIcon": 527913,
	"./PuzzleOutlineIcon": 935331,
	"./QiIcon": 776862,
	"./QqchatIcon": 743354,
	"./QrcodeEditIcon": 461938,
	"./QrcodeIcon": 948174,
	"./QrcodeScanIcon": 119053,
	"./QuadcopterIcon": 801044,
	"./QualityHighIcon": 912914,
	"./QualityLowIcon": 316402,
	"./QualityMediumIcon": 154512,
	"./QueryBuilderIcon": 543750,
	"./QuestionAnswerIcon": 628058,
	"./QuestionMarkBoxIcon": 889353,
	"./QuestionMarkCircleIcon": 59574,
	"./QuestionMarkCircleOutlineIcon": 214142,
	"./QuestionMarkIcon": 384651,
	"./QuestionMarkRhombusIcon": 869305,
	"./QuestionMarkRhombusOutlineIcon": 503700,
	"./QuestionNetworkIcon": 797396,
	"./QuestionNetworkOutlineIcon": 294142,
	"./QueueIcon": 610118,
	"./QueueMusicIcon": 961320,
	"./QueueMusicOutlineIcon": 707591,
	"./QuicktimeIcon": 61952,
	"./QuoraIcon": 813982,
	"./RabbitIcon": 648164,
	"./RacingHelmetIcon": 4349,
	"./RacquetballIcon": 496957,
	"./RadarIcon": 649584,
	"./RadiationIcon": 747022,
	"./RadiationOffIcon": 99530,
	"./RadiatorDisabledIcon": 986691,
	"./RadiatorIcon": 791410,
	"./RadiatorOffIcon": 966512,
	"./RadioAmIcon": 666662,
	"./RadioButtonCheckedIcon": 872038,
	"./RadioButtonUncheckedIcon": 581852,
	"./RadioFmIcon": 302786,
	"./RadioHandheldIcon": 916251,
	"./RadioIcon": 997519,
	"./RadioTowerIcon": 259888,
	"./RadioactiveIcon": 999682,
	"./RadioactiveOffIcon": 964635,
	"./RadioboxBlankIcon": 286747,
	"./RadioboxMarkedIcon": 824525,
	"./RadiusIcon": 441914,
	"./RadiusOutlineIcon": 229503,
	"./RailroadLightIcon": 359436,
	"./RainbowIcon": 190189,
	"./RankIcon": 39534,
	"./RaspberryPiIcon": 821945,
	"./RateReviewIcon": 691345,
	"./RayEndArrowIcon": 899263,
	"./RayEndIcon": 410122,
	"./RayStartArrowIcon": 832196,
	"./RayStartEndIcon": 591256,
	"./RayStartIcon": 996003,
	"./RayVertexIcon": 269745,
	"./RcaIcon": 957576,
	"./ReactIcon": 143978,
	"./ReadIcon": 813168,
	"./ReadMoreIcon": 247161,
	"./ReadMoreOutlineIcon": 586620,
	"./ReceiptIcon": 61392,
	"./RecentIcon": 322126,
	"./RecordCircleIcon": 717790,
	"./RecordCircleOutlineIcon": 372016,
	"./RecordIcon": 616956,
	"./RecordPlayerIcon": 742914,
	"./RecordRecIcon": 572580,
	"./RecordVoiceOverIcon": 943708,
	"./RectangleIcon": 604602,
	"./RectangleOutlineIcon": 198898,
	"./RecycleIcon": 358890,
	"./RedditIcon": 223733,
	"./RedeemIcon": 683997,
	"./RedoIcon": 659631,
	"./RedoVariantIcon": 682242,
	"./ReflectHorizontalIcon": 167987,
	"./ReflectVerticalIcon": 247719,
	"./RefreshIcon": 93756,
	"./RefrigeratorBottomIcon": 735686,
	"./RefrigeratorIcon": 320327,
	"./RefrigeratorOutlineIcon": 454334,
	"./RefrigeratorTopIcon": 62417,
	"./RegexIcon": 53695,
	"./RegisterIcon": 779420,
	"./RegisterOutlineIcon": 35725,
	"./RegisteredTrademarkIcon": 239759,
	"./RegistrationMarkIcon": 46835,
	"./RegularExpressionIcon": 643313,
	"./RelativeScaleIcon": 603484,
	"./ReligionBuddhistIcon": 768498,
	"./ReligionChristianIcon": 224668,
	"./ReligionChristianOutlineIcon": 741667,
	"./ReligionHinduIcon": 740895,
	"./ReligionIslamicIcon": 503017,
	"./ReligionJudaicIcon": 102238,
	"./ReligionMuslimIcon": 843308,
	"./ReloadIcon": 355499,
	"./ReminderIcon": 4198,
	"./RemoteDesktopIcon": 706611,
	"./RemoteIcon": 626936,
	"./RemoteOffIcon": 559737,
	"./RemoteTvIcon": 83913,
	"./RemoteTvOffIcon": 18734,
	"./RemoveCircleIcon": 117543,
	"./RemoveCircleOutlineIcon": 736367,
	"./RemoveIcon": 393110,
	"./RemoveRedEyeIcon": 458066,
	"./RemoveShoppingCartIcon": 364953,
	"./RenameBoxIcon": 678196,
	"./RenameIcon": 258688,
	"./RenminbiIcon": 472324,
	"./RentACarIcon": 67782,
	"./ReorderHorizontalIcon": 684218,
	"./ReorderVerticalIcon": 944895,
	"./RepeatIcon": 461339,
	"./RepeatOffIcon": 249023,
	"./RepeatOnceIcon": 72099,
	"./RepeatOneIcon": 485046,
	"./ReplayIcon": 509176,
	"./ReplyAllIcon": 283900,
	"./ReplyAllOutlineIcon": 492140,
	"./ReplyIcon": 624754,
	"./ReplyOutlineIcon": 192303,
	"./ReportIcon": 761592,
	"./ReportProblemIcon": 947436,
	"./ReproductionIcon": 57040,
	"./ResistorIcon": 746822,
	"./ResistorNodesIcon": 852571,
	"./ResizeBottomRightIcon": 400229,
	"./ResizeHorizontalIcon": 740533,
	"./ResizeIcon": 706189,
	"./ResizeVerticalIcon": 592502,
	"./ResponsiveIcon": 40102,
	"./RestartIcon": 742325,
	"./RestartOffIcon": 450192,
	"./RestaurantIcon": 647277,
	"./RestaurantMenuIcon": 757738,
	"./RestoreClockIcon": 429917,
	"./RestoreFromTrashIcon": 602435,
	"./RestoreIcon": 587639,
	"./RestorePageIcon": 264525,
	"./ResumeIcon": 836021,
	"./ReverseIcon": 763043,
	"./Rewind10Icon": 508642,
	"./Rewind30Icon": 629803,
	"./RewindIcon": 620635,
	"./RewindOutlineIcon": 920693,
	"./RhombusIcon": 206777,
	"./RhombusMediumIcon": 563470,
	"./RhombusOutlineIcon": 888953,
	"./RhombusSplitIcon": 496497,
	"./RibbonIcon": 689784,
	"./RiceIcon": 434791,
	"./RingIcon": 87583,
	"./RivetIcon": 993792,
	"./RoadIcon": 143628,
	"./RoadVariantIcon": 936169,
	"./RobotIcon": 898362,
	"./RobotIndustrialIcon": 143474,
	"./RobotVacuumIcon": 446534,
	"./RobotVacuumVariantIcon": 285357,
	"./RocketIcon": 269610,
	"./RollerSkateIcon": 546869,
	"./RollerbladeIcon": 387481,
	"./RollupjsIcon": 174279,
	"./RoomIcon": 606579,
	"./RoomServiceIcon": 24416,
	"./RoomServiceOutlineIcon": 492569,
	"./RoombaIcon": 247040,
	"./Rotate3dIcon": 156201,
	"./Rotate3dVariantIcon": 217384,
	"./Rotate90DegreesCcwIcon": 193416,
	"./RotateLeftIcon": 906274,
	"./RotateLeftVariantIcon": 94937,
	"./RotateOrbitIcon": 791965,
	"./RotateRightIcon": 338981,
	"./RotateRightVariantIcon": 970889,
	"./RoundedCornerIcon": 116866,
	"./RouterWirelessIcon": 795282,
	"./RouterWirelessSettingsIcon": 972369,
	"./RoutesIcon": 959647,
	"./RowingIcon": 537965,
	"./RssBoxIcon": 134644,
	"./RssFeedBoxIcon": 152228,
	"./RssFeedIcon": 66435,
	"./RssIcon": 652708,
	"./RssOffIcon": 636195,
	"./RubbishBinCircleIcon": 363351,
	"./RubbishBinCircleOutlineIcon": 666318,
	"./RubbishBinEmptyIcon": 754553,
	"./RubbishBinIcon": 517818,
	"./RubbishBinOutlineIcon": 832579,
	"./RubbishCircleIcon": 903406,
	"./RubbishCircleOutlineIcon": 521978,
	"./RubbishEmptyIcon": 227392,
	"./RubbishIcon": 373682,
	"./RubbishOutlineIcon": 920698,
	"./RubleIcon": 122051,
	"./RubyIcon": 339775,
	"./RugbyBallIcon": 643156,
	"./RugbyIcon": 681104,
	"./RulerIcon": 79140,
	"./RulerSquareIcon": 147291,
	"./RunFastIcon": 400113,
	"./RunIcon": 449641,
	"./RupeeIcon": 33981,
	"./SackIcon": 406973,
	"./SackPercentIcon": 874898,
	"./SafeIcon": 522334,
	"./SafetyBeltIcon": 236332,
	"./SafetyGogglesIcon": 918143,
	"./SailingIcon": 85785,
	"./SaleIcon": 553620,
	"./SalesforceIcon": 239833,
	"./SassIcon": 272000,
	"./SatelliteIcon": 169498,
	"./SatelliteUplinkIcon": 82731,
	"./SatelliteVariantIcon": 707085,
	"./SausageIcon": 529979,
	"./SawBladeIcon": 550606,
	"./SaxophoneIcon": 71596,
	"./ScaleBalanceIcon": 959476,
	"./ScaleBathroomIcon": 190118,
	"./ScaleIcon": 791042,
	"./ScanIcon": 390276,
	"./ScannerIcon": 74157,
	"./ScannerOffIcon": 230793,
	"./ScatterPlotIcon": 203431,
	"./ScatterPlotOutlineIcon": 874802,
	"./ScheduleIcon": 13313,
	"./SchoolIcon": 170332,
	"./ScissorsCuttingIcon": 830154,
	"./ScissorsIcon": 105986,
	"./ScoreIcon": 925435,
	"./ScreenLockRotationIcon": 598370,
	"./ScreenRotationIcon": 796005,
	"./ScreenRotationLockIcon": 463887,
	"./ScrewFlatTopIcon": 318763,
	"./ScrewLagIcon": 177971,
	"./ScrewMachineFlatTopIcon": 986399,
	"./ScrewMachineRoundTopIcon": 876680,
	"./ScrewRoundTopIcon": 399862,
	"./ScrewdriverIcon": 581919,
	"./ScriptIcon": 139828,
	"./ScriptOutlineIcon": 139867,
	"./ScriptTextIcon": 531532,
	"./ScriptTextOutlineIcon": 53952,
	"./ScrollIcon": 301806,
	"./ScrollOutlineIcon": 583967,
	"./ScrollTextIcon": 408729,
	"./ScrollTextOutlineIcon": 537239,
	"./SdCardIcon": 821477,
	"./SdIcon": 746930,
	"./SdStorageIcon": 670634,
	"./SealIcon": 543743,
	"./SearchAddIcon": 355327,
	"./SearchAddOutlineIcon": 959944,
	"./SearchHandsFreeIcon": 811765,
	"./SearchHandsFreeOffIcon": 962435,
	"./SearchIcon": 711784,
	"./SearchMinusIcon": 144089,
	"./SearchMinusOutlineIcon": 898826,
	"./SearchPlusIcon": 19149,
	"./SearchPlusOutlineIcon": 914907,
	"./SearchWebIcon": 601985,
	"./SeatFlatAngledIcon": 715727,
	"./SeatFlatIcon": 179522,
	"./SeatIcon": 686952,
	"./SeatIndividualSuiteIcon": 602939,
	"./SeatLegroomExtraIcon": 81535,
	"./SeatLegroomNormalIcon": 783304,
	"./SeatLegroomReducedIcon": 459301,
	"./SeatOutlineIcon": 622229,
	"./SeatReclineExtraIcon": 638303,
	"./SeatReclineNormalIcon": 957067,
	"./SeatbeltIcon": 667524,
	"./SecurityAccountIcon": 495673,
	"./SecurityAccountOutlineIcon": 2714,
	"./SecurityCameraIcon": 965282,
	"./SecurityHomeIcon": 846221,
	"./SecurityIcon": 605899,
	"./SecurityLockIcon": 72987,
	"./SecurityNetworkIcon": 947738,
	"./SecurityOffIcon": 754793,
	"./SeedIcon": 329863,
	"./SeedOutlineIcon": 189610,
	"./SeedlingIcon": 293085,
	"./SeedlingOutlineIcon": 423079,
	"./SegmentIcon": 513534,
	"./SelectAllIcon": 773176,
	"./SelectColorIcon": 748373,
	"./SelectColourIcon": 163598,
	"./SelectCompareIcon": 482820,
	"./SelectDragIcon": 504108,
	"./SelectGroupIcon": 910827,
	"./SelectIcon": 385584,
	"./SelectInverseIcon": 455092,
	"./SelectOffIcon": 414370,
	"./SelectionDragIcon": 234587,
	"./SelectionEllipseArrowInsideIcon": 89573,
	"./SelectionEllipseIcon": 427663,
	"./SelectionIcon": 268826,
	"./SelectionOffIcon": 20277,
	"./SendCircleIcon": 1285,
	"./SendCircleOutlineIcon": 487734,
	"./SendIcon": 519910,
	"./SendLockIcon": 232282,
	"./SendSecureIcon": 641432,
	"./SentimentVerySatisfiedIcon": 79765,
	"./SerialPortIcon": 723389,
	"./ServerAddIcon": 44269,
	"./ServerIcon": 257776,
	"./ServerMinusIcon": 991070,
	"./ServerNetworkIcon": 137027,
	"./ServerNetworkOffIcon": 412886,
	"./ServerOffIcon": 123047,
	"./ServerPlusIcon": 845226,
	"./ServerRemoveIcon": 535785,
	"./ServerSecurityIcon": 469304,
	"./ServiceToolboxIcon": 873286,
	"./SetAllIcon": 440728,
	"./SetAndIcon": 622812,
	"./SetCenterIcon": 320459,
	"./SetCenterRightIcon": 553573,
	"./SetCentreIcon": 722772,
	"./SetCentreRightIcon": 44981,
	"./SetIcon": 634770,
	"./SetIntersectionIcon": 317863,
	"./SetLeftCenterIcon": 366959,
	"./SetLeftCentreIcon": 435,
	"./SetLeftIcon": 867751,
	"./SetLeftRightIcon": 687747,
	"./SetNoneIcon": 453896,
	"./SetNotIcon": 14131,
	"./SetNullIcon": 651252,
	"./SetOrIcon": 789572,
	"./SetRightIcon": 759237,
	"./SetTopBoxIcon": 772264,
	"./SetUnionIcon": 15796,
	"./SetXorIcon": 287668,
	"./SettingsApplicationsIcon": 112958,
	"./SettingsBackupRestoreIcon": 298435,
	"./SettingsBluetoothIcon": 670416,
	"./SettingsBoxIcon": 408681,
	"./SettingsCellIcon": 502026,
	"./SettingsHelperIcon": 720062,
	"./SettingsIcon": 90987,
	"./SettingsInputAntennaIcon": 91791,
	"./SettingsInputComponentIcon": 685903,
	"./SettingsInputCompositeIcon": 500624,
	"./SettingsInputHdmiIcon": 287500,
	"./SettingsInputSvideoIcon": 334467,
	"./SettingsOutlineIcon": 903418,
	"./SettingsPhoneIcon": 360110,
	"./SettingsPowerIcon": 983530,
	"./SettingsRemoteIcon": 322740,
	"./SettingsVoiceIcon": 373585,
	"./ShapeAddIcon": 368837,
	"./ShapeCircleAddIcon": 169666,
	"./ShapeCirclePlusIcon": 204159,
	"./ShapeIcon": 590633,
	"./ShapeOutlineIcon": 598027,
	"./ShapePlusIcon": 990267,
	"./ShapePolygonAddIcon": 813751,
	"./ShapePolygonPlusIcon": 97558,
	"./ShapeRectangleAddIcon": 35660,
	"./ShapeRectanglePlusIcon": 937781,
	"./ShapeSquareAddIcon": 560636,
	"./ShapeSquarePlusIcon": 213897,
	"./ShareIcon": 357074,
	"./ShareOffIcon": 276591,
	"./ShareOffOutlineIcon": 686496,
	"./ShareOutlineIcon": 190218,
	"./ShareVariantIcon": 91202,
	"./SheepIcon": 452252,
	"./ShieldAccountIcon": 840279,
	"./ShieldAccountOutlineIcon": 631125,
	"./ShieldAddIcon": 478402,
	"./ShieldAddOutlineIcon": 707326,
	"./ShieldAeroplaneIcon": 30999,
	"./ShieldAeroplaneOutlineIcon": 677937,
	"./ShieldAirplaneIcon": 900597,
	"./ShieldAirplaneOutlineIcon": 727160,
	"./ShieldAlertIcon": 776828,
	"./ShieldAlertOutlineIcon": 390561,
	"./ShieldCarIcon": 278526,
	"./ShieldCheckIcon": 557172,
	"./ShieldCheckOutlineIcon": 26503,
	"./ShieldChristianityIcon": 441384,
	"./ShieldChristianityOutlineIcon": 244886,
	"./ShieldCrossIcon": 653524,
	"./ShieldCrossOutlineIcon": 588568,
	"./ShieldHalfFullIcon": 387746,
	"./ShieldHomeIcon": 978384,
	"./ShieldHomeOutlineIcon": 655194,
	"./ShieldHouseIcon": 244328,
	"./ShieldHouseOutlineIcon": 949295,
	"./ShieldIcon": 86376,
	"./ShieldKeyIcon": 543269,
	"./ShieldKeyOutlineIcon": 616262,
	"./ShieldLinkVariantIcon": 276310,
	"./ShieldLinkVariantOutlineIcon": 952933,
	"./ShieldLockIcon": 167450,
	"./ShieldLockOutlineIcon": 353969,
	"./ShieldOffIcon": 250226,
	"./ShieldOffOutlineIcon": 190249,
	"./ShieldOutlineIcon": 754981,
	"./ShieldPersonIcon": 827104,
	"./ShieldPersonOutlineIcon": 185618,
	"./ShieldPlaneIcon": 367685,
	"./ShieldPlaneOutlineIcon": 650807,
	"./ShieldPlusIcon": 454832,
	"./ShieldPlusOutlineIcon": 825144,
	"./ShieldRemoveIcon": 278523,
	"./ShieldRemoveOutlineIcon": 817284,
	"./ShieldSearchIcon": 661278,
	"./ShieldTemplarIcon": 695249,
	"./ShieldTemplarOutlineIcon": 311182,
	"./ShieldTickIcon": 304727,
	"./ShieldTickOutlineIcon": 718699,
	"./ShieldUserIcon": 62822,
	"./ShieldUserOutlineIcon": 11381,
	"./ShieldWarningIcon": 632242,
	"./ShieldWarningOutlineIcon": 982042,
	"./ShipIcon": 105413,
	"./ShipWheelIcon": 191446,
	"./ShoeFormalIcon": 627930,
	"./ShoeHeelIcon": 361819,
	"./ShoePrintIcon": 527526,
	"./Shop24HourIcon": 869668,
	"./ShopIcon": 790527,
	"./ShopifyIcon": 194120,
	"./ShoppingBasketIcon": 990823,
	"./ShoppingCartAddIcon": 23985,
	"./ShoppingCartArrowDownIcon": 459947,
	"./ShoppingCartArrowRightIcon": 503144,
	"./ShoppingCartArrowUpIcon": 344663,
	"./ShoppingCartIcon": 709611,
	"./ShoppingCartMinusIcon": 141472,
	"./ShoppingCartOffIcon": 59338,
	"./ShoppingCartOutlineIcon": 603263,
	"./ShoppingCartPlusIcon": 359680,
	"./ShoppingCartRemoveIcon": 939109,
	"./ShoppingIcon": 579288,
	"./ShoppingMusicIcon": 652715,
	"./ShoppingSearchIcon": 683431,
	"./ShovelIcon": 593619,
	"./ShovelOffIcon": 555306,
	"./ShowChartIcon": 463194,
	"./ShowIcon": 78892,
	"./ShowOutlineIcon": 997058,
	"./ShowerHeadIcon": 210675,
	"./ShowerIcon": 612318,
	"./ShredderIcon": 911843,
	"./ShuffleDisabledIcon": 112497,
	"./ShuffleIcon": 189679,
	"./ShuffleVariantIcon": 297786,
	"./ShutdownIcon": 85748,
	"./ShuttlecockIcon": 919877,
	"./SigmaIcon": 209326,
	"./SigmaLowerIcon": 432465,
	"./SignCautionIcon": 223223,
	"./SignDirectionIcon": 312671,
	"./SignIcon": 496847,
	"./SignInIcon": 72639,
	"./SignInVariantIcon": 879430,
	"./SignOutIcon": 26216,
	"./SignOutVariantIcon": 618248,
	"./SignRoutesIcon": 37520,
	"./SignTextIcon": 415471,
	"./Signal2gIcon": 869057,
	"./Signal3gIcon": 504824,
	"./Signal4gIcon": 91383,
	"./Signal5gIcon": 824688,
	"./SignalCellular0Icon": 704623,
	"./SignalCellular1Icon": 217293,
	"./SignalCellular2Icon": 295496,
	"./SignalCellular3Icon": 921504,
	"./SignalCellularNoSimIcon": 609900,
	"./SignalCellularOutlineIcon": 422974,
	"./SignalDistanceVariantIcon": 874359,
	"./SignalHspaIcon": 727727,
	"./SignalHspaPlusIcon": 948266,
	"./SignalIcon": 154139,
	"./SignalOffIcon": 236935,
	"./SignalVariantIcon": 945841,
	"./SignatureFreehandIcon": 89990,
	"./SignatureIcon": 677428,
	"./SignatureImageIcon": 355707,
	"./SignatureTextIcon": 617206,
	"./SiloIcon": 359160,
	"./SilverwareForkIcon": 333683,
	"./SilverwareForkKnifeIcon": 738050,
	"./SilverwareIcon": 90391,
	"./SilverwareSpoonIcon": 899610,
	"./SilverwareVariantIcon": 718265,
	"./SimAlertIcon": 974606,
	"./SimCardAlertIcon": 98322,
	"./SimCardIcon": 280754,
	"./SimIcon": 392301,
	"./SimOffIcon": 985416,
	"./SimWarningIcon": 167877,
	"./SinaWeiboIcon": 324366,
	"./SineWaveIcon": 158990,
	"./SitemapIcon": 277111,
	"./SkateIcon": 375276,
	"./SkewDecreaseIcon": 922044,
	"./SkewIncreaseIcon": 787506,
	"./SkewLessIcon": 130444,
	"./SkewMoreIcon": 871632,
	"./SkipBackwardIcon": 641582,
	"./SkipBackwardOutlineIcon": 91662,
	"./SkipForwardIcon": 643959,
	"./SkipForwardOutlineIcon": 890918,
	"./SkipNextCircleIcon": 584893,
	"./SkipNextCircleOutlineIcon": 110497,
	"./SkipNextIcon": 371291,
	"./SkipNextOutlineIcon": 153025,
	"./SkipPreviousCircleIcon": 918302,
	"./SkipPreviousCircleOutlineIcon": 913118,
	"./SkipPreviousIcon": 697434,
	"./SkipPreviousOutlineIcon": 721506,
	"./SkullCrossbonesIcon": 928188,
	"./SkullCrossbonesOutlineIcon": 852120,
	"./SkullIcon": 161200,
	"./SkullOutlineIcon": 736344,
	"./SkypeBusinessIcon": 446846,
	"./SkypeIcon": 211978,
	"./SlackIcon": 753553,
	"./SlackwareIcon": 812766,
	"./SlateIcon": 74448,
	"./SlateOutlineIcon": 245046,
	"./SleepIcon": 742201,
	"./SleepOffIcon": 145136,
	"./SlideshowIcon": 128653,
	"./SlopeDownhillIcon": 771605,
	"./SlopeUphillIcon": 494757,
	"./SmartphoneAndroidIcon": 378624,
	"./SmartphoneArrowDownIcon": 220775,
	"./SmartphoneDockIcon": 481978,
	"./SmartphoneEraseIcon": 429725,
	"./SmartphoneIcon": 592017,
	"./SmartphoneInformationIcon": 592422,
	"./SmartphoneIphoneIcon": 457692,
	"./SmartphoneKeyIcon": 776630,
	"./SmartphoneLinkIcon": 872712,
	"./SmartphoneLinkOffIcon": 547489,
	"./SmartphoneLockIcon": 373044,
	"./SmartphoneMessageIcon": 94906,
	"./SmartphoneOffIcon": 309055,
	"./SmartphoneSettingsIcon": 102543,
	"./SmartphoneSettingsVariantIcon": 869909,
	"./SmartphoneSoundIcon": 790927,
	"./SmartphoneTextIcon": 319708,
	"./SmartphoneWirelessIcon": 975868,
	"./SmileyAngryIcon": 816551,
	"./SmileyAngryOutlineIcon": 271726,
	"./SmileyCoolIcon": 330251,
	"./SmileyCoolOutlineIcon": 743996,
	"./SmileyCryIcon": 10055,
	"./SmileyCryOutlineIcon": 660961,
	"./SmileyDeadIcon": 768332,
	"./SmileyDeadOutlineIcon": 913086,
	"./SmileyDevilIcon": 503990,
	"./SmileyDevilOutlineIcon": 370754,
	"./SmileyExcitedIcon": 467625,
	"./SmileyExcitedOutlineIcon": 914073,
	"./SmileyHappyIcon": 488596,
	"./SmileyHappyOutlineIcon": 7781,
	"./SmileyIcon": 69226,
	"./SmileyKissIcon": 579380,
	"./SmileyKissOutlineIcon": 975489,
	"./SmileyNeutralIcon": 467930,
	"./SmileyNeutralOutlineIcon": 460667,
	"./SmileyOutlineIcon": 683930,
	"./SmileyPoopIcon": 673210,
	"./SmileySadIcon": 793529,
	"./SmileySadOutlineIcon": 558810,
	"./SmileyTongueIcon": 627146,
	"./SmileyTongueOutlineIcon": 674332,
	"./SmileyWinkIcon": 224139,
	"./SmileyWinkOutlineIcon": 714014,
	"./SmogIcon": 241217,
	"./SmokeDetectorIcon": 483055,
	"./SmokeFreeIcon": 748469,
	"./SmokingAreaIcon": 949808,
	"./SmokingIcon": 970392,
	"./SmokingOffIcon": 345003,
	"./SmokingRoomsIcon": 515010,
	"./SmsFailedIcon": 262263,
	"./SmsFailedOutlineIcon": 413869,
	"./SmsIcon": 183418,
	"./SnapchatIcon": 720720,
	"./SnookerRackIcon": 577734,
	"./SnookerTriangleIcon": 203632,
	"./SnowAdvisoryIcon": 83929,
	"./SnowflakeAlertIcon": 434148,
	"./SnowflakeIcon": 185569,
	"./SnowflakeVariantIcon": 882038,
	"./SnowmanIcon": 368834,
	"./SoccerFieldIcon": 898646,
	"./SoccerIcon": 167937,
	"./SofaIcon": 305613,
	"./SolarPanelIcon": 743061,
	"./SolarPanelLargeIcon": 288213,
	"./SolarPowerIcon": 638409,
	"./SolidIcon": 533419,
	"./SonyPlaystationIcon": 905149,
	"./SortAlphabeticalIcon": 556319,
	"./SortAlphabeticallyIcon": 877113,
	"./SortAscendingIcon": 631341,
	"./SortByAlphaIcon": 116231,
	"./SortDescendingIcon": 95460,
	"./SortIcon": 454391,
	"./SortNumericIcon": 877951,
	"./SortNumericallyIcon": 595844,
	"./SortVariantIcon": 94151,
	"./SortVariantLockIcon": 420125,
	"./SortVariantLockOpenIcon": 363883,
	"./SoundcloudIcon": 317180,
	"./SourceBranchIcon": 41476,
	"./SourceCommitEndIcon": 798694,
	"./SourceCommitEndLocalIcon": 168993,
	"./SourceCommitIcon": 503488,
	"./SourceCommitLocalIcon": 542920,
	"./SourceCommitNextLocalIcon": 761337,
	"./SourceCommitStartIcon": 67404,
	"./SourceCommitStartNextLocalIcon": 813022,
	"./SourceForkIcon": 439457,
	"./SourceMergeIcon": 231449,
	"./SourcePullIcon": 590022,
	"./SourceRepositoriesIcon": 508027,
	"./SourceRepositoryIcon": 569032,
	"./SourceRepositoryMultipleIcon": 367578,
	"./SoySauceIcon": 826697,
	"./SoyaSauceIcon": 960846,
	"./SpaIcon": 391540,
	"./SpaOutlineIcon": 153826,
	"./SpaceInvadersIcon": 820900,
	"./SpadeIcon": 990024,
	"./SpannerIcon": 725835,
	"./SpannerOutlineIcon": 548840,
	"./SpeakIcon": 347330,
	"./SpeakerBluetoothIcon": 417046,
	"./SpeakerIcon": 129137,
	"./SpeakerMultipleIcon": 974683,
	"./SpeakerNotesIcon": 536856,
	"./SpeakerNotesOffIcon": 24895,
	"./SpeakerOffIcon": 681868,
	"./SpeakerWirelessIcon": 715759,
	"./SpeakerphoneIcon": 224472,
	"./SpeakerphoneOffIcon": 242285,
	"./SpeakersIcon": 639309,
	"./SpeakingIcon": 175345,
	"./SpeedometerIcon": 670572,
	"./SpeedometerMediumIcon": 689701,
	"./SpeedometerSlowIcon": 104897,
	"./SpellcheckIcon": 86225,
	"./SphereDiameterIcon": 578641,
	"./SphereDiameterOutlineIcon": 644240,
	"./SphereDiameterVariantIcon": 985380,
	"./SphereRadiusIcon": 191757,
	"./SphereRadiusOutlineIcon": 944698,
	"./SpicyIcon": 972153,
	"./SpiderWebIcon": 820167,
	"./SpotifyIcon": 815254,
	"./SpotlightBeamIcon": 368462,
	"./SpotlightIcon": 840875,
	"./SprayBottleIcon": 214573,
	"./SprayIcon": 581623,
	"./SproutIcon": 158839,
	"./SproutOutlineIcon": 680672,
	"./SqlFullOuterJoinIcon": 282408,
	"./SqlInnerJoinIcon": 945896,
	"./SqlLeftOuterJoinIcon": 698039,
	"./SqlRightOuterJoinIcon": 318586,
	"./SquareBracketsIcon": 332459,
	"./SquareEditOutlineIcon": 911013,
	"./SquareIcon": 235631,
	"./SquareIncCashIcon": 214099,
	"./SquareIncIcon": 246803,
	"./SquareMediumIcon": 899186,
	"./SquareMediumOutlineIcon": 377143,
	"./SquareOutlineIcon": 147825,
	"./SquareRootBoxIcon": 898428,
	"./SquareRootIcon": 732452,
	"./SquareSmallIcon": 131407,
	"./SquashIcon": 336603,
	"./SqueegeeIcon": 699396,
	"./SshIcon": 111875,
	"./StackExchangeIcon": 803475,
	"./StackOverflowIcon": 784756,
	"./StadiumIcon": 410546,
	"./StairsIcon": 724930,
	"./StamperIcon": 85799,
	"./StandardDefinitionIcon": 92733,
	"./StanleyKnifeIcon": 387428,
	"./StarAndCrescentIcon": 305281,
	"./StarBorderIcon": 536371,
	"./StarBoxIcon": 106413,
	"./StarBoxOutlineIcon": 907739,
	"./StarCircleIcon": 153613,
	"./StarCircleOutlineIcon": 582438,
	"./StarFaceIcon": 198834,
	"./StarFourPointsIcon": 611311,
	"./StarFourPointsOutlineIcon": 83130,
	"./StarHalfIcon": 234411,
	"./StarIcon": 615173,
	"./StarOfDavidIcon": 780432,
	"./StarOffIcon": 72192,
	"./StarOutlineIcon": 670705,
	"./StarRateIcon": 274990,
	"./StarThreePointsIcon": 324652,
	"./StarThreePointsOutlineIcon": 368640,
	"./StarburstIcon": 107579,
	"./StarburstOutlineIcon": 338863,
	"./StarsIcon": 825114,
	"./StayCurrentPortraitIcon": 21650,
	"./StayPrimaryPortraitIcon": 821220,
	"./SteamBoxIcon": 16227,
	"./SteamIcon": 621813,
	"./SteeringIcon": 171529,
	"./SteeringOffIcon": 136246,
	"./StepBackward2Icon": 707231,
	"./StepBackwardIcon": 556761,
	"./StepForward2Icon": 999190,
	"./StepForwardIcon": 60570,
	"./StereoIcon": 721089,
	"./SterlingIcon": 973187,
	"./StethoscopeIcon": 223846,
	"./StickerEmojiIcon": 560336,
	"./StickerIcon": 811174,
	"./StockingIcon": 548443,
	"./StopCircleIcon": 10531,
	"./StopCircleOutlineIcon": 192040,
	"./StopIcon": 230306,
	"./StopwatchIcon": 391660,
	"./StopwatchOffIcon": 915749,
	"./Store24HourIcon": 771565,
	"./StoreIcon": 227131,
	"./StoreMallDirectoryIcon": 982990,
	"./StormAdvisoryIcon": 733912,
	"./StormAdvisoryOutlineIcon": 787564,
	"./StoveIcon": 837861,
	"./StravaIcon": 36254,
	"./StretchToPageIcon": 438501,
	"./StretchToPageOutlineIcon": 409516,
	"./StrikethroughSIcon": 124348,
	"./StyleIcon": 17683,
	"./SubdirectoryArrowLeftIcon": 942324,
	"./SubdirectoryArrowRightIcon": 716355,
	"./SubscriberIdentificationModuleIcon": 934722,
	"./SubscriberIdentityModuleIcon": 35280,
	"./SubscriptionsIcon": 455162,
	"./SubtasksIcon": 364386,
	"./SubtitlesIcon": 16794,
	"./SubtitlesOutlineIcon": 949440,
	"./SubwayAlertVariantIcon": 395356,
	"./SubwayIcon": 27995,
	"./SubwayVariantIcon": 179985,
	"./SubwayWarningVariantIcon": 297905,
	"./SubwooferIcon": 300979,
	"./SuitClubsIcon": 957253,
	"./SuitDiamondsIcon": 830521,
	"./SuitHeartsIcon": 965003,
	"./SuitSpadesIcon": 837513,
	"./SummationIcon": 903774,
	"./SummitIcon": 243314,
	"./SunAdvisoryIcon": 438356,
	"./SunMoonStarsIcon": 48950,
	"./SunglassesIcon": 679299,
	"./SunriseIcon": 410085,
	"./SuperChatForGoodIcon": 899525,
	"./SupportIcon": 394071,
	"./SurroundSound20Icon": 352210,
	"./SurroundSound31Icon": 944799,
	"./SurroundSound51Icon": 474799,
	"./SurroundSound71Icon": 330817,
	"./SurroundSoundIcon": 323732,
	"./SvgIcon": 899407,
	"./SwapCallsIcon": 903059,
	"./SwapDrivingAppsWheelIcon": 20085,
	"./SwapHorizontalBoldIcon": 964094,
	"./SwapHorizontalIcon": 616771,
	"./SwapHorizontalVariantIcon": 926228,
	"./SwapVerticalBoldIcon": 110478,
	"./SwapVerticalIcon": 608440,
	"./SwapVerticalVariantIcon": 974173,
	"./SwimIcon": 957912,
	"./SwimmingPoolIcon": 934075,
	"./SwitchCameraIcon": 321085,
	"./SwitchIcon": 23909,
	"./SwitchVideoIcon": 13952,
	"./SwordCrossIcon": 626458,
	"./SwordIcon": 460366,
	"./SymfonyIcon": 312840,
	"./SyncAlertIcon": 300608,
	"./SyncDisabledIcon": 917690,
	"./SyncIcon": 845370,
	"./SyncOffIcon": 40147,
	"./SyncProblemIcon": 813621,
	"./SyncWarningIcon": 372914,
	"./SyringeIcon": 227240,
	"./TabAddIcon": 650550,
	"./TabIcon": 843172,
	"./TabMinusIcon": 373993,
	"./TabPlusIcon": 676138,
	"./TabRemoveIcon": 90918,
	"./TabUnselectedIcon": 43719,
	"./TableAddIcon": 107583,
	"./TableBorderIcon": 902395,
	"./TableColumnAddAfterIcon": 15712,
	"./TableColumnAddBeforeIcon": 562127,
	"./TableColumnIcon": 281636,
	"./TableColumnPlusAfterIcon": 445590,
	"./TableColumnPlusBeforeIcon": 307952,
	"./TableColumnRemoveIcon": 266726,
	"./TableColumnWidthIcon": 517545,
	"./TableEditIcon": 110108,
	"./TableIcon": 571764,
	"./TableLargeAddIcon": 470230,
	"./TableLargeIcon": 241545,
	"./TableLargePlusIcon": 612013,
	"./TableLargeRemoveIcon": 110278,
	"./TableMergeCellsIcon": 954577,
	"./TableOfContentsIcon": 457112,
	"./TablePlusIcon": 197301,
	"./TableRemoveIcon": 4473,
	"./TableRowAddAfterIcon": 541163,
	"./TableRowAddBeforeIcon": 18092,
	"./TableRowHeightIcon": 126130,
	"./TableRowIcon": 497273,
	"./TableRowPlusAfterIcon": 410730,
	"./TableRowPlusBeforeIcon": 28884,
	"./TableRowRemoveIcon": 839832,
	"./TableSearchIcon": 542727,
	"./TableSettingsIcon": 665439,
	"./TableTennisIcon": 909678,
	"./TabletAndroidIcon": 115741,
	"./TabletCellphoneIcon": 459758,
	"./TabletDashboardIcon": 641974,
	"./TabletIcon": 529932,
	"./TabletIpadIcon": 768114,
	"./TabletMacIcon": 337669,
	"./TabletMobilePhoneIcon": 422953,
	"./TabletSmartphoneIcon": 388145,
	"./TacoIcon": 701930,
	"./TagAddIcon": 508735,
	"./TagFacesIcon": 724578,
	"./TagHeartIcon": 708032,
	"./TagHeartOutlineIcon": 875454,
	"./TagIcon": 213181,
	"./TagMinusIcon": 454845,
	"./TagMultipleIcon": 67734,
	"./TagOutlineIcon": 383719,
	"./TagPlusIcon": 174871,
	"./TagRemoveIcon": 648210,
	"./TagTextOutlineIcon": 533116,
	"./TagsIcon": 238621,
	"./TakaIcon": 412373,
	"./TalkIcon": 781893,
	"./TalkingIcon": 29437,
	"./TankIcon": 478488,
	"./TaoismIcon": 844524,
	"./TapeIcon": 845503,
	"./TapeMeasureIcon": 897267,
	"./TargetAccountIcon": 51154,
	"./TargetArrowIcon": 873104,
	"./TargetIcon": 741326,
	"./TargetUserIcon": 844688,
	"./TargetVariantIcon": 73532,
	"./TaxiIcon": 491111,
	"./TeaIcon": 240792,
	"./TeaKettleEmptyIcon": 325776,
	"./TeaKettleFullIcon": 389624,
	"./TeaKettleIcon": 199960,
	"./TeaKettleOutlineIcon": 935436,
	"./TeaOutlineIcon": 42672,
	"./TeachIcon": 91954,
	"./TeacherIcon": 404729,
	"./TeachingIcon": 57066,
	"./TeamviewerIcon": 593563,
	"./TelegramIcon": 941609,
	"./TelephoneBluetoothIcon": 905112,
	"./TelephoneForwardIcon": 753205,
	"./TelephoneHangupIcon": 636589,
	"./TelephoneIcon": 864906,
	"./TelephoneInTalkIcon": 305914,
	"./TelephoneIncomingIcon": 655845,
	"./TelephoneLockIcon": 288754,
	"./TelephoneLockedIcon": 583489,
	"./TelephoneOutlineIcon": 563636,
	"./TelescopeIcon": 426305,
	"./TelevisionBoxIcon": 77047,
	"./TelevisionClassicIcon": 788565,
	"./TelevisionClassicOffIcon": 186863,
	"./TelevisionGuideIcon": 367581,
	"./TelevisionIcon": 219920,
	"./TelevisionOffIcon": 258747,
	"./TelevisionPauseIcon": 724224,
	"./TelevisionPlayIcon": 441107,
	"./TelevisionStopIcon": 589142,
	"./TemperatureCelsiusIcon": 460660,
	"./TemperatureCentigradeIcon": 86702,
	"./TemperatureFahrenheitIcon": 918141,
	"./TemperatureKelvinIcon": 789854,
	"./TennisBallIcon": 388805,
	"./TennisIcon": 600875,
	"./TennisRacketIcon": 148067,
	"./TennisRacquetIcon": 576182,
	"./TentIcon": 609092,
	"./TerminalIcon": 379196,
	"./TerminalLineIcon": 674962,
	"./TerminalNetworkIcon": 464426,
	"./TerminalNetworkOutlineIcon": 592063,
	"./TerrainIcon": 236585,
	"./TestTubeEmptyIcon": 938763,
	"./TestTubeIcon": 711882,
	"./TestTubeOffIcon": 111770,
	"./TextIcon": 811610,
	"./TextShadowIcon": 344431,
	"./TextShortIcon": 184576,
	"./TextSubjectIcon": 263857,
	"./TextToSpeechIcon": 811168,
	"./TextToSpeechOffIcon": 780061,
	"./TextboxIcon": 728441,
	"./TextboxPasswordIcon": 636722,
	"./TextsmsIcon": 524327,
	"./TextureIcon": 820456,
	"./TheaterIcon": 681283,
	"./TheatersIcon": 114053,
	"./TheatreIcon": 279339,
	"./ThemeIcon": 476385,
	"./ThemeLightDarkIcon": 268769,
	"./ThermometerAddIcon": 832074,
	"./ThermometerAlertIcon": 658433,
	"./ThermometerChevronDownIcon": 185895,
	"./ThermometerChevronUpIcon": 271266,
	"./ThermometerIcon": 765394,
	"./ThermometerLinesIcon": 92507,
	"./ThermometerMinusIcon": 172508,
	"./ThermometerPlusIcon": 168720,
	"./ThermometerWarningIcon": 230848,
	"./ThermostatBoxIcon": 729866,
	"./ThermostatIcon": 318187,
	"./ThinkOutlineIcon": 533249,
	"./ThinkingIcon": 831649,
	"./ThinkingOutlineIcon": 212283,
	"./ThoughtBubbleIcon": 173386,
	"./ThoughtBubbleOutlineIcon": 765939,
	"./ThumbDownIcon": 78608,
	"./ThumbDownOutlineIcon": 2380,
	"./ThumbUpIcon": 64021,
	"./ThumbUpOutlineIcon": 641397,
	"./ThumbsDownIcon": 838444,
	"./ThumbsDownOutlineIcon": 811089,
	"./ThumbsUpDownIcon": 72439,
	"./ThumbsUpIcon": 284264,
	"./ThumbsUpOutlineIcon": 270698,
	"./TickAllIcon": 260302,
	"./TickBoxMultipleOutlineIcon": 580782,
	"./TickCircleIcon": 762788,
	"./TickCircleOutlineIcon": 727193,
	"./TickDecagramIcon": 498552,
	"./TickIcon": 994912,
	"./TickNetworkIcon": 966977,
	"./TickNetworkOutlineIcon": 342417,
	"./TickOutlineIcon": 431572,
	"./TicketAccountIcon": 963911,
	"./TicketConfirmationIcon": 683207,
	"./TicketIcon": 369475,
	"./TicketOutlineIcon": 669503,
	"./TicketPercentIcon": 355176,
	"./TicketUserIcon": 728219,
	"./TicksIcon": 700027,
	"./TieIcon": 187937,
	"./TildeIcon": 331521,
	"./TillIcon": 293204,
	"./TimeToLeaveIcon": 899535,
	"./TimelapseIcon": 807540,
	"./TimelineAlertIcon": 936964,
	"./TimelineAlertOutlineIcon": 651936,
	"./TimelineHelpIcon": 92288,
	"./TimelineHelpOutlineIcon": 762277,
	"./TimelineIcon": 109405,
	"./TimelineOutlineIcon": 913967,
	"./TimelinePlusIcon": 916193,
	"./TimelinePlusOutlineIcon": 304869,
	"./TimelineTextIcon": 672548,
	"./TimelineTextOutlineIcon": 262139,
	"./Timer10Icon": 158854,
	"./Timer3Icon": 466870,
	"./TimerIcon": 678653,
	"./TimerOffIcon": 458903,
	"./TimerSandEmptyIcon": 977306,
	"./TimerSandFullIcon": 526408,
	"./TimerSandIcon": 33504,
	"./TimerTenIcon": 604609,
	"./TimerThreeIcon": 669017,
	"./TimetableIcon": 423153,
	"./TimezoneIcon": 9601,
	"./TimezoneOutlineIcon": 101931,
	"./TitleBackwardIcon": 7258,
	"./TitleForwardIcon": 219325,
	"./TmIcon": 82168,
	"./ToasterOvenIcon": 799400,
	"./TocIcon": 334882,
	"./ToggleSwitchIcon": 184965,
	"./ToggleSwitchOffIcon": 384245,
	"./ToggleSwitchOffOutlineIcon": 363220,
	"./ToggleSwitchOutlineIcon": 466940,
	"./ToiletIcon": 536016,
	"./TollIcon": 495213,
	"./TombstoneIcon": 820152,
	"./ToolboxIcon": 961224,
	"./ToolboxOutlineIcon": 62911,
	"./TooltipAccountIcon": 640573,
	"./TooltipAddIcon": 23624,
	"./TooltipAddOutlineIcon": 886996,
	"./TooltipEditIcon": 300863,
	"./TooltipIcon": 185818,
	"./TooltipImageIcon": 377457,
	"./TooltipImageOutlineIcon": 531476,
	"./TooltipOutlineIcon": 767294,
	"./TooltipOutlinePlusIcon": 477006,
	"./TooltipPersonIcon": 83463,
	"./TooltipPlusIcon": 824007,
	"./TooltipPlusOutlineIcon": 66015,
	"./TooltipTextIcon": 675928,
	"./TooltipTextOutlineIcon": 585708,
	"./TooltipUserIcon": 750987,
	"./ToothIcon": 657105,
	"./ToothOutlineIcon": 749711,
	"./TorIcon": 968216,
	"./TorchIcon": 657082,
	"./TorchOffIcon": 720824,
	"./TortoiseIcon": 700256,
	"./TournamentIcon": 721293,
	"./TowerBeachIcon": 228722,
	"./TowerFireIcon": 422175,
	"./TowingIcon": 261535,
	"./ToysIcon": 353896,
	"./ToysOutlineIcon": 197389,
	"./TrackChangesIcon": 529463,
	"./TrackLightIcon": 785565,
	"./TrackpadIcon": 307431,
	"./TrackpadLockIcon": 475278,
	"./TractorIcon": 942686,
	"./TrademarkIcon": 189762,
	"./TrafficLightIcon": 424837,
	"./TragedyIcon": 995924,
	"./TrainCarIcon": 345909,
	"./TrainIcon": 652197,
	"./TrainVariantIcon": 869123,
	"./TramIcon": 589407,
	"./TranscribeCloseIcon": 426406,
	"./TranscribeIcon": 525466,
	"./TransferDownIcon": 869131,
	"./TransferLeftIcon": 94447,
	"./TransferRightIcon": 14636,
	"./TransferUpIcon": 173231,
	"./TransferWithinAStationIcon": 480637,
	"./TransitConnectionIcon": 498723,
	"./TransitConnectionVariantIcon": 370337,
	"./TransitDetourIcon": 277847,
	"./TransitTransferIcon": 227120,
	"./TransitionIcon": 682810,
	"./TransitionMaskedIcon": 434187,
	"./TranslateIcon": 101834,
	"./TranslateOffIcon": 925781,
	"./TransmissionTowerIcon": 295331,
	"./TransportationIcon": 62096,
	"./TrashCanCircleIcon": 814538,
	"./TrashCanCircleOutlineIcon": 92548,
	"./TrashCanEmptyIcon": 139711,
	"./TrashCanIcon": 631623,
	"./TrashCanOutlineIcon": 142437,
	"./TrashCircleIcon": 241867,
	"./TrashCircleOutlineIcon": 356921,
	"./TrashEmptyIcon": 987789,
	"./TrashIcon": 781514,
	"./TrashOutlineIcon": 784199,
	"./TrashRestoreIcon": 378494,
	"./TrashVariantIcon": 779254,
	"./TravelIcon": 706987,
	"./TreasureChestIcon": 438995,
	"./TreeIcon": 329682,
	"./TreeOutlineIcon": 579585,
	"./TrelloIcon": 384005,
	"./TrendingDownIcon": 432337,
	"./TrendingFlatIcon": 101081,
	"./TrendingNeutralIcon": 960934,
	"./TrendingUpIcon": 134989,
	"./TriangleIcon": 277927,
	"./TriangleOutlineIcon": 374440,
	"./TriforceIcon": 575409,
	"./TrolleyAddIcon": 391828,
	"./TrolleyArrowDownIcon": 628526,
	"./TrolleyArrowRightIcon": 254166,
	"./TrolleyArrowUpIcon": 248009,
	"./TrolleyIcon": 626088,
	"./TrolleyMinusIcon": 39366,
	"./TrolleyOffIcon": 785336,
	"./TrolleyOutlineIcon": 917779,
	"./TrolleyPlusIcon": 554484,
	"./TrolleyRemoveIcon": 708467,
	"./TrophyAwardIcon": 424540,
	"./TrophyBrokenIcon": 532858,
	"./TrophyIcon": 243741,
	"./TrophyOutlineIcon": 317792,
	"./TrophyVariantIcon": 198922,
	"./TrophyVariantOutlineIcon": 433603,
	"./TruckCheckIcon": 966057,
	"./TruckDeliveryIcon": 487075,
	"./TruckFastIcon": 502789,
	"./TruckIcon": 115507,
	"./TruckTickIcon": 757924,
	"./TruckTrailerIcon": 910709,
	"./TshirtCrewIcon": 35664,
	"./TshirtCrewOutlineIcon": 156536,
	"./TshirtVIcon": 984638,
	"./TshirtVOutlineIcon": 660433,
	"./TtsIcon": 402858,
	"./TtsOffIcon": 104934,
	"./TubeIcon": 607653,
	"./TubeVariantIcon": 886433,
	"./TumbleDryerIcon": 37319,
	"./TumblrBoxIcon": 156253,
	"./TumblrIcon": 452878,
	"./TumblrReblogIcon": 721905,
	"./TuneIcon": 392514,
	"./TuneVerticalIcon": 241215,
	"./TurnedInIcon": 523250,
	"./TurnedInNotIcon": 5636,
	"./TurnstileIcon": 282058,
	"./TurnstileOutlineIcon": 756879,
	"./TurtleIcon": 658705,
	"./TuxIcon": 628699,
	"./TvBoxIcon": 27827,
	"./TvClassicIcon": 4332,
	"./TvClassicOffIcon": 958803,
	"./TvGuideIcon": 21563,
	"./TvIcon": 677458,
	"./TvOffIcon": 826381,
	"./TwitchIcon": 505534,
	"./TwitterBoxIcon": 213442,
	"./TwitterCircleIcon": 247369,
	"./TwitterIcon": 80978,
	"./TwitterRetweetIcon": 149151,
	"./TwoFactorAuthenticationIcon": 142391,
	"./TypewriterIcon": 461502,
	"./UberIcon": 862902,
	"./UbisoftIcon": 34786,
	"./UbuntuIcon": 596257,
	"./UhdIcon": 556314,
	"./UltraHighDefinitionIcon": 460634,
	"./UmbracoIcon": 445580,
	"./UmbrellaClosedIcon": 255421,
	"./UmbrellaIcon": 973829,
	"./UmbrellaOutlineIcon": 961863,
	"./UnarchiveIcon": 323448,
	"./UndergroundIcon": 75053,
	"./UndergroundVariantIcon": 614887,
	"./UndoIcon": 921274,
	"./UndoVariantIcon": 985376,
	"./UnfoldLessHorizontalIcon": 571297,
	"./UnfoldLessVerticalIcon": 929928,
	"./UnfoldMoreHorizontalIcon": 860825,
	"./UnfoldMoreVerticalIcon": 824422,
	"./UngroupIcon": 954986,
	"./UnicodeIcon": 798937,
	"./UnityIcon": 662795,
	"./UniversityIcon": 211961,
	"./UnrealEngineIcon": 721283,
	"./UnrealIcon": 25089,
	"./UntappdIcon": 31146,
	"./UnwrapIcon": 426883,
	"./UpdateIcon": 336690,
	"./UplayIcon": 353625,
	"./UploadIcon": 24655,
	"./UploadMultipleIcon": 122407,
	"./UploadNetworkIcon": 101789,
	"./UploadNetworkOutlineIcon": 635917,
	"./UploadOutlineIcon": 213192,
	"./UploadsIcon": 796954,
	"./UsbIcon": 969124,
	"./UserAddIcon": 775422,
	"./UserAddOutlineIcon": 4427,
	"./UserCircleIcon": 532103,
	"./UserCircleOutlineIcon": 46695,
	"./UserClockIcon": 291505,
	"./UserClockOutlineIcon": 557765,
	"./UserConvertIcon": 380368,
	"./UserDetailsIcon": 796498,
	"./UserEditIcon": 899788,
	"./UserGroupIcon": 859479,
	"./UserGroupOutlineIcon": 814032,
	"./UserHeartIcon": 983213,
	"./UserHeartOutlineIcon": 146656,
	"./UserHelpIcon": 250121,
	"./UserHelpOutlineIcon": 40422,
	"./UserIcon": 81371,
	"./UserKeyIcon": 81740,
	"./UserKeyOutlineIcon": 137937,
	"./UserMinusIcon": 673434,
	"./UserMinusOutlineIcon": 938081,
	"./UserMultipleAddIcon": 74357,
	"./UserMultipleAddOutlineIcon": 212103,
	"./UserMultipleCheckIcon": 81126,
	"./UserMultipleIcon": 916034,
	"./UserMultipleMinusIcon": 659856,
	"./UserMultipleMinusOutlineIcon": 336287,
	"./UserMultipleOutlineIcon": 586989,
	"./UserMultiplePlusIcon": 878519,
	"./UserMultiplePlusOutlineIcon": 169918,
	"./UserMultipleTickIcon": 146833,
	"./UserNetworkIcon": 893502,
	"./UserNetworkOutlineIcon": 419814,
	"./UserOffIcon": 347809,
	"./UserOffOutlineIcon": 205932,
	"./UserOutlineIcon": 825961,
	"./UserPlusIcon": 794568,
	"./UserPlusOutlineIcon": 984287,
	"./UserQuestionIcon": 676179,
	"./UserQuestionOutlineIcon": 258034,
	"./UserRemoveIcon": 477391,
	"./UserRemoveOutlineIcon": 997232,
	"./UserSearchIcon": 432901,
	"./UserSearchOutlineIcon": 622190,
	"./UserSettingsIcon": 712304,
	"./UserStarIcon": 982678,
	"./UserStarOutlineIcon": 904203,
	"./UserSupervisorCircleIcon": 425171,
	"./UserSupervisorIcon": 279529,
	"./UserSwitchIcon": 128384,
	"./UserTieIcon": 514516,
	"./UsersAddIcon": 247192,
	"./UsersAddOutlineIcon": 204714,
	"./UsersCheckIcon": 566791,
	"./UsersGroupIcon": 37595,
	"./UsersGroupOutlineIcon": 634024,
	"./UsersIcon": 49993,
	"./UsersMinusIcon": 374806,
	"./UsersMinusOutlineIcon": 584669,
	"./UsersOutlineIcon": 363129,
	"./UsersPlusIcon": 512970,
	"./UsersPlusOutlineIcon": 306290,
	"./UsersSwitchIcon": 105929,
	"./UsersTickIcon": 135036,
	"./VanCandyIcon": 274936,
	"./VanPassengerIcon": 158931,
	"./VanUtilityIcon": 206246,
	"./VanishIcon": 121075,
	"./VariableIcon": 20168,
	"./VectorArrangeAboveIcon": 893521,
	"./VectorArrangeBelowIcon": 201321,
	"./VectorBezierIcon": 483302,
	"./VectorCircleIcon": 922304,
	"./VectorCircleVariantIcon": 976540,
	"./VectorCombineIcon": 964419,
	"./VectorCurveIcon": 784822,
	"./VectorDifferenceAbIcon": 295558,
	"./VectorDifferenceBaIcon": 168777,
	"./VectorDifferenceIcon": 677839,
	"./VectorEllipseIcon": 49239,
	"./VectorIntersectionIcon": 132383,
	"./VectorLineIcon": 755580,
	"./VectorPointIcon": 8893,
	"./VectorPolygonIcon": 736287,
	"./VectorPolylineIcon": 781969,
	"./VectorRadiusIcon": 987979,
	"./VectorRectangleIcon": 401522,
	"./VectorSelectionIcon": 730481,
	"./VectorSquareIcon": 388159,
	"./VectorTriangleIcon": 960766,
	"./VectorUnionIcon": 86004,
	"./VenmoIcon": 24191,
	"./VerifiedIcon": 182507,
	"./VerifiedUserIcon": 577886,
	"./VerticalRotateClockwiseIcon": 209729,
	"./VerticalRotateCounterclockwiseIcon": 713549,
	"./VhsCassetteIcon": 695331,
	"./VhsIcon": 147849,
	"./VhsTapeIcon": 315370,
	"./VibrateIcon": 176104,
	"./VibrateOffIcon": 778589,
	"./VibrationIcon": 344710,
	"./Video3dIcon": 588331,
	"./Video3dVariantIcon": 679147,
	"./Video4kBoxIcon": 437967,
	"./VideoAccountIcon": 47885,
	"./VideoAddIcon": 769074,
	"./VideoCallIcon": 988691,
	"./VideoClassicIcon": 153926,
	"./VideoFilmIcon": 846170,
	"./VideoHomeSystemIcon": 568139,
	"./VideoIcon": 685505,
	"./VideoImageIcon": 872915,
	"./VideoInputAntennaIcon": 581451,
	"./VideoInputComponentIcon": 182193,
	"./VideoInputCompositeIcon": 957054,
	"./VideoInputHdmiIcon": 41366,
	"./VideoInputScartIcon": 7914,
	"./VideoInputSvideoIcon": 307820,
	"./VideoInputYpbprIcon": 955952,
	"./VideoMinusIcon": 947557,
	"./VideoOffIcon": 79627,
	"./VideoOffOutlineIcon": 665797,
	"./VideoOutlineIcon": 939432,
	"./VideoPlusIcon": 229000,
	"./VideoRemoveIcon": 442930,
	"./VideoStabilisationIcon": 163026,
	"./VideoStabilizationIcon": 402479,
	"./VideoSwitchIcon": 683817,
	"./VideoUserIcon": 61785,
	"./VideoVintageIcon": 749054,
	"./VideoWirelessIcon": 200585,
	"./VideoWirelessOutlineIcon": 96635,
	"./VideoYoutubeIcon": 537664,
	"./VideocamIcon": 949244,
	"./VideocamOffIcon": 294584,
	"./VideocamOffOutlineIcon": 233163,
	"./VideocamOutlineIcon": 938265,
	"./ViewAgendaIcon": 433512,
	"./ViewArrayIcon": 952055,
	"./ViewCarouselIcon": 50245,
	"./ViewColumnIcon": 602506,
	"./ViewComfyIcon": 860600,
	"./ViewCompactIcon": 514508,
	"./ViewCompactOutlineIcon": 996089,
	"./ViewDashboardIcon": 55389,
	"./ViewDashboardOutlineIcon": 550806,
	"./ViewDashboardVariantIcon": 418379,
	"./ViewDayIcon": 755547,
	"./ViewGridAddIcon": 533996,
	"./ViewGridIcon": 273210,
	"./ViewGridPlusIcon": 432704,
	"./ViewHeadlineIcon": 391706,
	"./ViewInArIcon": 899205,
	"./ViewInAugmentedRealityIcon": 193018,
	"./ViewListIcon": 512116,
	"./ViewModuleIcon": 957036,
	"./ViewParallelIcon": 427714,
	"./ViewQuiltIcon": 84466,
	"./ViewSequentialIcon": 282958,
	"./ViewSplitHorizontalIcon": 58696,
	"./ViewSplitVerticalIcon": 404990,
	"./ViewStreamIcon": 119118,
	"./ViewWeekIcon": 525451,
	"./VimeoIcon": 191693,
	"./VinylIcon": 413597,
	"./ViolinIcon": 117671,
	"./VirtualPrivateNetworkIcon": 229933,
	"./VirtualRealityIcon": 353458,
	"./VisibilityIcon": 200805,
	"./VisibilityOffIcon": 938247,
	"./VisibilityOffOutlineIcon": 267241,
	"./VisibilityOutlineIcon": 35730,
	"./VisualStudioCodeIcon": 195039,
	"./VisualStudioIcon": 668374,
	"./VitalsIcon": 985632,
	"./VkBoxIcon": 910416,
	"./VkCircleIcon": 377142,
	"./VkIcon": 815217,
	"./VkontakteBoxIcon": 798762,
	"./VkontakteCircleIcon": 488355,
	"./VkontakteIcon": 421960,
	"./VlcIcon": 106707,
	"./VoiceChatIcon": 972696,
	"./VoiceIcon": 31633,
	"./VoiceOffIcon": 293015,
	"./VoicemailIcon": 835053,
	"./VolleyballIcon": 396897,
	"./VolumeDecreaseIcon": 883012,
	"./VolumeHighIcon": 533299,
	"./VolumeIncreaseIcon": 514857,
	"./VolumeLowIcon": 677492,
	"./VolumeMediumIcon": 654121,
	"./VolumeMinusIcon": 542424,
	"./VolumeMuteIcon": 937975,
	"./VolumeOffIcon": 793394,
	"./VolumePlusIcon": 972174,
	"./VolumeVariantOffIcon": 167118,
	"./VoteIcon": 520018,
	"./VoteOutlineIcon": 541632,
	"./VoteRecountIcon": 534298,
	"./VoteRecountOutlineIcon": 259726,
	"./VoucherIcon": 691977,
	"./VoyagerIcon": 292704,
	"./VpnIcon": 544279,
	"./VpnKeyIcon": 156518,
	"./VrIcon": 986401,
	"./VsCodeIcon": 383021,
	"./VuejsIcon": 179630,
	"./VuetifyIcon": 923436,
	"./WalkIcon": 888262,
	"./WalkerIcon": 151279,
	"./WalkingIcon": 194102,
	"./WallIcon": 105663,
	"./WallSconceFlatIcon": 731308,
	"./WallSconceIcon": 494620,
	"./WallSconceVariantIcon": 927175,
	"./WalletAddIcon": 363402,
	"./WalletAddOutlineIcon": 434790,
	"./WalletGiftcardIcon": 948079,
	"./WalletIcon": 680630,
	"./WalletMembershipIcon": 526476,
	"./WalletOutlineIcon": 522243,
	"./WalletPlusIcon": 604157,
	"./WalletPlusOutlineIcon": 637040,
	"./WalletTravelIcon": 330053,
	"./WallpaperIcon": 843102,
	"./WanIcon": 251201,
	"./WandIcon": 696842,
	"./WardrobeIcon": 495022,
	"./WardrobeOutlineIcon": 392694,
	"./WarehouseIcon": 275388,
	"./WarningBoxIcon": 970108,
	"./WarningBoxOutlineIcon": 111584,
	"./WarningCircleIcon": 136334,
	"./WarningCircleOutlineIcon": 974360,
	"./WarningDecagramIcon": 464818,
	"./WarningDecagramOutlineIcon": 119379,
	"./WarningIcon": 32529,
	"./WarningLightsIcon": 314181,
	"./WarningOctagonIcon": 790955,
	"./WarningOctagonOutlineIcon": 21559,
	"./WarningOctagramIcon": 844716,
	"./WarningOctagramOutlineIcon": 373099,
	"./WarningOutlineIcon": 657907,
	"./WasherFluidIcon": 221808,
	"./WashingMachineIcon": 426541,
	"./WatchExportIcon": 762131,
	"./WatchExportVariantIcon": 973854,
	"./WatchIcon": 851394,
	"./WatchImportIcon": 325436,
	"./WatchImportVariantIcon": 50527,
	"./WatchLaterIcon": 232564,
	"./WatchVariantIcon": 421739,
	"./WatchVibrateIcon": 13292,
	"./WatchVibrateOffIcon": 912902,
	"./WaterBoilerIcon": 707936,
	"./WaterFilterIcon": 309339,
	"./WaterHeaterIcon": 779046,
	"./WaterIcon": 472373,
	"./WaterOffIcon": 826175,
	"./WaterOutlineIcon": 831311,
	"./WaterPercentIcon": 26967,
	"./WaterPumpIcon": 577890,
	"./WaterPumpOffIcon": 155409,
	"./WatermarkIcon": 465886,
	"./WaveIcon": 44184,
	"./WavesIcon": 563831,
	"./WazeIcon": 365899,
	"./WbAutoIcon": 775681,
	"./WbCloudyIcon": 29487,
	"./WbIncandescentIcon": 48739,
	"./WbIridescentIcon": 678896,
	"./WbSunnyIcon": 927839,
	"./WcIcon": 109091,
	"./WeatherCloudyAlertIcon": 636912,
	"./WeatherCloudyArrowRightIcon": 218700,
	"./WeatherCloudyIcon": 795846,
	"./WeatherFlashIcon": 2171,
	"./WeatherFogIcon": 439425,
	"./WeatherHailIcon": 730685,
	"./WeatherHazyIcon": 19724,
	"./WeatherHeavyRainIcon": 144652,
	"./WeatherHurricaneIcon": 549299,
	"./WeatherLightningIcon": 16720,
	"./WeatherLightningRainyIcon": 113569,
	"./WeatherNightIcon": 542133,
	"./WeatherNightPartlyCloudyIcon": 186101,
	"./WeatherPartlyCloudyIcon": 302824,
	"./WeatherPartlyLightningIcon": 779235,
	"./WeatherPartlyRainyIcon": 53727,
	"./WeatherPartlySnowyIcon": 511383,
	"./WeatherPartlySnowyRainyIcon": 208899,
	"./WeatherPouringIcon": 786988,
	"./WeatherRainyIcon": 215461,
	"./WeatherSnowyHeavyIcon": 880857,
	"./WeatherSnowyIcon": 547813,
	"./WeatherSnowyRainyIcon": 786288,
	"./WeatherStormIcon": 474556,
	"./WeatherSunnyAlertIcon": 141006,
	"./WeatherSunnyIcon": 919682,
	"./WeatherSunsetDownIcon": 152210,
	"./WeatherSunsetIcon": 814746,
	"./WeatherSunsetUpIcon": 471926,
	"./WeatherThunderIcon": 958878,
	"./WeatherThunderRainyIcon": 510636,
	"./WeatherTornadoIcon": 497954,
	"./WeatherWindyIcon": 209009,
	"./WeatherWindyVariantIcon": 386196,
	"./WebAssetIcon": 437917,
	"./WebBoxIcon": 440703,
	"./WebCameraIcon": 303385,
	"./WebIcon": 489325,
	"./WebcamIcon": 445470,
	"./WebhookIcon": 651761,
	"./WebpackIcon": 327159,
	"./WechatIcon": 463751,
	"./WeightGramIcon": 91577,
	"./WeightIcon": 367251,
	"./WeightKgIcon": 357773,
	"./WeightKilogramIcon": 152111,
	"./WeightLbIcon": 942846,
	"./WeightPoundIcon": 33479,
	"./WeightsIcon": 186260,
	"./WhatsappIcon": 137581,
	"./WhatshotIcon": 417124,
	"./WheatIcon": 461580,
	"./WheatOffIcon": 506917,
	"./WheelchairAccessibilityIcon": 497865,
	"./WhereToVoteIcon": 457723,
	"./WhistleIcon": 800328,
	"./WhiteBalanceAutoIcon": 879196,
	"./WhiteBalanceIncandescentIcon": 207482,
	"./WhiteBalanceIridescentIcon": 177701,
	"./WhiteBalanceSunnyIcon": 122609,
	"./WhiteboardIcon": 548571,
	"./WideAreaNetworkIcon": 527504,
	"./WidgetsIcon": 169395,
	"./WifiFavouriteIcon": 215889,
	"./WifiIcon": 162616,
	"./WifiOffIcon": 573614,
	"./WifiStarIcon": 454573,
	"./WifiStrength0AlertIcon": 906795,
	"./WifiStrength0Icon": 527440,
	"./WifiStrength0LockIcon": 964801,
	"./WifiStrength0WarningIcon": 238554,
	"./WifiStrength1AlertIcon": 164774,
	"./WifiStrength1Icon": 433844,
	"./WifiStrength1LockIcon": 295859,
	"./WifiStrength1WarningIcon": 758902,
	"./WifiStrength2AlertIcon": 937900,
	"./WifiStrength2Icon": 678690,
	"./WifiStrength2LockIcon": 452880,
	"./WifiStrength2WarningIcon": 942540,
	"./WifiStrength3AlertIcon": 340807,
	"./WifiStrength3Icon": 475396,
	"./WifiStrength3LockIcon": 218661,
	"./WifiStrength3WarningIcon": 433656,
	"./WifiStrength4AlertIcon": 765363,
	"./WifiStrength4Icon": 488853,
	"./WifiStrength4LockIcon": 521888,
	"./WifiStrength4WarningIcon": 920099,
	"./WifiStrengthAlertOutlineIcon": 552774,
	"./WifiStrengthLockOutlineIcon": 352425,
	"./WifiStrengthOffIcon": 975366,
	"./WifiStrengthOffOutlineIcon": 369660,
	"./WifiStrengthOutlineIcon": 642654,
	"./WifiStrengthWarningOutlineIcon": 204740,
	"./WiiIcon": 191152,
	"./WiiuIcon": 566432,
	"./WikipediaIcon": 774433,
	"./WindTurbineIcon": 307939,
	"./WindowCloseIcon": 997072,
	"./WindowClosedIcon": 428794,
	"./WindowMaximizeIcon": 558485,
	"./WindowMinimizeIcon": 740575,
	"./WindowOpenIcon": 11209,
	"./WindowRestoreIcon": 372405,
	"./WindowsClassicIcon": 414586,
	"./WindowsIcon": 681464,
	"./WiperFluidIcon": 330487,
	"./WiperIcon": 231702,
	"./WiperWashIcon": 636277,
	"./WishIcon": 318262,
	"./WomanChildIcon": 75570,
	"./WomanIcon": 764716,
	"./WomanWomanIcon": 470380,
	"./WomenIcon": 279431,
	"./WonIcon": 850869,
	"./WordpressIcon": 701139,
	"./WorkIcon": 304123,
	"./WorkOutlineIcon": 829599,
	"./WorkerIcon": 754690,
	"./WorkflowIcon": 970478,
	"./WrapDisabledIcon": 811701,
	"./WrapIcon": 898036,
	"./WrenchIcon": 938572,
	"./WrenchOutlineIcon": 127241,
	"./WrestlingIcon": 404510,
	"./WunderlistIcon": 42614,
	"./XamarinIcon": 448808,
	"./XamarinOutlineIcon": 510557,
	"./XamlIcon": 100920,
	"./XboxControllerBatteryAlertIcon": 809823,
	"./XboxControllerBatteryChargingIcon": 197075,
	"./XboxControllerBatteryEmptyIcon": 315177,
	"./XboxControllerBatteryFullIcon": 755728,
	"./XboxControllerBatteryLowIcon": 398524,
	"./XboxControllerBatteryMediumIcon": 2225,
	"./XboxControllerBatteryUnknownIcon": 716184,
	"./XboxControllerBatteryWarningIcon": 668835,
	"./XboxControllerIcon": 9749,
	"./XboxControllerMenuIcon": 658016,
	"./XboxControllerOffIcon": 503902,
	"./XboxControllerViewIcon": 302072,
	"./XboxIcon": 89910,
	"./XboxLiveIcon": 469138,
	"./XdaIcon": 832690,
	"./XiIcon": 822311,
	"./XingBoxIcon": 566298,
	"./XingCircleIcon": 273395,
	"./XingIcon": 845485,
	"./XmlIcon": 702753,
	"./XmppIcon": 995805,
	"./YahooIcon": 441903,
	"./YammerIcon": 991723,
	"./YeastIcon": 732973,
	"./YelpIcon": 86435,
	"./YenIcon": 994365,
	"./YinYangIcon": 633490,
	"./YoutubeCreatorStudioIcon": 703489,
	"./YoutubeGamingIcon": 664525,
	"./YoutubeIcon": 229584,
	"./YoutubePlayIcon": 61917,
	"./YoutubeSportsIcon": 223793,
	"./YoutubeSubscriptionIcon": 879347,
	"./YoutubeTvIcon": 535271,
	"./YuanIcon": 273104,
	"./ZWaveIcon": 820674,
	"./ZeldaIcon": 545491,
	"./ZendIcon": 307619,
	"./ZigbeeIcon": 465048,
	"./ZipBoxIcon": 371880,
	"./ZipDiskIcon": 359384,
	"./ZodiacAquariusIcon": 334437,
	"./ZodiacAriesIcon": 679917,
	"./ZodiacCancerIcon": 487081,
	"./ZodiacCapricornIcon": 110126,
	"./ZodiacGeminiIcon": 850912,
	"./ZodiacLeoIcon": 124551,
	"./ZodiacLibraIcon": 721253,
	"./ZodiacPiscesIcon": 244782,
	"./ZodiacSagittariusIcon": 950688,
	"./ZodiacScorpioIcon": 449602,
	"./ZodiacTaurusIcon": 517089,
	"./ZodiacVirgoIcon": 262343,
	"./ZoomInCursorIcon": 925078,
	"./ZoomInIcon": 306818,
	"./ZoomInOutlineIcon": 560251,
	"./ZoomOutCursorIcon": 543239,
	"./ZoomOutIcon": 693429,
	"./ZoomOutOutlineIcon": 896603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643453;